<template>
  <div
    :style="getHeight()"
    :class="
      ShowPlayerHeader
        ? 'right-pannel-wrapper'
        : 'right-pannel-wrapper without-header'
    "
    @click="rightPanelOnClick"
  >
    <!---Speakers tab start------>
    <div class="right-desc-pannel d-none" id="tab_speaker">
      <div class="speakers-tab">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3 v-if="sessionTypeId == 4">{{ $t("rightpanel.guests") }}</h3>
              <h3 v-else>{{ $t("rightpanel.speakers") }}</h3>
            </div>
            <div
              v-show="userType == 1 || isCurrentUserCoHost"
              class="access-wrap"
              data-toggle="tooltip"
              data-placement="left"
              v-bind:data-original-title="
                broadcastSettings.SpeakerInfoEnabled
                  ? 'Make Speakers invisible for Attendees'
                  : 'Make Speakers visible for Attendees'
              "
            >
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="broadcastSettings.SpeakerInfoEnabled"
                  @click="enableSpeakerInfo"
                />
                <span class="slider round"></span>
              </label>
              <p v-if="broadcastSettings.SpeakerInfoEnabled">
                {{ $t("rightpanel.disable") }}
              </p>
              <p v-if="!broadcastSettings.SpeakerInfoEnabled">
                {{ $t("rightpanel.enable") }}
              </p>
            </div>
          </div>
          <div id="speaker-area-wrap" class="qna-middle-part scroll-area">
            <div class="tab-content">
              <div class="tab-pane fade show active">
                <div class="featured-question">
                  <div
                    v-for="item in currentSpeakers"
                    :id="'rp_speaker_' + item.AttendeeId"
                    :key="item.AttendeeId"
                    :class="
                      item.IsActive
                        ? 'single-feature-question'
                        : 'single-feature-question d-none'
                    "
                  >
                    <div class="featured-inner">
                      <div class="attendee-image">
                        <!--<img
                          v-if="item.ProfilePictureURL == ''"
                          src="../../../assets/Images/common-avatar.svg"
                        />
                        <img v-else v-bind:src="item.ProfilePictureURL" />-->

                        <img
                          v-if="item.ProfilePictureURL != ''"
                          v-bind:src="item.ProfilePictureURL"
                          @error="item.ProfilePictureURL = ''"
                        />
                        <span
                          v-else-if="item.NameInitial != ''"
                          class="chat-user-initial"
                          >{{ item.NameInitial }}</span
                        >
                        <img
                          v-else
                          src="../../../assets/Images/common-avatar.svg"
                        />
                      </div>
                      <div class="question-description ml-3 pl-0">
                        <div class="attendee-description">
                          <div class="attendee-name-desc">
                            <h4 class="s-name">
                              {{ item.Name }}
                              <span v-if="item.AttendeeId == hostId"
                                >[HOST]</span
                              >
                              <span v-else-if="item.AttendeeId == coHostId"
                                >[CO-HOST]</span
                              >
                            </h4>
                            <span
                              v-if="
                                item.Company != '' && item.Designation != ''
                              "
                              class="designation"
                              >{{ item.Designation }}, {{ item.Company }}</span
                            >
                            <span
                              v-else-if="item.Company != ''"
                              class="designation"
                              >{{ item.Company }}</span
                            >
                            <span
                              v-else-if="item.Designation != ''"
                              class="designation"
                              >{{ item.Designation }}</span
                            >
                            <div class="speaker-description text-justify">
                              <div
                                v-html="item.Profile"
                                :id="'speaker_' + item.AttendeeId"
                              ></div>
                              <a
                                :id="'more_' + item.AttendeeId"
                                v-if="item.Profile && item.Profile.length > 100"
                                v-on:click="
                                  toggleSpeakerProfile(item.AttendeeId)
                                "
                                >{{ $t("rightpanel.more") }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---Speakers tab end------>
    <!---Attendees tab start------>
    <div class="right-desc-pannel d-none" id="tab_attendee">
      <div class="attendees-tab">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3>{{ $t("rightpanel.attendees") }}</h3>
            </div>
            <div
              class="grid-listing-button-wrap"
              @click="attendeeGridView = !attendeeGridView"
            >
              <img
                v-if="attendeeGridView"
                src="../../../assets/Images/grid-view.svg"
                alt="grid view"
              />
              <img
                v-else
                src="../../../assets/Images/list.svg"
                alt="list view"
              />
            </div>
            <div
              v-show="
                isAttendeeTabVisible && (userType == 1 || isCurrentUserCoHost)
              "
              class="access-wrap"
              data-toggle="tooltip"
              data-placement="left"
              v-bind:data-original-title="
                broadcastSettings.AttendeeEnabled
                  ? 'Hide from Attendees'
                  : 'Make visible to Attendees'
              "
            >
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="broadcastSettings.AttendeeEnabled"
                  @click="enableAttendee"
                />
                <span class="slider round"></span>
              </label>
              <p v-if="broadcastSettings.AttendeeEnabled">
                {{ $t("rightpanel.disable") }}
              </p>
              <p v-if="!broadcastSettings.AttendeeEnabled">
                {{ $t("rightpanel.enable") }}
              </p>
            </div>
          </div>
          <div class="search-section-wrap">
            <input
              type="text"
              placeholder="Search By Name"
              v-model="attendeeSearchTxt"
            />
            <img src="../../../assets/Images/icons/search-lite.svg" alt="" />
          </div>
          <div id="attendee-area-wrap" class="qna-middle-part scroll-area">
            <!-- <ul class="nav nav-tabs" id="myTab" role="tablist"> -->
            <!-- <li class="nav-item"> -->
            <!-- <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Plenary</a> -->
            <!-- </li> -->
            <!-- <li class="nav-item"> -->
            <!-- <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Breakout</a> -->
            <!-- </li> -->
            <!-- </ul> -->
            <!--<perfect-scrollbar>-->
            <div class="tab-content">
              <div
                class="tab-pane show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div
                  v-if="currentAttendees.length > 0"
                  class="featured-question attendee-wrapper"
                  :class="{ 'grid-view-wrapper': attendeeGridView }"
                >
                  <!-- v-show="!item.HideInList" -->
                  <div
                    v-for="item in currentAttendees"
                    :id="item.AttendeeId"
                    :key="item.AttendeeId"
                    class="single-feature-question single-attendee-wrap"
                  >
                    <!-- v-if="!item.HideInList" -->
                    <div class="featured-inner">
                      <div class="attendee-image">
                        <!--<img
                          v-if="item.ProfilePictureURL == ''"
                          src="../../../assets/Images/common-avatar.svg"
                        />-->
                        <!--<img v-else v-bind:src="item.ProfilePictureURL" />-->

                        <img
                          v-if="item.ProfilePictureURL != ''"
                          v-bind:src="item.ProfilePictureURL"
                        />
                        <span
                          v-else-if="item.NameInitial != ''"
                          class="chat-user-initial"
                          >{{ item.NameInitial }}</span
                        >
                        <img
                          v-else
                          src="../../../assets/Images/common-avatar.svg"
                        />
                      </div>
                      <div class="question-description ml-3 pl-0">
                        <div class="attendee-description">
                          <div class="attendee-name-desc">
                            <div
                              class="
                                d-flex
                                justify-content-between
                                align-item-center
                              "
                            >
                              <h4 class="s-name">{{ item.Name }}</h4>
                              <v-menu
                                v-if="
                                  (userType == 1 || isCurrentUserCoHost) &&
                                  enableInviteSessionAttendee &&
                                  hostCanInviteAttendeeToStage
                                "
                                left
                                offset-y
                              >
                                <!-- ||
                                  (userType == 4 &&
                                  allowRaiseHand &&
                                  !item.RHRequestStatus) -->
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="mr-1"
                                    icon
                                    height="20px"
                                    width="10px"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon color="#fff"
                                      >mdi-dots-vertical</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <v-list class="vertical-dot-menu" color="#333">
                                  <!-- ######### Invite Attendee To Stage ######### -->
                                  <v-list-item color="#fff">
                                    <v-btn
                                      v-if="
                                        !item.InviteRequestStatus ||
                                        (item.InviteRequestStatus &&
                                          !item.InviteAcceptStatus)
                                      "
                                      plain
                                      dark
                                      color="#fff"
                                      class="p-0"
                                      depressed
                                      :disabled="
                                        item.RHRequestStatus ||
                                        !(
                                          sessionHostSpeakerCount +
                                            sessionInvitedAndRHInStageCount <
                                          maxSpeakerLimit
                                        )
                                      "
                                      :loading="
                                        item.InviteRequestStatus &&
                                        !item.InviteAcceptStatus
                                      "
                                      @click="
                                        inviteAttendeeToStage(
                                          1,
                                          item.AttendeeId,
                                          true
                                        )
                                      "
                                    >
                                      <v-icon color="#fff" class="mr-3"
                                        >mdi-account-voice</v-icon
                                      >
                                      Invite to Stage
                                      <!-- <template v-slot:loader>
                                        <v-progress-circular
                                          indeterminate
                                          size="23"
                                          :width="2"
                                        />
                                        <span class="ml-2 text-initial"
                                          >Awaiting...</span
                                        >
                                      </template> -->
                                    </v-btn>
                                    <v-btn
                                      v-if="
                                        item.InviteRequestStatus &&
                                        item.InviteAcceptStatus
                                      "
                                      plain
                                      color="#fff"
                                      class="p-0"
                                      :loading="item.Inviting"
                                      @click="
                                        inviteAttendeeToStage(
                                          1,
                                          item.AttendeeId,
                                          false
                                        )
                                      "
                                    >
                                      <v-icon color="#fff" class="mr-3"
                                        >mdi-account-voice-off</v-icon
                                      >
                                      Remove from Stage
                                      <template v-slot:loader>
                                        <span class="ml-2 text-initial"
                                          >Removing...</span
                                        >
                                      </template>
                                    </v-btn>
                                  </v-list-item>
                                  <!-- ######### Allow Raise Hand ######### -->
                                  <!-- <v-list-item color="#fff">
                                    <v-btn
                                      v-if="
                                        !item.RHRequestStatus ||
                                        (item.RHRequestStatus &&
                                          !item.RHAcceptStatus)
                                      "
                                      plain
                                      color="#fff"
                                      class="p-0"
                                      :loading="
                                        item.RHRequestStatus &&
                                        !item.RHAcceptStatus
                                      "
                                      @click="
                                        inviteAttendeeToStage(
                                          1,
                                          item.AttendeeId,
                                          true
                                        )
                                      "
                                    >
                                      <v-icon color="#fff" class="mr-3"
                                        >mdi-account-voice</v-icon
                                      >
                                      Raise Hand
                                    </v-btn>
                                    <v-btn
                                      v-if="
                                        item.InviteRequestStatus &&
                                        item.InviteAcceptStatus
                                      "
                                      plain
                                      color="#fff"
                                      class="p-0"
                                      :loading="item.Inviting"
                                      @click="
                                        inviteAttendeeToStage(
                                          1,
                                          item.AttendeeId,
                                          false
                                        )
                                      "
                                    >
                                      <v-icon color="#fff" class="mr-3"
                                        >mdi-account-voice-off</v-icon
                                      >
                                      Hand Down
                                      <template v-slot:loader>
                                        <span class="ml-2 text-initial"
                                          >Procession...</span
                                        >
                                      </template>
                                    </v-btn>
                                  </v-list-item> -->
                                </v-list>
                              </v-menu>
                            </div>
                            <!--<span class="designation">Senior Hr Executive, Web Spiders</span>-->
                            <span
                              v-if="
                                item.Company != '' && item.Designation != ''
                              "
                              class="designation"
                              >{{ item.Designation }}, {{ item.Company }}</span
                            >
                            <span
                              v-else-if="item.Company != ''"
                              class="designation"
                              >{{ item.Company }}</span
                            >
                            <span
                              v-else-if="item.Designation != ''"
                              class="designation"
                              >{{ item.Designation }}</span
                            >
                          </div>
                          <!-- <div>
                            <span
                              >{{ item.RHRequestStatus }}-{{
                                item.RHAcceptStatus
                              }}</span
                            >
                          </div> -->
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        (userType == 1 || isCurrentUserCoHost) &&
                        hostCanInviteAttendeeToStage &&
                        item.InviteRequestStatus &&
                        !item.InviteAcceptStatus
                      "
                      class="
                        d-flex
                        justify-content-between
                        align-item-center
                        pr-2
                      "
                    >
                      <v-btn
                        plain
                        width="100px"
                        color="#fff"
                        class="p-0"
                        :loading="
                          item.InviteRequestStatus && !item.InviteAcceptStatus
                        "
                      >
                        <template v-slot:loader>
                          <v-progress-circular
                            indeterminate
                            size="43"
                            :width="5"
                          />
                          <span class="ml-2 text-initial">Awaiting...</span>
                        </template>
                      </v-btn>
                      <v-btn
                        small
                        icon
                        class="p-0"
                        @click="
                          inviteAttendeeToStage(1, item.AttendeeId, false)
                        "
                      >
                        <v-icon color="#fff">mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="!attendeeSearchTxt"
                  class="featured-question attendee-wrapper empty"
                >
                  <span class="center-center"
                    >Attendees will show up here as they join</span
                  >
                </div>
                <div v-else class="featured-question attendee-wrapper empty">
                  <span class="center-center"
                    >No matching results to display</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---Attendees tab end------>
    <!---Q&A tab start------>
    <div class="right-desc-pannel d-none" id="tab_qa">
      <div class="qna-section">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3>QnA</h3>
            </div>
            <div
              v-show="userType == 1 || isCurrentUserCoHost"
              class="access-wrap"
              data-toggle="tooltip"
              data-placement="left"
              v-bind:data-original-title="
                broadcastSettings.QnAEnabled
                  ? 'Make QnA invisible for Attendees'
                  : 'Make QnA visible for Attendees'
              "
            >
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="broadcastSettings.QnAEnabled"
                  @click="enableQnA"
                />
                <span class="slider round"></span>
              </label>
              <p v-if="broadcastSettings.QnAEnabled">
                {{ $t("rightpanel.disable") }}
              </p>
              <p v-if="!broadcastSettings.QnAEnabled">
                {{ $t("rightpanel.enable") }}
              </p>
            </div>
          </div>
          <div
            id="qna-area-wrap"
            class="qna-middle-part qna-area-wrap scroll-area"
          >
            <!--v-show="userType != 1"-->
            <ul class="nav nav-tabs pl-0">
              <li class="nav-item" @click="changeQnASortingTab(0)">
                <span
                  :class="
                    qnaActiveTabIndex == 0 ? 'nav-link active' : 'nav-link'
                  "
                  >{{ userType == 1 ? "Newest" : "Newest" }}</span
                >
              </li>
              <li class="nav-item" @click="changeQnASortingTab(1)">
                <span
                  :class="
                    qnaActiveTabIndex == 1 ? 'nav-link active' : 'nav-link'
                  "
                  >{{ userType == 1 ? "Popular" : "Popular" }}</span
                >
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade show active">
                <div class="featured-question">
                  <div
                    v-for="item in qnaList"
                    :id="item.QnAId"
                    :key="item.QnAId"
                    class="single-feature-question"
                  >
                    <div class="qna-inner-wrap">
                      <div class="attendee-image">
                        <!--<img
                          v-if="item.ProfilePictureURL == ''"
                          src="../../../assets/Images/common-avatar.svg"
                        />
                        <img v-else v-bind:src="item.ProfilePictureURL" />-->

                        <img
                          v-if="item.ProfilePictureURL != ''"
                          v-bind:src="item.ProfilePictureURL"
                          @error="item.ProfilePictureURL = ''"
                        />
                        <span
                          v-else-if="item.NameInitial != ''"
                          class="chat-user-initial"
                          >{{ item.NameInitial }}</span
                        >
                        <img
                          v-else
                          src="../../../assets/Images/common-avatar.svg"
                        />
                      </div>
                      <div class="question-description ml-2">
                        <div class="attendee-description">
                          <div class="attendee-name-desc">
                            <h4>{{ item.Name }}</h4>
                            <p>{{ item.CreatedDateStr }}</p>
                            <!--<h4>Kenneth Aparicio</h4>
                            <p>10:32</p>-->
                          </div>

                          <div
                            :class="
                              item.myQnA
                                ? 'thumb-like-area'
                                : 'thumb-like-area cursor-pointer'
                            "
                            @click="
                              toggleLikeQnA(
                                item.QnAId,
                                item.myQnA,
                                item.IsLiked
                              )
                            "
                          >
                            <p>
                              <a>
                                <img
                                  v-if="item.TotalLikes > 0"
                                  src="../../../assets/Images/icons/thumb.svg"
                                />
                                <img
                                  v-else
                                  src="../../../assets/Images/icons/thumb-blank.svg"
                                />
                                <span v-if="item.TotalLikes > 0">{{
                                  item.TotalLikes
                                }}</span>
                                <span v-else></span>
                              </a>
                            </p>
                          </div>
                        </div>
                        <!--<p class="attendee-question" v-html="item.Question"></p>-->
                        <p class="attendee-question">{{ item.Question }}</p>
                        <!--<p class="attendee-question">
                          Lorem ipsum dolor sit amet consectetur adipiscing elit.
                        </p>-->
                      </div>
                    </div>
                    <div v-if="userType == 1" class="qna-bottom-wrap">
                      <p class="attendee-chk">Show to attendees</p>
                      <div
                        :class="
                          userType == 1
                            ? 'thumb-like-area cursor-pointer'
                            : 'thumb-like-area'
                        "
                        @click="togglePublishQnA(item.QnAId, item.IsPublished)"
                      >
                        <p>
                          <a href="javscript: void(0);">
                            <img
                              v-if="item.IsPublished"
                              src="../../../assets/Images/icons/published.svg"
                            />
                            <img
                              v-else
                              src="../../../assets/Images/icons/unpublished.svg"
                            />
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <!--<div class="single-feature-question">
                    <div class="attendee-image">
                      <img
                        src="../../../assets/Images/imgpsh_fullsize_anim.jpg"
                      />
                    </div>
                    <div class="question-description">
                      <div class="attendee-description">
                        <div class="attendee-name-desc">
                          <h4>Kenneth Aparicio</h4>
                          <p>10:32</p>
                        </div>
                        <div class="thumb-like-area">
                          <p>
                            <a href>
                              <img
                                src="../../../assets/Images/icons/thumb.svg"
                              />
                              <span>100</span>
                            </a>
                          </p>
                        </div>
                      </div>
                      <p class="attendee-question">
                        Lorem ipsum dolor sit amet consectetur adipiscing elit.
                      </p>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="scroll-qna-to-me"></div>

          <div id="ask-question-wrap" class="ask-question-wrap d-none">
            <div class="back-qna" @click="goToQnAList">
              <img src="../../../assets/Images/left-arrow-back-qna.svg" />
            </div>
            <div class="section-description">
              <img src="../../../assets/Images/qna-graphics.svg" />
              <h4>{{ $t("rightpanel.askMod") }}</h4>
              <p>
                {{ $t("rightpanel.QuesWontVisible") }}
              </p>
            </div>
            <div
              v-if="PostQnAAnonymous"
              class="question-input-by"
              style="min-height: 41px"
            >
              <p>{{ $t("rightpanel.submittingasanonymous") }}</p>
            </div>
            <div v-else class="question-input-by">
              <p>{{ $t("rightpanel.submittingas") }}</p>
              <span>{{ name }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="qna-bottom-part"> -->
        <!-- <a href="">Ask a question</a> -->
        <!-- </div> -->
        <!--<div v-if="userType == 4" class="message-input-area qna-input-area">-->
        <div
          v-show="broadcastSettings.QnAEnabled"
          id="go-ask-question"
          class="message-input-area qna-input-area"
        >
          <span class="btn" @click="goToQnA">{{
            $t("rightpanel.askQns")
          }}</span>
          <!--<input type="text" name="Type Something" id="" value="" placeholder="Type Something" />
          <input type="submit" id="" value="" onclick="" class="" />-->
        </div>
        <div
          v-show="broadcastSettings.QnAEnabled"
          id="qna-input-area"
          class="question-input-area d-none"
        >
          <div class="input-question-sec submit-area">
            <input
              type="text"
              id="txtQnA"
              v-on:keyup.enter="createQnA"
              :placeholder="$t('rightpanel.askQns')"
              autocomplete="off"
            />

            <input type="button" @click="createQnA" class="question-sub-btn" />
          </div>
          <div v-show="AllowPostingQuestionsAnonymously">
            <label class="check-wrap">
              <input
                type="checkbox"
                id="chkPostAnonymous"
                v-model="PostQnAAnonymous"
              />
              <span class="checkmark"></span
              >{{ $t("rightpanel.postasanonymous") }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <!---Q&A tab end------>
    <!---Message tab start------>
    <div class="right-desc-pannel d-none" id="tab_message">
      <div class="qna-section">
        <div
          class="message-top-area"
          :class="{'speakers':userType < 4  && !dialogSessionId }"
        >
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3>{{ $t("rightpanel.chat") }}</h3>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <div
                v-show="
                  (userType == 1 || isCurrentUserCoHost) &&
                  sessionTypeId != 6 &&
                  sessionTypeId != 7
                "
                class="access-wrap"
                data-toggle="tooltip"
                data-placement="left"
                v-bind:data-original-title="
                  broadcastSettings.ChatEnabled
                    ? 'Disable Chat for Attendees'
                    : 'Enable Chat for Attendees'
                "
              >
                <label class="switch">
                  <input
                    type="checkbox"
                    v-model="broadcastSettings.ChatEnabled"
                    @click="enableChat"
                  />
                  <span class="slider round"></span>
                </label>
                <p v-if="broadcastSettings.ChatEnabled">
                  {{ $t("rightpanel.disable") }}
                </p>
                <p v-if="!broadcastSettings.ChatEnabled">
                  {{ $t("rightpanel.enable") }}
                </p>
              </div>
              <div v-show="stageUrl == '/stageview'">
                <v-btn
                  depressed
                  color="#1e1f26"
                  class="stage-button px-0 ml-0"
                  min-width="0"
                  style="color: #fff; border: 0"
                  @click="toggleChatTab"
                >
                  <v-icon class="ml-1"> arrow_forward </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <!---->
          <div
            id="chat-area-wrap"
            class="qna-middle-part qna-area-wrap chat-part scroll-area"
          >
            <div class="tab-content">
              <div class="tab-pane fade show active">
                <div class="featured-question">
                  <div
                    v-for="item in chat.allChats"
                    :id="item.ChatId"
                    :key="item.ChatId"
                    v-bind:class="'single-feature-question ' + item.UaserClass"
                    v-show="!item.SendTo || userType < 4"
                  >
                    <div
                      v-if="!item.SendTo || userType < 4"
                      class="qna-inner-wrap"
                    >
                      <div class="attendee-image">
                        <!--<img
                          v-if="item.ProfilePictureURL == ''"
                          src="../../../assets/Images/common-avatar.svg"
                          onerror="
                            this.src =
                              'https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fcommon-avatar.svg?alt=media'
                          "
                        />-->
                        <img
                          v-if="item.ProfilePictureURL != ''"
                          v-bind:src="item.ProfilePictureURL"
                          @error="item.ProfilePictureURL = ''"
                        />
                        <span
                          v-else-if="item.NameInitial != ''"
                          class="chat-user-initial"
                          >{{ item.NameInitial }}</span
                        >
                        <img
                          v-else
                          src="../../../assets/Images/common-avatar.svg"
                        />
                      </div>
                      <div class="question-description ml-2">
                        <div class="attendee-description">
                          <div class="attendee-name-desc">
                            <h4>{{ item.Name }}</h4>
                            <p>
                              <span
                                v-if="
                                  item.SendTo &&
                                  userType < 4 &&
                                  item.CreatedBy == uid
                                "
                                class="private-message"
                              >
                                Sent to Speakers
                              </span>
                              {{ item.CreatedDateStr }}
                              <span
                                v-if="
                                  item.SendTo &&
                                  userType < 4 &&
                                  item.CreatedBy != uid
                                "
                                class="private-message"
                              >
                                Sent to Speakers
                              </span>
                            </p>
                          </div>
                        </div>
                        <p class="attendee-question" v-html="item.Message"></p>
                        <div class="msg-reactions">
                          <ul
                            class="
                              d-flex
                              justify-content-start
                              align-items-center
                              flex-wrap
                            "
                          >
                            <li
                              v-for="reaction in chat.allReactions"
                              v-show="
                                item[reaction.id] &&
                                item[reaction.id].length > 0
                              "
                              :key="reaction.id"
                              class="msg-single-reaction"
                            >
                              <v-icon
                                class="reaction-icon"
                                size="16"
                                :color="reaction.color"
                              >
                                {{ reaction.code }}
                              </v-icon>
                              <span
                                v-if="
                                  item[reaction.id] &&
                                  item[reaction.id].length > 1
                                "
                                class="text-subtitle-2"
                              >
                                {{ item[reaction.id].length }}
                              </span>
                              <div class="msg-reaction-users">
                                <div class="msg-single-users-reaction">
                                  <v-icon
                                    class="reaction-icon"
                                    size="20"
                                    :color="reaction.color"
                                  >
                                    {{ reaction.code }}
                                  </v-icon>
                                </div>
                                <div class="msg-reaction-users-list">
                                  <div
                                    v-for="user in item[reaction.id]"
                                    :key="user"
                                    class="msg-reaction-details"
                                  >
                                    <div v-if="allAttendees[user]">
                                      <img
                                        v-if="
                                          allAttendees[user]
                                            .ProfilePictureURL != ''
                                        "
                                        v-bind:src="
                                          allAttendees[user].ProfilePictureURL
                                        "
                                        @error="
                                          allAttendees[user].ProfilePictureURL =
                                            ''
                                        "
                                      />
                                      <span
                                        v-else-if="
                                          getInitials(
                                            allAttendees[user].Name
                                          ) != ''
                                        "
                                        class="msg-user-initial"
                                        >{{
                                          getInitials(allAttendees[user].Name)
                                        }}</span
                                      >
                                      <img
                                        v-else
                                        src="../../../assets/Images/common-avatar.svg"
                                      />
                                      <span>{{ allAttendees[user].Name }}</span>
                                    </div>
                                    <div v-else>
                                      {{ user }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <!--<li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-emoticon-cool
                              </v-icon>
                              <span>99</span>
                            </li>-->
                            <!--<li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>
                            <li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>
                            <li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>
                            <li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>
                            <li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>
                            <li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>
                            <li>
                              <v-icon
                                class="reaction-icon"
                                size="25"
                                color="#4080ff"
                              >
                                mdi-cards-heart
                              </v-icon>
                              <span>99</span>
                            </li>-->
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="!item.SendTo || userType < 4"
                      :class="'msg-reaction-options ' + item.UaserClass"
                    >
                      <span>
                        <v-icon size="15" color="#ccc">
                          mdi-emoticon-happy-outline
                        </v-icon>
                      </span>
                      <div
                        :id="'msg-reaction-list-' + item.ChatId"
                        class="msg-reaction-list"
                      >
                        <ul>
                          <!--<li>
                            <span class="reaction-icon">😊|&#9829;</span>
                          </li>-->
                          <li
                            v-for="reaction in chat.allReactions"
                            :key="reaction.id"
                          >
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              :color="reaction.color"
                              :title="reaction.title"
                              @click="
                                sendMessageReaction(item.ChatId, reaction.id)
                              "
                            >
                              {{ reaction.code }}
                            </v-icon>
                          </li>
                          <!--<li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#4080ff"
                              @click="sendMessageReaction(item.ChatId, 1)"
                            >
                              mdi-thumb-up
                            </v-icon>
                          </li>
                          <li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#f25268"
                              @click="sendMessageReaction(item.ChatId, 3)"
                            >
                              mdi-cards-heart
                            </v-icon>
                          </li>
                          <li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#ffd972"
                              @click="sendMessageReaction(item.ChatId, 4)"
                            >
                              mdi-emoticon-excited
                            </v-icon>
                          </li>
                          <li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#ffd972"
                              @click="sendMessageReaction(item.ChatId, 5)"
                            >
                              mdi-emoticon-cool
                            </v-icon>
                          </li>
                          <li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#ffd972"
                              @click="sendMessageReaction(item.ChatId, 6)"
                            >
                              mdi-emoticon-cry
                            </v-icon>
                          </li>
                          <li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#F45768"
                              @click="sendMessageReaction(item.ChatId, 7)"
                            >
                              mdi-emoticon-angry
                            </v-icon>
                          </li>
                          <li>
                            <v-icon
                              class="reaction-icon"
                              size="25"
                              color="#4080ff"
                              @click="sendMessageReaction(item.ChatId, 2)"
                            >
                              mdi-thumb-down
                            </v-icon>
                          </li>-->
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!callStarted"
                    class="featured-question attendee-wrapper empty"
                  >
                    <span class="center-center">
                      Please click on the Play Button to Join the Session & Chat
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="scroll-chat-to-me"></div>
          </div>
        </div>
        <div
          v-show="
            broadcastSettings.ChatEnabled && userType < 4 && sessionTypeId == 3 && !dialogSessionId
          "
          class="message-send-option"
        >
          <label>Send To: </label>
          <select id="selectSendTo" class="send-options">
            <option v-if="userType < 4" value="1">Host and Panelists</option>
            <option value="">Everyone</option>
          </select>
        </div>
        <div
          v-show="broadcastSettings.ChatEnabled || stageUrl == '/stageview'"
          class="message-input-area chat-input-area submit-area"
        >
          <div
            @click="toggleChatEmojiPanel()"
            @keyup.enter="toggleChatEmojiPanel()"
            class="btn-emoji"
          >
            <v-icon size="25" color="#696969">
              mdi-emoticon-happy-outline
            </v-icon>
            <div v-if="showChatEmojiPannel" class="emoji-pannel">
              <span class="emoji-close">X</span>
              <VEmojiPicker
                :hasSearch="false"
                :style="{ width: '100%' }"
                :showCategories="false"
                @select="chatEmojiSelected"
              />
            </div>
          </div>
          <input
            type="text"
            id="txtChat"
            :readonly="stageUrl == '/stageview' && !callStarted"
            :placeholder="$t('rightpanel.typeSomething')"
            v-on:keyup.enter="createChat"
            class="chat-input ml-1"
            autocomplete="off"
          />
          <input type="button" @click="createChat" class="chat-submit" />
        </div>
      </div>
    </div>
    <!---Message tab end------>
    <!---Raise-Hand tab start------>
    <div class="right-desc-pannel d-none" id="tab_raise_hand">
      <div class="qna-section">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3>{{ $t("rightpanel.raiseHand") }}</h3>
            </div>
            <div
              v-show="userType == 1 || isCurrentUserCoHost"
              class="access-wrap"
              data-toggle="tooltip"
              data-placement="left"
              v-bind:data-original-title="
                broadcastSettings.RaiseHandEnabled
                  ? 'Disable Raise Hand for Attendees'
                  : 'Enable Raise Hand for Attendees'
              "
            >
              <!-- <label class="switch" v-show="userType < 3">
                <input
                  type="checkbox"
                  v-model="broadcastSettings.RaiseHandEnabled"
                  @click="enableRaiseHand"
                />
                <span class="slider round"></span>
              </label>
              <p v-if="broadcastSettings.RaiseHandEnabled">
                {{ $t("rightpanel.disable") }}
              </p>
              <p v-if="!broadcastSettings.RaiseHandEnabled">
                {{ $t("rightpanel.enable") }}
              </p> -->
            </div>
          </div>
          <div id="rh-middle-part" class="qna-middle-part scroll-area">
            <div class="tab-content">
              <div
                v-if="currentRHAttendees.length > 0"
                class="tab-pane fade show active"
              >
                <div
                  v-for="item in currentRHAttendees"
                  :id="item.AttendeeId"
                  :key="item.AttendeeId"
                  class="single-permission"
                >
                  <div class="permission-grant-top">
                    <div class="permissionwant-image">
                      <img
                        v-if="item.ProfilePictureURL != ''"
                        v-bind:src="item.ProfilePictureURL"
                      />
                      <span
                        v-else-if="item.NameInitial != ''"
                        class="chat-user-initial"
                        >{{ item.NameInitial }}</span
                      >
                      <img
                        v-else
                        src="../../../assets/Images/common-avatar.svg"
                      />
                    </div>
                    <div class="permission-details">
                      <h4>{{ item.Name }}</h4>
                      <span
                        v-if="item.Company != '' && item.Designation != ''"
                        class="designation"
                        >{{ item.Designation }}, {{ item.Company }}</span
                      >
                      <span
                        v-else-if="item.Company != ''"
                        class="designation"
                        >{{ item.Company }}</span
                      >
                      <span
                        v-else-if="item.Designation != ''"
                        class="designation"
                        >{{ item.Designation }}</span
                      >
                    </div>
                  </div>
                  <div
                    v-show="userType == 1 || isCurrentUserCoHost"
                    class="permision-grant-sec mt-2"
                  >
                    <!-- <p>{{ $t("rightpanel.RequestMic") }}</p> -->
                    <div class="permission-grant-btn">
                      <v-btn
                        v-show="item.RHRequestStatus && !item.RHAcceptStatus"
                        color="#19a883"
                        class="access-btn"
                        :disabled="
                          !(
                            sessionHostSpeakerCount +
                              sessionInvitedAndRHInStageCount <
                            maxSpeakerLimit
                          )
                        "
                        @click="
                          inviteAttendeeToStage(2, item.AttendeeId, true, true)
                        "
                      >
                        {{ $t("rightpanel.accept") }}
                      </v-btn>
                      <v-btn
                        v-show="item.RHRequestStatus && !item.RHAcceptStatus"
                        outlined
                        color="#525252"
                        class="dismiss-btn"
                        @click="
                          inviteAttendeeToStage(2, item.AttendeeId, false, true)
                        "
                      >
                        {{ $t("rightpanel.dismiss") }}
                      </v-btn>
                      <v-btn
                        v-show="item.RHRequestStatus && item.RHAcceptStatus"
                        :loading="item.RHRemoving"
                        color="#525252"
                        class="dismiss-btn"
                        @click="
                          inviteAttendeeToStage(2, item.AttendeeId, false, true)
                        "
                      >
                        <v-icon color="#fff" class="mr-3"
                          >mdi-account-voice-off</v-icon
                        >
                        Remove from stage
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="featured-question attendee-wrapper empty">
                <span class="center-center"
                  >Attendees will show up here as they raise their hand</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---Raise-Hand tab end------>
    <!---Sessions List tab start------>
    <div class="right-desc-pannel d-none" id="tab_session">
      <div class="sessions-tab">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3>{{ $t("rightpanel.sessions") }}</h3>
            </div>
            <!--<div v-show="userType == 1 || isCurrentUserCoHost" class="access-wrap"
              data-toggle="tooltip"
              data-placement="left"
              v-bind:data-original-title="
                broadcastSettings.SessionListEnabled
                  ? 'Disable Session list view for Attendees'
                  : 'Enable Session list view for Attendees'
              ">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="broadcastSettings.SessionListEnabled"
                  @click="enableSessionList"
                />
                <span class="slider round"></span>
              </label>
              <p v-if="broadcastSettings.SessionListEnabled">
                {{ $t("rightpanel.disable") }}
              </p>
              <p v-if="!broadcastSettings.SessionListEnabled">
                {{ $t("rightpanel.enable") }}
              </p>
            </div>-->
          </div>
          <div
            v-show="
              agendaFilterOption == 2 &&
              selectedAgendaType >= 0 &&
              mySessionsLoaded &&
              mySessions.length > 0
            "
            class="pannel-top-area"
          >
            <ul id="myTab" class="nav nav-tabs" role="tablist">
              <li class="nav-item" @click.prevent="changeAgendaType(1)">
                <a
                  :class="
                    selectedAgendaType == 1 ? 'nav-link active' : 'nav-link'
                  "
                  data-toggle="tab"
                  href="javscript:void(0);"
                  role="tab"
                  aria-controls="Featured"
                  aria-selected="true"
                  >{{ $t("rightpanel.myAgenda") }}</a
                >
              </li>
              <li class="nav-item" @click.prevent="changeAgendaType(0)">
                <a
                  :class="
                    selectedAgendaType == 0 ? 'nav-link active' : 'nav-link'
                  "
                  data-toggle="tab"
                  href="javscript:void(0);"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                  >{{ $t("rightpanel.fullAgenda") }}</a
                >
              </li>
            </ul>
          </div>
          <div
            v-if="currentTabSessions.length > 0"
            id="right-session-list-wrapper"
            :class="
              agendaFilterOption == 2 &&
              selectedAgendaType >= 0 &&
              mySessionsLoaded &&
              mySessions.length > 0
                ? 'qna-area-wrap right-session-list-wrapper'
                : 'qna-area-wrap right-session-list-wrapper no-filter-tab'
            "
          >
            <div
              v-for="item in currentTabSessions"
              :id="'rp_session_' + item.SessionId"
              :key="'rp_session_' + item.SessionId"
              :class="'single-sesion-right ' + item.SelectedSessionClass"
              :sessionType="
                item.SessionId != sessionId &&
                item.SessionTypeDetails.TypeID < 5
                  ? item.SessionTypeDetails.TypeID
                  : 0
              "
            >
              <div class="top-right-session-wrap">
                <div :class="'right-session-type ' + item.LinkClass">
                  <span class="mr-2">
                    <svg
                      v-if="item.SessionTypeDetails.TypeID == OnDemandTypeID"
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                    >
                      <defs></defs>
                      <path
                        id="on-demand.svg"
                        class="cls-1"
                        d="M6956,1428a14,14,0,1,1,14-14A14,14,0,0,1,6956,1428Zm0-26.25a12.25,12.25,0,1,0,12.25,12.25A12.244,12.244,0,0,0,6956,1401.75Zm0,21a8.75,8.75,0,1,1,8.75-8.75A8.753,8.753,0,0,1,6956,1422.75Z"
                        transform="translate(-6942 -1400)"
                      />
                    </svg>
                    <svg
                      v-if="item.SessionTypeDetails.TypeID == LiveStreamTypeID"
                      xmlns="http://www.w3.org/2000/svg"
                      width="46"
                      height="20"
                      viewBox="0 0 46 20"
                    >
                      <defs></defs>
                      <path
                        id="live-stream.svg"
                        class="cls-1"
                        d="M7127,1424h-42a2.006,2.006,0,0,1-2-2v-16a2.006,2.006,0,0,1,2-2h42a2.006,2.006,0,0,1,2,2v16A2.006,2.006,0,0,1,7127,1424Zm0-18h-42v16h42v-16Zm-35,4a4,4,0,1,1-4,4A4,4,0,0,1,7092,1410Zm9.67,6.39h2.94v1.6H7100v-7.98h1.67v6.38Zm6.31,1.6h-1.66v-7.98h1.66v7.98Zm5.43-2.57,2.05-5.41h1.77l-3.08,7.98h-1.47l-3.09-7.98h1.77Zm10.52-3.8h-3.48v1.5h3.25v1.57h-3.25v1.7h3.56v1.6h-5.23v-7.98h5.15v1.61Z"
                        transform="translate(-7083 -1404)"
                      />
                    </svg>
                    <svg
                      v-if="item.SessionTypeDetails.TypeID == LivePanelTypeID"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="29"
                      viewBox="0 0 32 29"
                    >
                      <defs></defs>
                      <path
                        id="live-panel.svg"
                        class="cls-1"
                        d="M7039.22,1421.07c-0.76,0-1.9-.05-2.47-0.05a13.947,13.947,0,0,0-3.03-20.6l1.44-1.43A15.938,15.938,0,0,1,7039.22,1421.07Zm-4.57-3.99c-0.57,0-1.49-.03-2.4-0.03a7.871,7.871,0,0,0,1.75-4.97,7.976,7.976,0,0,0-4.68-7.26l1.49-1.49a9.984,9.984,0,0,1,5.19,8.75A9.873,9.873,0,0,1,7034.65,1417.08Zm-3.66-4.96a4.775,4.775,0,0,1-1.47,3.51,5,5,0,0,1-7.06,0,4.775,4.775,0,0,1-1.47-3.51,4.852,4.852,0,0,1,1.47-3.53,4.927,4.927,0,0,1,7.06,0A4.852,4.852,0,0,1,7030.99,1412.12Zm-2.84-2.16a3.01,3.01,0,0,0-5.15,2.15,2.827,2.827,0,0,0,.87,2.12,3.174,3.174,0,0,0,4.28,0,2.865,2.865,0,0,0,.87-2.12A2.982,2.982,0,0,0,7028.15,1409.96Zm-10.15,2.12a7.956,7.956,0,0,0,2.08,5.37c-0.67.37-1.29,0.52-1.86,0.9a9.968,9.968,0,0,1,2.97-15.02l1.49,1.49A7.976,7.976,0,0,0,7018,1412.08Zm-6,0a13.889,13.889,0,0,0,2.75,8.32,9.265,9.265,0,0,0-.47,2.55,15.945,15.945,0,0,1,2.56-23.96l1.44,1.43A13.978,13.978,0,0,0,7012,1412.08Zm6.01,9.32a12.071,12.071,0,0,1,4.02-1.8,17.553,17.553,0,0,1,3.73-.52c3.4,0,6.35.7,8.23,2.03a3.685,3.685,0,0,1,1.83,2.95l-0.01,3.93h-19.62l-0.01-3.77A3.5,3.5,0,0,1,7018.01,1421.4Zm0.25,4.53h15.48l0.08-2.04c0-1.79-5.37-2.82-7.72-2.82-2.64,0-7.93,1.66-7.93,2.99Z"
                        transform="translate(-7010 -1399)"
                      />
                    </svg>
                    <svg
                      v-if="item.SessionTypeDetails.TypeID == RoundTableTypeID"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="31.21"
                      viewBox="0 0 32 31.21"
                    >
                      <defs></defs>
                      <path
                        id="round-table.svg"
                        class="cls-1"
                        d="M6900.5,1418.06H6898a13.9,13.9,0,0,0,0-8.08h2.5A16.572,16.572,0,0,1,6900.5,1418.06Zm-12.29,9.31a13.56,13.56,0,0,0,6.87-4.13l1.26,2.19a16.11,16.11,0,0,1-6.89,4.12Zm-0.17-26.75,1.25-2.18a16.028,16.028,0,0,1,6.94,4.06l-1.25,2.19A13.566,13.566,0,0,0,6888.04,1400.62Zm6.96,13.37a10,10,0,1,1-10-10A10,10,0,0,1,6895,1413.99Zm-10-7.6a7.6,7.6,0,1,0,7.6,7.6A7.6,7.6,0,0,0,6885,1406.39Zm-9.84-1.86-1.24-2.17a15.92,15.92,0,0,1,6.97-3.97l1.25,2.19A13.641,13.641,0,0,0,6875.16,1404.53Zm6.8,22.88-1.25,2.18a15.874,15.874,0,0,1-6.94-4.06l1.25-2.18A13.579,13.579,0,0,0,6881.96,1427.41Zm-12.46-9.35a16.572,16.572,0,0,1,0-8.08h2.5a13.9,13.9,0,0,0,0,8.08h-2.5Z"
                        transform="translate(-6869 -1398.38)"
                      />
                    </svg>
                    <svg
                      v-if="item.SessionTypeDetails.TypeID == InPersonTypeID"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill-rule="evenodd"
                      fill="#eaeaea"
                    >
                      <path
                        d="M24.473,19.801 C24.433,19.238 24.356,18.629 24.238,17.977 C24.121,17.324 23.973,16.718 23.795,16.160 C23.616,15.602 23.376,15.058 23.075,14.528 C22.774,13.998 22.474,13.490 22.037,13.172 C20.649,12.163 19.918,12.338 18.739,12.941 C18.650,12.987 18.404,13.061 18.036,13.301 C17.668,13.541 17.252,13.809 16.789,14.105 C16.325,14.401 15.723,14.669 14.981,14.908 C14.238,15.149 13.493,15.268 12.746,15.268 C11.998,15.268 11.253,15.149 10.511,14.908 C9.768,14.669 9.166,14.401 8.703,14.105 C8.239,13.809 7.824,13.541 7.455,13.301 C7.087,13.061 6.828,13.007 6.752,12.941 C6.023,12.307 4.942,12.162 3.454,13.172 C3.007,13.476 2.718,13.998 2.416,14.528 C2.115,15.058 1.875,15.602 1.697,16.160 C1.518,16.718 1.370,17.324 1.253,17.977 C1.136,18.629 1.057,19.238 1.019,19.801 C0.979,20.365 0.960,20.943 0.960,21.534 C0.960,22.873 1.367,23.931 2.182,24.706 C2.997,25.482 4.079,25.870 5.430,25.870 L20.061,25.870 C21.412,25.870 22.494,25.482 23.309,24.706 C24.124,23.931 24.531,22.873 24.531,21.534 C24.531,20.943 24.512,20.365 24.473,19.801 ZM12.746,0.156 C10.971,0.156 9.456,0.783 8.200,2.039 C6.945,3.295 6.317,4.810 6.317,6.584 C6.317,8.359 6.945,9.874 8.200,11.129 C9.456,12.385 10.971,13.013 12.746,13.013 C14.520,13.013 16.035,12.385 17.291,11.129 C18.546,9.874 19.174,8.359 19.174,6.584 C19.174,4.810 18.546,3.295 17.291,2.039 C16.035,0.783 14.520,0.156 12.746,0.156 Z"
                      />
                    </svg>
                  </span>
                  <p>{{ item.SessionTypeDetails.TypeName }}</p>
                </div>
                <div class="right-session-status">
                  <p>
                    <span :class="item.StatusClass"></span>
                    {{ item.StatusDisplayText }}
                  </p>
                </div>
              </div>
              <div class="right-session-details">
                <p>
                  {{ item.Name }}
                </p>
                <span class="keynote">{{ item.TrackName }}</span>
                <p class="time-session">
                  {{ item.StartTimeLabel }} - {{ item.EndTimeLabel }}
                </p>
              </div>
              <div class="right-session-button">
                <div
                  v-if="
                    (item.SessionTypeDetails.TypeID < 5 ||
                      item.SessionTypeDetails.InPersonURL) &&
                    item.IsLive &&
                    (item.SessionId != sessionId ||
                      item.IsHost ||
                      item.IsSpeaker) &&
                    (!(item.IsZoomRTMP|| item.IsRTMP )||
                      item.IsHost ||
                      item.IsSpeaker ||
                      ((item.IsZoomRTMP||item.IsRTMP) && item.RTMPStarted))
                  "
                  @click="
                    startSession(
                      item.SessionId,
                      item.IsLive,
                      item.SessionTypeDetails.TypeID,
                      item.SessionTypeDetails.InPersonURL
                    )
                  "
                  class="btn-manual-proceed ml-0"
                >
                  {{ $t("livestage.proceed") }}
                </div>
                <div v-else class="btn-manual-proceed ml-0 disabled">
                  {{ $t("livestage.proceed") }}
                </div>
                <!--<div
                  v-if="
                    IsZoomRTMPOptionsEnabled &&
                    item.SessionTypeDetails.TypeID == 3 &&
                    item.IsLive &&
                    item.IsZoomRTMP &&
                    item.ZoomMeetingStarted &&
                    (item.IsHost || (item.IsSpeaker && item.RTMPStarted))
                  "
                  class="on-demand-session-option"
                >
                  <p @click="toggleMoreSessionActions(item.SessionId, $event)">
                    <span></span>
                    <span></span>
                    <span></span>
                  </p>
                  <div class="on-demand-dropdown d-none">
                    <ul>
                      <li
                        v-if="
                          item.IsHost &&
                          item.ZoomMeetingStarted &&
                          !item.RTMPStarted
                        "
                        @click="StartRTMPStreaming(item.SessionId, $event)"
                      >
                        Start RTMP Streaming
                      </li>
                      <li
                        v-if="item.IsHost && item.RTMPStarted"
                        @click="StopRTMPStreaming(item.SessionId, $event)"
                      >
                        Stop RTMP Streaming
                      </li>
                      <li
                        v-if="
                          (item.IsHost || item.IsSpeaker) &&
                          item.RTMPStarted
                        "
                        @click="startInteractionWithAudience(item.SessionId)"
                      >
                        Interact with Audience
                      </li>
                    </ul>
                  </div>
                </div>-->
              </div>
            </div>
          </div>
          <div
            v-else
            id="right-session-list-wrapper"
            :class="
              agendaFilterOption == 2 &&
              selectedAgendaType >= 0 &&
              mySessionsLoaded &&
              mySessions.length > 0
                ? 'qna-area-wrap right-session-list-wrapper empty'
                : 'qna-area-wrap right-session-list-wrapper empty no-filter-tab'
            "
          >
            <h2>No sessions scheduled today</h2>
            <router-link :to="'/sessions'">Go to All Sessions</router-link>
          </div>
        </div>
      </div>
      <div class="session-list-head">
        <!--<h3>Sessions</h3>
        <select>
          <option>Full Agenda</option>
          <option>My Agenda</option>
        </select>-->
      </div>
    </div>
    <!---Sessions List end------>
    <!---Meeting List tab start------>
    <div class="right-desc-pannel d-none" id="tab_meeting">
      <div class="sessions-tab">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top">
              <h3>{{ $t("rightpanel.mymeetings") }}</h3>
            </div>
          </div>
          <div class="qna-area-wrap right-session-list-wrapper no-filter-tab">
            <ExhibitorsMeeting
              :uid="uid"
              :rightPanel="true"
              :sessionTypeId="sessionTypeId"
              :allowRequestMeeting="false"
              :currentMeetingId="meetingId"
              @startMeeting="startMeeting"
              @setNextMeetingData="setNextMeetingData"
            ></ExhibitorsMeeting>
          </div>
        </div>
      </div>
    </div>
    <!---Meeting List end------>
    <!---Poll tab start---->
    <div class="right-desc-pannel d-none" id="tab_poll">
      <div class="pool-tab-area qna-section">
        <div class="qna-top-area">
          <div class="pannel-top-area">
            <div class="pannel-top text-left" id="live_PollTop">
              <h3>
                {{ $t("rightpanel.livepoll") }}
              </h3>
              <p class="pt-2">{{ $t("rightpanel.engageattendee") }}</p>
            </div>
            <!----create_PollTop-->
            <div
              class="pannel-top text-left"
              id="create_PollTop"
              style="display: none"
            >
              <h3>
                <i v-on:click="showpoll()" class="fa fa-angle-left pr-2"></i>
                {{ $t("rightpanel.createpoll") }}
              </h3>
            </div>
          </div>
          <!---->
          <div
            id="poll-area-wrap"
            class="qna-middle-part qna-area-wrap chat-part scroll-area"
          >
            <!---question box--->
            <!-----first step start------>
            <div class="tab-content poll-first-step">
              <div class="tab-pane fade show active">
                <div class="featured-question" id="dvQuestionList">
                  <!---question box--->
                  <div
                    v-for="ques in myPollList"
                    v-bind:key="ques.SurveyID"
                    :id="ques.SurveyID"
                    class="single-feature-question"
                  >
                    <div class="question-description">
                      <div class="attendee-description q-top">
                        <div
                          class="attendee-name-desc"
                          style="cursor: pointer"
                          @click="
                            showPollPopup(
                              ques.QuesID,
                              ques.UserID == uid ? 1 : ques.IsSubmitted ? 2 : 1
                            )
                          "
                        >
                          <p class="mb-0">
                            {{ ques.Question }}
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="ques.UserID == uid"
                        class="vote-border-wrapper"
                      >
                        <p
                          style="cursor: pointer"
                          @click="showPollPopup(ques.QuesID, 2)"
                        >
                          <span>
                            <i class="fa fa-eye"></i>
                          </span>
                          Votes
                        </p>
                        <p
                          style="cursor: pointer"
                          class="v-right-p"
                          v-if="ques.isActive == true && ques.UserID == uid"
                          v-on:click="
                            ActivateQuestion(ques.QuesID, ques.SurveyID)
                          "
                        >
                          Unpublish Poll
                          <span class="sm-circle red-bg"
                            ><i class="fa fa-stop"></i
                          ></span>
                        </p>

                        <p
                          style="cursor: pointer"
                          class="v-right-p"
                          v-if="ques.isActive == false && ques.UserID == uid"
                          v-on:click="
                            ActivateQuestion(ques.QuesID, ques.SurveyID)
                          "
                        >
                          Publish Poll
                          <span class="sm-circle"
                            ><i class="fa fa-play"></i
                          ></span>
                        </p>
                      </div>
                      <!--question bottom end-->
                    </div>
                  </div>
                  <!---question box end--->
                </div>
              </div>
            </div>
            <!-----first step end------>
            <!----poll second step---->
            <div class="poll-second-step" style="display: none">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <span
                    :class="
                      pollCreateOption != 0 ? 'nav-link active' : 'nav-link'
                    "
                    @click="changePollCreateOption(1)"
                  >
                    {{ $t("rightpanel.multiplechoice") }}</span
                  >
                </li>
                <li class="nav-item">
                  <span
                    :class="
                      pollCreateOption == 0 ? 'nav-link active' : 'nav-link'
                    "
                    @click="changePollCreateOption(0)"
                    >{{ $t("rightpanel.openans") }}</span
                  >
                </li>
              </ul>
              <div class="tab-content">
                <!---multiple-choice start-->
                <div
                  v-show="pollCreateOption != 0"
                  class="tab-pane fade show active"
                  id="multiple-choice"
                >
                  <div class="featured-question">
                    <p>Add your question</p>
                    <div class="create-qs-wrapper">
                      <p class="d-flex justify-content-between">
                        <span
                          id="lblQuestion"
                          class="autu-increse-input d-block"
                          role="textbox"
                          contenteditable
                          :data-placeholder="$t('rightpanel.enterQuestion')"
                        >
                        </span>
                      </p>
                      <div class="new_poll_warpper">
                        <div
                          v-for="(item, index) in OptionList"
                          :key="index"
                          class="form-group"
                        >
                          <div
                            class="
                              d-flex
                              justify-content-between
                              align-items-center
                            "
                          >
                            <label>Option {{ index + 1 }} <span>*</span></label>
                            <label
                              class="remone-poll-f"
                              @click="DeleteOptions(index)"
                              >Remove</label
                            >
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            :value="item"
                            placeholder=""
                            readonly="true"
                          />
                          <!--<input
                            type="text"
                            class="form-control"
                            placeholder=""
                          />-->
                        </div>
                        <div v-show="OptionList.length < 4" class="form-group">
                          <div
                            class="
                              d-flex
                              justify-content-between
                              align-items-center
                            "
                          >
                            <label
                              >Option {{ OptionList.length + 1 }}
                              <span>*</span></label
                            >
                            <label class="remone-poll-f"></label>
                          </div>
                          <!--@keydown.esc="DeleteBeforeAdd()"-->
                          <div class="poll-input-wrap">
                            <input
                              type="text"
                              id="lblOptions"
                              class="form-control"
                              placeholder="Add Option"
                              autocomplete="off"
                              v-on:keyup.enter="AddOptions()"
                              v-model="pollOption"
                            />
                            <span
                              v-show="pollOption"
                              @click="clearOption"
                              class="clear-option"
                            >
                              <img
                                src="../../../assets/Images/icons/cross-white.svg"
                                alt=""
                              />
                            </span>
                          </div>
                        </div>
                        <button
                          v-show="OptionList.length < 4"
                          class="poll_add_option"
                          @click="AddOptions()"
                        >
                          Add option
                        </button>
                        <div id="dvOptioninfo" style="margin-top: 15px">
                          <i
                            class="fa fa-exclamation-triangle"
                            style="color: #fff; float: left"
                          ></i>
                          <div
                            style="
                              font-weight: bold;
                              padding-left: 5px;
                              color: #f54c16;
                              padding-bottom: 16px;
                              padding-left: 22px;
                            "
                            id="dvOptionmsg"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---open answer section start------>
                <div
                  v-show="pollCreateOption == 0"
                  class="tab-pane fade show active"
                  id="open-answer"
                >
                  <div class="featured-question">
                    <p>{{ $t("rightpanel.addQuestion") }}</p>
                    <div class="create-qs-wrapper">
                      <p class="d-flex justify-content-between">
                        <span
                          id="lblOpenQuestion"
                          class="autu-increse-input d-block"
                          role="textbox"
                          contenteditable
                          :data-placeholder="$t('rightpanel.enterQuestion')"
                        >
                        </span>
                      </p>
                      <div
                        id="dvOpenOptioninfo"
                        style="width: 100%; float: left"
                      >
                        <i
                          class="fa fa-exclamation-triangle"
                          style="color: #fff; float: left; padding-top: 2px"
                        ></i>
                        <div
                          style="
                            font-weight: bold;
                            padding-left: 5px;
                            color: #f54c16;
                            padding-bottom: 16px;
                            padding-left: 22px;
                          "
                          id="dvOpenOptionmsg"
                        ></div>
                      </div>
                      <p>
                        <strong
                          ><i class="fa fa-lightbulb-o"></i>&nbsp;Tip : </strong
                        >&nbsp;It is recommended for attendees to use 1 to 3
                        words for best results in word cloud. Longer phrases or
                        sentences is not recommended.
                      </p>
                    </div>
                  </div>
                  <!--show answer as a word cloud--->
                  <!-- <ul class="word-cloud">
                    <li>
                      <input
                        class="styled-checkbox"
                        id="styled-checkbox-1"
                        type="checkbox"
                      />
                      <label for="styled-checkbox-1"
                        >Show answer as a word cloud</label
                      >
                    </li>
                  </ul> -->
                  <!--show answer as a word cloud end--->
                </div>
                <!---open answer section end------>
              </div>
            </div>
            <!----poll second step end---->
          </div>
        </div>
        <!--Create New Poll button--->
        <div
          class="
            message-input-area
            chat-input-area
            submit-area
            text-uppercase
            py-0
          "
        >
          <div class="vote-button-area full-width" id="btn_create_pool">
            <button
              type="button"
              class="btn btn-create-pool full-width"
              @click="createIpoll"
              v-show="isCreatePollVisible == false"
            >
              {{ $t("rightpanel.createnewpoll") }}
            </button>
          </div>
          <!--poll-lunch---->
          <div
            class="vote-button-area full-width poll-lunch"
            style="display: none"
          >
            <button
              type="button"
              v-on:click="clicklaunch()"
              class="btn lunch-pool"
            >
              {{ $t("rightpanel.launch") }}
            </button>
            <button
              type="button"
              v-on:click="showpoll()"
              class="btn cancle-pool"
            >
              {{ $t("rightpanel.cancel") }}
            </button>
          </div>
          <!------>
        </div>
        <!---button end-->
      </div>
    </div>
    <!--Poll tab end---->
    <div
      :class="
        ShowPlayerHeader
          ? 'right-icon-pannel'
          : 'right-icon-pannel without-header'
      "
    >
      <ul class="right-icon-pannel-top">
        <li
          id="btn_session"
          v-show="checkSessionTabVisible"
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.SessionListEnabled
              ? ''
              : tabNotEnabledByHostMsg
          "
          :class="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.SessionListEnabled
              ? ''
              : 'disable-action'
          "
          @click="toggleSessionsTab"
        >
          <span class="right-pannel-icon">
            <img
              src="../../../assets/Player/images/sessions.svg"
              alt="Session Icon"
            />
          </span>
          <span class="label-right">{{ $t("rightpanel.sessions") }}</span>
        </li>
        <li
          id="btn_meeting"
          v-show="[6, 7].includes(sessionTypeId) && checkMeetingTabVisible"
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.MeetingListEnabled
              ? ''
              : tabNotEnabledByHostMsg
          "
          :class="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.MeetingListEnabled
              ? ''
              : 'disable-action'
          "
          @click="toggleMeetingsTab"
        >
          <span class="right-pannel-icon">
            <img
              src="../../../assets/Player/images/sessions.svg"
              alt="Meeting Icon"
            />
          </span>
          <span class="label-right">{{ $t("rightpanel.meetings") }}</span>
        </li>
        <!--v-show="callStarted && isSpeakerTabVisible"-->
        <li
          id="btn_speaker"
          v-show="false"
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.SpeakerInfoEnabled
              ? ''
              : tabNotEnabledByHostMsg
          "
          :class="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.SpeakerInfoEnabled
              ? ''
              : 'disable-action'
          "
          @click="toggleSpeakerTab"
        >
          <span class="right-pannel-icon">
            <img
              src="../../../assets/Images/speakers-wht.svg"
              alt="Speaker Icon"
            />
          </span>
          <span v-if="sessionTypeId == 4" class="label-right">{{
            $t("rightpanel.guests")
          }}</span>
          <span v-else class="label-right">{{
            $t("rightpanel.speakers")
          }}</span>
        </li>
        <li
          id="btn_attendee"
          v-show="
            callStarted &&
            sessionTypeId != 4 &&
            (isAttendeeTabVisible || (sessionTypeId < 5 && userType < 4)) && !dialogSessionId
          "
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType < 3 ||
            isCurrentUserCoHost ||
            broadcastSettings.AttendeeEnabled
              ? ''
              : tabNotEnabledByHostMsg
          "
          :class="
            userType < 3 ||
            isCurrentUserCoHost ||
            broadcastSettings.AttendeeEnabled
              ? ''
              : 'disable-action'
          "
          @click="toggleAttendeeTab"
        >
          <span class="right-pannel-icon">
            <img
              src="../../../assets/Images/attendees-white.svg"
              alt="Attendees Icon"
            />
          </span>
          <span class="label-right">{{ $t("rightpanel.attendees") }}</span>
        </li>
        <li
          id="btn_qa"
          v-show="
            callStarted && isQnATabVisible && sessionTypeId != RoundTableTypeID
          "
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType == 1 || isCurrentUserCoHost || broadcastSettings.QnAEnabled
              ? ''
              : tabNotEnabledByHostMsg
          "
          :class="
            userType == 1 || isCurrentUserCoHost || broadcastSettings.QnAEnabled
              ? ''
              : 'disable-action'
          "
          @click="toggleQnATab"
        >
          <span class="right-pannel-icon">
            <img src="../../../assets/Images/qna.svg" alt="QnA Icon" />
            <small
              v-show="
                !isQnAPanelOpend &&
                (userType != 4 || broadcastSettings.QnAEnabled) &&
                unreadQnACount > 0
              "
              class="bulb-2"
              >{{ unreadQnACount }}</small
            >
          </span>
          <span class="label-right">QnA</span>
        </li>
        <!-----28.10 polls start------>
        <li
          id="btn_poll"
          v-show="
            callStarted &&
            isPollTabVisible &&
            (userType != 4 || activePollList.length > 0)
          "
          data-toggle="tooltip"
          data-placement="left"
          @click="togglePollTab"
        >
          <span class="right-pannel-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="29"
              viewBox="0 0 24 29"
            >
              <path
                id="poll.svg"
                fill="#ffffff"
                d="M3972,2444h-18a2.676,2.676,0,0,1-3-3v-9a2.676,2.676,0,0,1,3-3l5.39-.07-2.68-3.47a1.889,1.889,0,0,1,.28-2.6l9.12-7.45a1.754,1.754,0,0,1,2.52.3l3.58,4.65a1.882,1.882,0,0,1-.28,2.6l-7.31,5.97L3972,2429a2.676,2.676,0,0,1,3,3v9A2.676,2.676,0,0,1,3972,2444Zm-1.5-22.95-2.91-3.78c-0.31-.4-0.43-0.41-0.82-0.09l-8.25,6.74c-0.39.32-.4,0.45-0.1,0.85l2.92,3.77c0.31,0.41.43,0.42,0.82,0.1l8.25-6.74C3970.8,2421.58,3970.81,2421.45,3970.5,2421.05ZM3973,2432c0-1-.03-1-1-1h-18c-0.97,0-1,0-1,1v1h20v-1Zm0,3h-20v6c0,1,.03,1,1,1h18c0.97,0,1,0,1-1v-6Z"
                transform="translate(-3951 -2415)"
              />
            </svg>
          </span>
          <span class="label-right">{{ $t("rightpanel.poll") }}</span>
        </li>
        <!-----28.10 polls end------>
        <!-- v-show="(callStarted && isChatTabVisible) || stageUrl == '/stageview'" -->
        <li
          id="btn_message"
          v-show="callStarted && isChatTabVisible"
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.ChatEnabled
              ? ''
              : stageUrl == '/stageview'
              ? ''
              : tabNotEnabledByHostMsg
          "
          :class="
            (userType == 1 ||
              isCurrentUserCoHost ||
              broadcastSettings.ChatEnabled ||
              stageUrl == '/stageview') &&
            callStarted
              ? ''
              : 'disable-action'
          "
          @click="callStarted ? toggleChatTab($event) : null"
        >
          <span class="right-pannel-icon">
            <img
              src="../../../assets/Images/chat-new-wht.svg"
              alt="Chat Icon"
            />
            <small
              v-show="
                !isChatPanelOpend &&
                (userType != 4 || broadcastSettings.ChatEnabled) &&
                chat.unreadChatCount > 0
              "
              class="bulb-2"
              >{{ chat.unreadChatCount }}</small
            >
          </span>
          <span class="label-right">{{ $t("rightpanel.chat") }}</span>
        </li>
        <li
          id="btn_raise_hand"
          v-show="
            callStarted &&
            isRaiseHandTabVisible &&
            (userType == 1 ||
              isCurrentUserCoHost ||
              (userType == 4 && showAttendeeRH))
          "
          data-toggle="tooltip"
          data-placement="left"
          v-bind:data-original-title="
            userType == 1 ||
            isCurrentUserCoHost ||
            broadcastSettings.RaiseHandEnabled
              ? ''
              : tabNotEnabledByHostMsg
          "
          @click="
            userType == 1 ||
            isCurrentUserCoHost ||
            (userType == 4 && showAttendeeRH)
              ? toggleRaiseHandTab($event)
              : null
          "
          :class="{
            selected: userType != 1 && isRHInProcess,
            'disable-action': !(
              userType == 1 ||
              isCurrentUserCoHost ||
              (userType == 4 && showAttendeeRH)
            ),
          }"
        >
          <span class="right-pannel-icon">
            <img
              v-if="userType != 1 && isRHInProcess"
              src="../../../assets/Player/images/hand-raise-solid.svg"
              alt="Raise Hand"
            />
            <img
              v-else
              src="../../../assets/Images/hand-raise.svg"
              alt="Raise Hand"
            />
            <small
              v-show="
                !isRaiseHandPanelOpend &&
                (userType == 1 || isCurrentUserCoHost) &&
                broadcastSettings.RaiseHandEnabled &&
                currentRHAttendees.length > 0
              "
              class="bulb-2"
              >{{ currentRHAttendees.length }}</small
            >
          </span>
          <span v-if="isRHInProcess" class="label-right">{{
            $t("rightpanel.lowerhand")
          }}</span>
          <span v-else class="label-right">{{
            $t("rightpanel.raiseHand")
          }}</span>
        </li>
        <!-- <li
          v-if="callStarted && userType < 4 && isBreakoutRoomTabVisible"
          id="btn_breakout_room"
          :class="{
            'disable-action':
              !(userType == 1 || isCurrentUserCoHost) && !breakoutRoomPublished,
          }"
          @click="(userType == 1 || isCurrentUserCoHost) || breakoutRoomPublished ? OpenBreakoutPopup():null"
        > -->
        <li
          v-if="callStarted && isBreakoutRoomTabVisible"
          id="btn_breakout_room"
          :class="{
            'disable-action':
              !(userType == 1 || isCurrentUserCoHost) && !breakoutRoomPublished,
          }"
          @click="
            userType == 1 || isCurrentUserCoHost || breakoutRoomPublished
              ? OpenBreakoutPopup()
              : null
          "
        >
          <span class="right-pannel-icon">
            <img
              src="../../../assets/Images/icons/breakout-room.svg"
              alt="Breakout Rooms"
            />
          </span>
          <span
            v-if="callStarted && isBreakoutRoomTabVisible"
            class="label-right"
            >Rooms</span
          >
          <span v-else class="label-right">Rooms</span>
        </li>
      </ul>
      <!--sound-handle-wrap-bottom-->
      <div class="right-icon-pannel-bottom">
        <div
          v-show="
            callStarted &&
            ![0, 5].includes(sessionTypeId) &&
            !(stageUrl != '/livestage' && [1, 2].includes(sessionTypeId)) &&
            !(stageUrl != '/livestage' && isZoomRTMP)
          "
          @mouseleave="onVolumeButtonLeave"
          :class="userType == 4 ? 'sound-handle-wrap' : 'sound-handle-wrap'"
        >
          <div
            class="sound-bar"
            data-toggle="tooltip"
            data-placement="left"
            data-original-title="Slide up or down and release for changes to take effect"
          >
            <input
              id="volumeRange"
              v-model="volumeLevel"
              type="range"
              :class="volumePaused ? 'vranger muted d-none' : 'vranger d-none'"
              min="0"
              max="100"
              step="5"
              @change="onVolumeChanged"
            />
            <!--@input="volumeChanged"-->
          </div>
          <button
            class="sound-icon-btn"
            @click="toggleVolume()"
            @mouseover="onVolumeButtonHover"
          >
            <span
              :title="volumeLevel"
              :class="'volume-icon ' + volumeLevelClass"
            />
            <!--<img
            src="../../../assets/Images/volume-full.svg"
            v-if="volumeLevel <= 100 && volumeLevel >= 0"
            alt="sound-full"
          />-->
            <!--<img
            v-if="volumeLevel == 100"
            src="../../../assets/Images/volume-full.svg"
            alt="sound-full"
          />
          <img
            v-if="volumeLevel < 100 && volumeLevel > 49"
            src="../../../assets/Images/volume-mid.svg"
            alt="sound-mid"
          />
          <img
            v-if="volumeLevel < 50 && volumeLevel > 0"
            src="../../../assets/Images/volume-low.svg"
            alt="sound-low"
          />
          <img
            v-if="volumeLevel == 0"
            src="../../../assets/Images/volume-off.svg"
            alt="sound-off"
          />-->
            <span class="volcontroltext">{{ $t("rightpanel.volume") }}</span>
          </button>
          <div
            v-if="
              callStarted &&
              notifyVolumeOff &&
              (volumePaused || volumeLevel < 20)
            "
            class="volume-off-msg"
            :class="{ 'no-resize-button': !playerResizeVisible }"
            @click="notifyVolumeOff = false"
          >
            <span v-if="volumePaused">
              Your speaker volume is off, please increase it to hear audio.
            </span>
            <span v-else-if="volumeLevel < 20">
              Your speaker volume is low, please increase it to make it loud.
            </span>
          </div>
        </div>
        <div
          v-show="
            callStarted && newDesign && playerResizeVisible && sessionTypeId < 4 && !dialogSessionId
          "
          class="player-resize-bottom"
          @click="resizePlayer(true)"
        >
          <img
            v-show="playerResizeVisible && !isFullScreen"
            id="btn-max"
            src="../../../assets/Images/maximise.svg"
            alt="on-air-white"
          />
          <span
            v-show="playerResizeVisible && !isFullScreen"
            class="window-state"
          >
            {{ $t("livestage.maximize") }}
          </span>
          <img
            v-show="playerResizeVisible && isFullScreen"
            id="btn-min"
            src="../../../assets/Images/minimize.svg"
            alt="on-air-white"
          />
          <span
            v-show="playerResizeVisible && isFullScreen"
            class="window-state"
          >
            {{ $t("livestage.restore") }}
          </span>
        </div>
      </div>
    </div>
    <div
      id="voteModalCenter"
      persistent
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      class="modal fade vote-modal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div id="pollPopupBody" class="modal-content">
          <div
            class="modal-body"
            style="padding: 0px !important; padding-top: 10px !important"
          >
            <div class="vote-head">
              <h3>{{ $t("rightpanel.livepoll") }}</h3>
              <!-- <button v-if="!pollFullScreen" type="button" class="full-screen" @click="FullScreenPollPopup()">
                <span aria-hidden="true"></span>
              </button> -->
              <!-- <v-btn v-if="!pollFullScreen"
                small
                icon
                class="p-0"
                right="50px"
                top="10px"
                color="#000"
                style=""
                @click="
                  FullScreenPollPopup()
                "
              >
                <v-icon color="#fff">mdi-close</v-icon>
              </v-btn>
              <button v-else type="button" class="exit-full-screen" @click="ExitFullScreenPollPopup()">
                <span aria-hidden="true"></span>
              </button> -->
              <button type="button" class="close" @click="hidePollPopup()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              v-show="pollStep == 0 && activePollList.length > 1"
              class="vote-slide-1"
            >
              <div class="vote-questions">
                <ul style="padding: 0 24px !important">
                  <li
                    v-for="activePoll in activePollList"
                    v-bind:key="activePoll.QuesID"
                  >
                    <!--@click.prevent="
                        showVotingOption(
                          activePoll.QuesID,
                          activePoll.fieldtype,
                          activePoll.SurveyID
                        )
                      "-->
                    <a
                      href="javascript: void(0);"
                      @click.prevent="showPollPopup(activePoll.QuesID)"
                      class="aQuestionList"
                      :id="activePoll.QuesID"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          :style="
                            activePoll.IsSubmitted
                              ? 'visibility:visible'
                              : 'visibility:hidden'
                          "
                          src="../../../assets/Images/icons/check-circle-outline.svg"
                        />
                        <span class="pl-2 pt-1">
                          {{ activePoll.Question }}
                        </span>
                      </div>
                      <span>
                        <img src="../../../assets/Images/icons/vote-next.svg" />
                      </span>
                    </a>
                  </li>
                </ul>

                <!-- <p class="vote-history">
                  <a href=""
                    >Your voting history
                    <span><img src="images/vote-next-red.svg" /></span
                  ></a>
                </p> -->
              </div>
            </div>
            <div v-show="pollStep != 0">
              <div
                v-for="(ques, pollIndex) in myPollList"
                v-bind:key="ques.QuesID"
                class="voting-area attendee-poll-wrapper"
                :id="ques.QuesID + '_VotingArea'"
              >
                <div v-if="currentPoll == ques.QuesID">
                  <div
                    v-if="currentPoll == ques.QuesID"
                    :id="'divblock' + ques.QuesID"
                    style="position: relative"
                  >
                    <div class="voting-question px-4">
                      <div class="mt-2" style="">
                        <a
                          v-if="activePollList.length > 1"
                          @click="backToPollList"
                          style="float: left
                            color: #696969;
                            font-weight: 500;
                            margin-right: 5px;
                          "
                        >
                          <img
                            height="24"
                            width="24"
                            style="margin-top: 2px"
                            src="../../../assets/Images/chat-assets/back-to-list-dark.svg"
                          />
                        </a>
                        <!--<span class="ml-2" style="line-height: 24px">
                          Back to List
                        </span>-->
                        <h4
                          class="my-0 mx-0 pb-2"
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          "
                        >
                          {{ ques.Question }}
                        </h4>
                      </div>
                      <div style="clear: both"></div>
                    </div>

                    <!---tab button area start-------->
                    <div class="border-bottom-tab1">
                      <ul
                        class="nav nav-tabs justify-content-center"
                        role="tablist"
                        v-show="ques.UserID == uid"
                      >
                        <li class="nav-item">
                          <a
                            :class="
                              pollStep == 1 ? 'nav-link active' : 'nav-link'
                            "
                            href="#"
                            @click.prevent="changePollTab(1)"
                            >Poll</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            :class="
                              pollStep == 2 ? 'nav-link active' : 'nav-link'
                            "
                            href="#"
                            @click="changePollTab(2)"
                            >Poll Results</a
                          >
                        </li>
                      </ul>
                    </div>
                    <!---tab button area end-------->
                    <!-----tab content area start----->
                    <div
                      v-if="ques.fieldtype === 'checkboxes'"
                      class="Quesboxoption multiple-ans"
                    >
                      <div v-if="pollStep == 1">
                        <ul
                          class="attendee-live-poll-q 1"
                          :id="'ul' + ques.QuesID"
                        >
                          <li
                            v-for="(ans1, index1) in ques.Options"
                            v-bind:key="index1"
                            class="vote-ans"
                          >
                            <label class="container-vote-ans"
                              >{{ ans1.label }}
                              <input
                                type="radio"
                                name="radio"
                                class="isvotechecked"
                                v-on:click="selectAnswer($event)"
                              />
                              <span class="checkmark-vote-ans">{{
                                optionChar[index1]
                              }}</span>
                            </label>
                          </li>
                        </ul>
                        <div style="width: 100%; text-align: center">
                          <v-btn
                            v-show="ques.isActive && !ques.IsSubmitted"
                            :loading="ques.IsSubmitting"
                            color="#4285f4"
                            style="
                              color: #fff;
                              font-size: 14px;
                              font-weight: 600;
                              min-width: 160px;
                              margin: 0 auto;
                            "
                            @click.prevent="
                              SubmitPoll(
                                ques.QuesID,
                                ques.fieldtype,
                                ques.SurveyID
                              )
                            "
                          >
                            {{ $t("rightpanel.submit") }}
                          </v-btn>
                        </div>
                      </div>
                      <div v-if="pollStep == 2" class="vote-result-area">
                        <div
                          v-if="currentPoll == ques.QuesID"
                          class="submit-vote-wrapper"
                          id="dvPollResult"
                        >
                          <div
                            v-show="ques.IsSubmitting"
                            id="dvResultLoader"
                            style="text-align: center"
                          >
                            <svg
                              width="65px"
                              height="65px"
                              viewBox="0 0 66 66"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g>
                                <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  values="0 33 33;270 33 33"
                                  begin="0s"
                                  dur="1.4s"
                                  fill="freeze"
                                  repeatCount="indefinite"
                                />
                                <circle
                                  fill="none"
                                  stroke-width="6"
                                  stroke-linecap="round"
                                  cx="33"
                                  cy="33"
                                  r="30"
                                  stroke-dasharray="187"
                                  stroke-dashoffset="610"
                                >
                                  <animate
                                    attributeName="stroke"
                                    values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                                    begin="0s"
                                    dur="5.6s"
                                    fill="freeze"
                                    repeatCount="indefinite"
                                  />
                                  <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    values="0 33 33;135 33 33;450 33 33"
                                    begin="0s"
                                    dur="1.4s"
                                    fill="freeze"
                                    repeatCount="indefinite"
                                  />
                                  <animate
                                    attributeName="stroke-dashoffset"
                                    values="187;46.75;187"
                                    begin="0s"
                                    dur="1.4s"
                                    fill="freeze"
                                    repeatCount="indefinite"
                                  />
                                </circle>
                              </g>
                            </svg>
                          </div>
                          <div class="multiple-ans">
                            <ul v-if="ques.vote">
                              <li
                                v-for="(optvote, index) in ques.vote"
                                v-bind:key="index"
                                :class="
                                  index == 0
                                    ? 'vote-ans currect-ans-box'
                                    : 'vote-ans'
                                "
                              >
                                <div
                                  :style="
                                    'width:' +
                                    (
                                      (optvote.count / ques.totVote) *
                                      100
                                    ).toFixed() +
                                    '%;'
                                  "
                                  class="inner-progress-bar"
                                ></div>
                                <label class="container-vote-ans"
                                  >{{ optvote.optionId }}
                                  <input
                                    type="checkbox"
                                    name="radio1"
                                    checked
                                    disabled
                                    class="isvotechecked"
                                  />
                                  <span class="checkmark-vote-ans"
                                    ><div class="counter-text">
                                      {{ optionChar[index] }}
                                    </div></span
                                  >
                                </label>
                                <span class="skill"
                                  ><i class="val">
                                    {{
                                      (
                                        (optvote.count / ques.totVote) *
                                        100
                                      ).toFixed() + "%"
                                    }}</i
                                  >{{ optvote.count }} Vote
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          v-if="currentPoll == ques.QuesID"
                          class="total-result"
                        >
                          <p>
                            {{ $t("rightpanel.totvote") }}
                            <span>{{ ques.totVote }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="ques.fieldtype === 'text'"
                      class="perfect-word-text-box"
                    >
                      <div v-if="pollStep == 1" class="word-ans-sec">
                        <textarea
                          cols="5"
                          rows="1"
                          :id="'txt' + ques.QuesID"
                          :placeholder="$t('rightpanel.typeyourans')"
                        ></textarea>
                        <div class="alert alert-info" id="dvInfoforwordcloud">
                          <strong
                            ><i class="fa fa-lightbulb-o"></i>&nbsp;Tip : </strong
                          >&nbsp; It is recommended for attendees to use 1 to 3
                          words for best results in word cloud. Longer phrases
                          or sentences is not recommended.
                        </div>
                        <div style="width: 100%; text-align: center">
                          <v-btn
                            v-show="ques.isActive && !ques.IsSubmitted"
                            :loading="ques.IsSubmitting"
                            color="#4285f4"
                            min-width="160px"
                            style="
                              color: #fff;
                              font-size: 14px;
                              font-weight: 600;
                              margin: 0 auto;
                            "
                            @click.prevent="
                              SubmitPoll(
                                ques.QuesID,
                                ques.fieldtype,
                                ques.SurveyID
                              )
                            "
                          >
                            {{ $t("rightpanel.submit") }}
                          </v-btn>
                        </div>
                      </div>
                      <div v-if="pollStep == 2" class="highlight-ans">
                        <div
                          v-show="ques.IsSubmitting"
                          id="dvResultLoader"
                          style="text-align: center"
                        >
                          <svg
                            width="65px"
                            height="65px"
                            viewBox="0 0 66 66"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <animateTransform
                                attributeName="transform"
                                type="rotate"
                                values="0 33 33;270 33 33"
                                begin="0s"
                                dur="1.4s"
                                fill="freeze"
                                repeatCount="indefinite"
                              />
                              <circle
                                fill="none"
                                stroke-width="6"
                                stroke-linecap="round"
                                cx="33"
                                cy="33"
                                r="30"
                                stroke-dasharray="187"
                                stroke-dashoffset="610"
                              >
                                <animate
                                  attributeName="stroke"
                                  values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                                  begin="0s"
                                  dur="5.6s"
                                  fill="freeze"
                                  repeatCount="indefinite"
                                />
                                <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  values="0 33 33;135 33 33;450 33 33"
                                  begin="0s"
                                  dur="1.4s"
                                  fill="freeze"
                                  repeatCount="indefinite"
                                />
                                <animate
                                  attributeName="stroke-dashoffset"
                                  values="187;46.75;187"
                                  begin="0s"
                                  dur="1.4s"
                                  fill="freeze"
                                  repeatCount="indefinite"
                                />
                              </circle>
                            </g>
                          </svg>
                        </div>
                        <div class="d-flex justify-center position-relative">
                          <!--<vue-word-cloud
                            style="height: 200px; width: 90%"
                            :words="ques.tagData"
                          />-->
                          <vue-word-cloud
                            style="height: 260px; width: 100%"
                            animation-duration="1000"
                            animation-easing="ease"
                            animation-overlap="1"
                            enter-animation="bounce"
                            font-family="Anton"
                            leave-animation="bounce"
                            spacing="0.5"
                            :words="ques.tagData"
                            :color="
                              ([, weight]) =>
                                weight > 4
                                  ? '#ffd077'
                                  : weight > 3
                                  ? '#3bc4c7'
                                  : weight > 2
                                  ? '#3a9eea'
                                  : weight > 1
                                  ? '#ff4e69'
                                  : '#461e47'
                            "
                          >
                            <template slot-scope="{ text, weight }">
                              <div :title="weight" style="cursor: pointer">
                                {{ text }}
                              </div>
                            </template>
                          </vue-word-cloud>
                        </div>
                        <div class="total-result">
                          <p>
                            {{ $t("rightpanel.totvote") }}
                            <span>{{ ques.totVote }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      :id="'dv' + pollIndex"
                      style="
                        padding-top: 5px;
                        padding-bottom: 5px;
                        width: 100%;
                        text-align: right;
                        padding-right: 50px;
                      "
                    >
                      <!-- <a
                      v-show="userType == 4"
                      href="javascript: void(0);"
                      @click.prevent="cancelPollingPop(ques.QuesID)"
                      class="cancel-sec"
                      >{{ $t("rightpanel.back") }}</a
                    > -->
                      <a
                        v-if="nextPoll"
                        href="javascript: void(0);"
                        @click.prevent="showPollPopup(nextPoll.QuesID, 1)"
                        class="next-sec"
                        >Next</a
                      >
                      <a
                        v-else-if="activePollList.length > 1"
                        href="javascript: void(0);"
                        @click="backToPollList"
                        class="cancel-sec"
                        >Show All</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>

    <div
      id="sessionSwitchConfirmPopup"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 16px; font-weight: 600; color: #1e1f26">
                Do you want to leave this session?
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="joinSessionCancel"
                  >NO</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="joinSession"
                  >YES</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="isBreakoutRoomPanelOpend" width="590">
      <v-card class="position-relative">
        <v-icon
          @click="isBreakoutRoomPanelOpend = false"
          size="25px"
          color="#888"
          class="close-popup"
          >mdi-close</v-icon
        >
        <BreakoutRoom
          ref="breakoutRoomRef"
          :key="breakoutRoomsKey"
          :sessionTypeId="sessionTypeId"
          :sessionId="sessionId"
          :tableId="roundTableId"
          :joinedRoomId="breakoutRoomId"
          :isLoading="isLoading"
          :breakoutRooms="breakoutRooms"
          :isHostOrCoHost="userType == 1 || isCurrentUserCoHost"
          @createBreakoutRoom="createBreakoutRoom"
          @updateRoomStatus="updateRoomStatus"
          @joinBreakoutRoom="joinBreakoutRoom"
        ></BreakoutRoom>
      </v-card>
    </v-dialog>
    <!-- <div
      v-show="roomClosing"
      style="width: 300px; position: absolute; top: 0; right: 0"
    >
      <v-card class="position-absolute">
        <v-icon
          @click="roomClosing = false"
          size="25px"
          color="#888"
          class="close-popup"
          >mdi-close</v-icon
        >
        <div style="border-bottom: 2px solid #dbdbdb; padding: 20px">
          <div>The Breakout Room will close in 60 seconds.</div>
          <div>You will be returned to the main session automatically</div>
        </div>
        <div class="mt-2">
          <v-btn
            depressed
            height="45px"
            width="130px"
            color="#e6e8ed"
            @click="roomClosing = false"
            class="cancel-switch mr-3"
            >Cancel</v-btn
          >
          <v-btn
            dark
            height="45px"
            width="130px"
            color="#0d6fec"
            @click="leaveBreakoutRoomNow"
            class="create-switch"
            >Leave Now</v-btn
          >
        </div>
      </v-card>
    </div> -->
    <div v-show="roomClosing" class="single-notification">
      <div class="notification-content">
        <span class="notification-close" @click="roomClosing = false">x</span>
        <div class="notification-image">
          <img src="../../../assets/Images/clock1.svg" alt="ni" />
        </div>
        <div>
          <p v-html="roomNotificationText" class="notification-text"></p>
          <div style="text-align: right">
            <v-btn
              dark
              small
              color="#0d6fec"
              @click="leaveBreakoutRoomNow"
              class="create-switch"
              >Leave Now</v-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
components:{
PerfectScrollbar,
},
};*/
import db from "@/components/firebaseInit";
//import vueCustomScrollbar from "vue-custom-scrollbar";
import jQuery from "jquery";
let $ = jQuery;
import { RESOLUTION_ARR } from "../utils/Settings";
//import firebaseChat from "@/views/Player/utils/firebase-chat.js";
import chat from "@/views/Player/utils/chat";
import qna from "@/views/Player/utils/qna";
import store from "@/store";
import VueWordCloud from "vuewordcloud";
import { VEmojiPicker } from "v-emoji-picker";
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";
import ExhibitorsMeeting from "@/components/ExhibitorsMeeting.vue";
import BreakoutRoom from "@/components/BreakoutRoom.vue";
//import attendee from "@/views/Player/utils/attendee";
//import { chatVars } from "@/views/Player/utils/chatVars";
//import vselect from "vue-select";
//var avatarImageUrl =
//  "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media";

let vm;
var pollPublishListener;
var pollRessultInterval;
var breakoutRoomListener;
var volumeOffTimr;
var roomClosingInterval;
//var funcTime = [];
export default {
  components: {
    //vueCustomScrollbar,
    //"v-select": vselect,
    ExhibitorsMeeting,
    VEmojiPicker,
    [VueWordCloud.name]: VueWordCloud,
    BreakoutRoom,
  },
  props: [
    "clientId",
    "eventId",
    "dialogEventCollectionName",
    "agendaFilterOption",
    "playersettings",
    "newDesign",
    "callStarted",
    "ShowPlayerHeader",
    "playerResizeVisible",
    "isFullScreen",
    "rememberSettings",
    "IsZoomRTMPOptionsEnabled",
    "IsRTMPEnabled",
    "allAttendees",
    "roomId",
    "dialogSessionId",
    "breakoutRoomId",
    "stageUrl",
    "hostCanInviteAttendeeToStage",
  ],
  data() {
    return {
      pollFullScreen: false,
      notifyVolumeOff: false,
      showChatEmojiPannel: false,
      isPollStarted: false,
      pollOption: "",
      //playerResizeVisible: false,
      //isFullScreen: false,
      selectedPollType: "S",
      currentPoll: "",
      pollCreateOption: 1,
      pollStep: 0,
      panel: this,
      uid: "",
      name: "",
      userType: 4, //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      event_collectionName: "",
      channelName: "",
      sessionTypeId: 0,
      sessionId: "",
      tempSessionId: "",
      interactWithAudience: false,
      roundTableId: "",
      spectatorEnabled: false,
      hostId: "",
      coHostId: "",
      meetingId: "",
      session: null,
      roundTable: null,
      o2oMeeting: null,
      isZoomRTMP: false,
      allHosts: [],
      allCoHosts: [],
      allSpeakers: [],
      settings: {
        maxScrollbarLength: 100,
      },
      volumeLevel: 100,
      volumePaused: false,
      volumeLevelClass: "volume-full",
      showSettings: false,
      resolutions: RESOLUTION_ARR,
      OnDemandTypeID: 1,
      LiveStreamTypeID: 2,
      LivePanelTypeID: 3,
      RoundTableTypeID: 4,
      InPersonTypeID: 5,
      O2OTypeID: 6,
      E2OTypeID: 7,
      currentGuestList: [],
      currentAttendeeList: [],
      //chatVars: chatVars,
      chat: chat,
      qna: qna,
      qnaActiveTabIndex: 0,
      //attendee: attendee,
      broadcastSettings: {
        SessionListEnabled: false,
        MeetingListEnabled: false,
        SpeakerInfoEnabled: false,
        AttendeeEnabled: false,
        QnAEnabled: false,
        ChatEnabled: false,
        RaiseHandEnabled: false,
        PollEnabled: false,
      },

      isSessionListPanelOpend: false,
      isMeetingListPanelOpend: false,
      isSpeakerPanelOpend: false,
      isAttendeePanelOpend: false,
      isQnAPanelOpend: false,
      isChatPanelOpend: false,
      isRaiseHandPanelOpend: false,
      isBreakoutRoomPanelOpend: false,
      roomClosing: false,
      roomClosingTemplate:
        "The Breakout Room will close in <b>{{timeLeft}}</b> seconds.<br/>You will be returned to the main session automatically",
      roomNotificationText: "",
      roomClosingTime: 60,
      isPollPanelOpend: false,
      //isVotingEnabled :false,
      isRHOn: false,

      isSessionTabVisible: true,
      isMeetingTabVisible: false,
      isSpeakerTabVisible: false,
      isAttendeeTabVisible: false,
      isQnATabVisible: false,
      isChatTabVisible: false,
      isRaiseHandTabVisible: false,
      isBreakoutRoomTabVisible: false,
      isPollTabVisible: false,
      isCreatePollVisible: false,
      AllowPostingQuestionsAnonymously: false,
      PostQnAAnonymous: false,
      QnAModeration: false,
      QnAAutoPublish: false,

      isLoading: true,
      breakoutRoomsKey: 0,
      breakoutRooms: [
        // {
        //   RoomId: "1",
        //   Name: "Breakout Room 1",
        //   IsPublished: true,
        //   Members: [
        //     {
        //       AttendeeId: "221000",
        //       Name: "Debashis Giri",
        //       NameInitial: "DG",
        //       Company: "WS Group",
        //       Designation: "Tech Lead",
        //       ProfilePictureURL:
        //         "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1594888724987E1611070965720%2FAttendees%2F221000_1668704494083_Debashis.PNG?alt=media",
        //     },
        //     {
        //       AttendeeId: "1562000",
        //       Name: "Debayan Ghosh",
        //       NameInitial: "DG",
        //       Company: "Web Spiders Group",
        //       Designation: "Team Lead",
        //       ProfilePictureURL:
        //         "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1594888724987E1611070965720%2FAttendees%2F1324000_1666939902072_Debayan%20Ghosh.jpg?alt=media",
        //     },
        //   ],
        // },
        // {
        //   RoomId: "2",
        //   Name: "Breakout Room 2",
        //   IsPublished: true,
        //   Members: [
        //     {
        //       AttendeeId: "221000",
        //       Name: "Debashis Giri",
        //       NameInitial: "DG",
        //       Company: "WS Group",
        //       Designation: "Tech Lead",
        //       ProfilePictureURL:
        //         "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1594888724987E1611070965720%2FAttendees%2F221000_1668704494083_Debashis.PNG?alt=media",
        //     },
        //     {
        //       AttendeeId: "1562000",
        //       Name: "Debayan Ghosh",
        //       NameInitial: "DG",
        //       Company: "Web Spiders Group",
        //       Designation: "Team Lead",
        //       ProfilePictureURL: "",
        //     },
        //   ],
        // },
        // {
        //   RoomId: "3",
        //   Name: "Breakout Room 3",
        //   IsPublished: false,
        //   Members: [
        //     {
        //       AttendeeId: "221000",
        //       Name: "Debashis Giri",
        //       NameInitial: "DG",
        //       Company: "WS Group",
        //       Designation: "Tech Lead",
        //       ProfilePictureURL:
        //         "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1594888724987E1611070965720%2FAttendees%2F221000_1668704494083_Debashis.PNG?alt=media",
        //     },
        //     {
        //       AttendeeId: "1562000",
        //       Name: "Debayan Ghosh",
        //       NameInitial: "DG",
        //       Company: "Web Spiders Group",
        //       Designation: "Team Lead",
        //       ProfilePictureURL: "",
        //     },
        //   ],
        // },
        // {
        //   RoomId: "4",
        //   Name: "Breakout Room 4",
        //   IsPublished: false,
        //   Members: [],
        // },
      ],

      videoProfile: "",
      camera: "",
      microphone: "",
      speaker: "",
      tabNotEnabledByHostMsg: this.$t("rightpanel.featurenotenabled"),

      unreadQnACount: 0,
      //unreadChatCount: 0,
      unreadRaiseHandCount: 0,
      roundTableSettingsLoade: false,
      pollQuestionList: [],
      OptionList: [],
      showCreatePoll: false,
      showLivePoll: false,
      showlivevoting: false,
      exPageId: "",
      allSessions: [],
      mySessions: [],
      mySessionsLoaded: false,
      selectedAgendaType: 0, // 0:FULL AGENDA, 1:MY AGENDA
      //AgendaFilterOption: 0, // 0: FullAgendaOnly (Default), 1: MyAgendaOnly, 2: ShowAll
      currentSessionElementId: "",
      altSpeakerList: [],
      altSpeaker: null,
      attendeeSearchTxt: null,
      attendeeGridView: false,
      isLive: true,
      selectedSpeakerId: "",
      optionChar: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "k",
        "L",
        "M",
        "N",
      ],
      enableInviteSessionAttendee: false,
      allowRaiseHand: false,
      maxSpeakerLimit: 16,
    };
  },
  computed: {
    breakoutRoomPublished() {
      let result = false;
      result = vm.breakoutRooms.some(function (element) {
        if (element.IsPublished) {
          return true;
        }
      });
      return result;
    },
    isInviteActive() {
      var result = false;
      for (var i = 0; i < vm.currentAttendeeList.length; i++) {
        if (
          vm.currentAttendeeList[i].AttendeeId == vm.uid &&
          (vm.currentAttendeeList[i].InviteRequestStatus ||
            vm.currentAttendeeList[i].InviteAcceptStatus)
        ) {
          result = true;
          break;
        }
      }
      return result;
    },
    isRHInProcess() {
      var result = false;
      for (var i = 0; i < vm.currentAttendeeList.length; i++) {
        if (
          vm.currentAttendeeList[i].AttendeeId == vm.uid &&
          (vm.currentAttendeeList[i].RHRequestStatus ||
            vm.currentAttendeeList[i].RHAcceptStatus)
        ) {
          result = true;
          break;
        }
      }
      return result;
    },
    isRHAccepted() {
      var result = false;
      for (var i = 0; i < vm.currentAttendeeList.length; i++) {
        if (
          vm.currentAttendeeList[i].AttendeeId == vm.uid &&
          vm.currentAttendeeList[i].RHAcceptStatus
        ) {
          result = true;
          break;
        }
      }
      return result;
    },
    showAttendeeRH() {
      var result = true;
      for (var i = 0; i < vm.currentAttendeeList.length; i++) {
        if (vm.currentAttendeeList[i].AttendeeId == vm.uid) {
          if (vm.currentAttendeeList[i].RHAcceptStatus) {
            result = false;
            break;
          } else if (vm.currentAttendeeList[i].InviteRequestStatus) {
            result = false;
            break;
          }
        }
      }
      return result;
    },
    sessionHostSpeakerCount() {
      var result = 0;
      if (vm.session && vm.session.MappedSpeakers) {
        result = vm.session.MappedSpeakers.length;
      }
      return result;
    },
    sessionInvitedAndRHInStageCount() {
      var sessionInvitedAndRHInStage = vm.currentAttendeeList.filter(function (
        item
      ) {
        return (
          (item.RHRequestStatus && item.RHAcceptStatus) ||
          item.InviteRequestStatus
        );
      });
      return sessionInvitedAndRHInStage.length;
    },
    checkSessionTabVisible() {
      let flag = false;
      flag =
        (vm.exPageId == "" || vm.exPageId == "sn") &&
        vm.isSessionTabVisible &&
        vm.callStarted;
      return flag;
    },
    checkMeetingTabVisible() {
      let flag = false;
      flag =
        [6, 7].includes(vm.sessionTypeId) &&
        vm.meetingId &&
        vm.isMeetingTabVisible &&
        vm.callStarted;
      return flag;
    },
    isCurrentUserCoHost: function () {
      let result = false;
      if (vm.uid) {
        result = vm.isUserCoHost(vm.uid);
      }
      return result;
    },

    //isAttendee() {
    //  alert(vm.userType);
    //  return vm.userType == 4;
    //},
    //currentAttendees: function () {
    //  //return vm.sortAttendee();
    //  //alert(attendee.currentAttendees);
    //  //attendee.currentAttendees = attendee.currentAttendees.filter(function (
    //  //  item
    //  //) {
    //  //  return item.AttendeeId != 0;
    //  //});
    //  return attendee.currentAttendees.sort(function (a, b) {
    //    ////
    //    //if (a.Name > b.Name) {
    //    //  return -1;
    //    //}
    //    //return a.Name.toLowerCase() > b.Name.toLowerCase()
    //    //  ? a.Name.toLowerCase() > b.Name.toLowerCase()
    //    //    ? 1
    //    //    : 0
    //    //  : -1;
    //    let v1 = a.Name.toLowerCase();
    //    let v2 = b.Name.toLowerCase();
    //    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
    //    //return a.Name.toLowerCase() > b.Name.toLowerCase();
    //  });
    //  //return attendee.currentAttendees;
    //},
    activePollList: function () {
      return vm.pollQuestionList.filter(function (u) {
        return u.isActive;
      });
    },
    //userType
    myPollList: function () {
      return vm.pollQuestionList;
    },
    nextPoll: function () {
      var poll;
      var flag = false;
      for (var i = 0; i < vm.pollQuestionList.length; i++) {
        if (!flag) {
          if (vm.pollQuestionList[i].QuesID == vm.currentPoll) {
            flag = true;
          }
        } else if (flag) {
          if (
            vm.pollQuestionList[i].isActive &&
            !vm.pollQuestionList[i].IsSubmitted
          ) {
            poll = vm.pollQuestionList[i];
            break;
          }
        }
      }
      return poll;
    },
    currentAttendees: function () {
      //return vm.sortAttendee();
      //alert(attendee.currentAttendees);
      //attendee.currentAttendees = attendee.currentAttendees.filter(function (
      //  item
      //) {
      //  return item.AttendeeId != 0;
      //});
      //alert(vm.currentAttendeeList.length);
      let attendeeList = vm.currentAttendeeList.sort(function (a, b) {
        ////
        //if (a.Name > b.Name) {
        //  return -1;
        //}
        //return a.Name.toLowerCase() > b.Name.toLowerCase()
        //  ? a.Name.toLowerCase() > b.Name.toLowerCase()
        //    ? 1
        //    : 0
        //  : -1;
        let v1 = a.Name.toLowerCase().trim();
        let v2 = b.Name.toLowerCase().trim();
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
        //return a.Name.toLowerCase() > b.Name.toLowerCase();
      });
      if (this.attendeeSearchTxt) {
        var searchText = this.attendeeSearchTxt.toLowerCase().trim();
        if (this.attendeeSearchTxt != "") {
          attendeeList = attendeeList.filter((attendee) => {
            return attendee.Name.toLowerCase().trim().includes(searchText);
          });
        }
      }
      return attendeeList;
    },
    currentRHAttendees: function () {
      let attendeeList = vm.currentAttendeeList.filter(function (item) {
        return item.RHRequestStatus;
      });
      let attendeeList1 = attendeeList.filter(function (item) {
        return item.RHRequestStatus && !item.RHAcceptStatus;
      });
      vm.unreadRaiseHandCount = attendeeList1.length;
      // let attendeeList = attendeeList.sort(function (a, b) {
      //   let v1 = a.Name.toLowerCase().trim();
      //   let v2 = b.Name.toLowerCase().trim();
      //   return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      // });
      // if (this.attendeeSearchTxt) {
      //   var searchText = this.attendeeSearchTxt.toLowerCase().trim();
      //   if (this.attendeeSearchTxt != "") {
      //     attendeeList = attendeeList.filter((attendee) => {
      //       return attendee.Name.toLowerCase().trim().includes(searchText);
      //     });
      //   }
      // }
      return attendeeList;
    },
    currentSpeakers: function () {
      let speakers = [];
      //alert(vm.allSpeakers.length);
      //alert(vm.allSpeakers);
      //alert(vm.allHosts.length);
      //alert(vm.sessionTypeId);
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        speakers = vm.allSpeakers.filter(function (item) {
          item.NameInitial = common.getInitials(item.Name);
          return item.AttendeeId != "";
        });
        speakers = speakers.sort(function (a, b) {
          let v1 = a.Name.toLowerCase();
          let v2 = b.Name.toLowerCase();
          return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
        });
        //alert("currentSpeakers:" + speakers.length);
        vm.currentGuestList.forEach(function (item) {
          let flag = false;

          speakers.forEach(function (speaker) {
            if (speaker.AttendeeId == item.AttendeeId) {
              flag = true;
              //alert(flag);
            }
          });
          if (!flag) {
            item.NameInitial = common.getInitials(item.Name);
            speakers.push(item);
          }
        });
        //alert(speakers.length);
        if (vm.allHosts.length > 0) {
          speakers.unshift(vm.allHosts[0]);
        }
      } else if ([1, 2, 3, 5, 6, 7, 100].includes(vm.sessionTypeId)) {
        //alert(vm.hostId);
        let host = vm.allSpeakers.filter(function (item) {
          item.NameInitial = common.getInitials(item.Name);
          return item.AttendeeId == vm.hostId;
        });
        speakers = vm.allSpeakers.filter(function (item) {
          item.NameInitial = common.getInitials(item.Name);
          return item.AttendeeId != vm.hostId;
        });
        speakers = speakers.sort(function (a, b) {
          let v1 = a.Name.toLowerCase();
          let v2 = b.Name.toLowerCase();
          return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
        });
        if (host.length > 0) {
          speakers.unshift(host[0]);
        }
      }
      speakers = speakers.filter(function () {
        return true;
      });
      return speakers;
    },
    qnaList() {
      let allQnAs = [];
      if (vm.isQnAPanelOpend) {
        qna.allQnAs.map(function (item) {
          item.read = true;
        });
      } else {
        let qnas = qna.allQnAs.filter(function (item) {
          return !item.read;
        });
        vm.unreadQnACount = qnas.length;
      }
      if (vm.qnaActiveTabIndex == 0) {
        allQnAs = qna.allQnAs.sort(function (a, b) {
          let v1 = a.CreatedDateS;
          let v2 = b.CreatedDateS;
          return v1 > v2 ? -1 : v1 < v2 ? 1 : 0;
        });
      } else if (vm.qnaActiveTabIndex == 1) {
        allQnAs = qna.allQnAs.sort(function (a, b) {
          let v1 = a.TotalLikes;
          let v2 = b.TotalLikes;
          return v1 > v2 ? -1 : v1 < v2 ? 1 : 0;
        });
      }
      //let allQnAs = qna.allQnAs.filter(function (item) {
      //  return item.QnAId;
      //});
      return allQnAs;
    },

    currentTabSessions() {
      //alert(vm.selectedAgendaType);
      vm.currentSessionElementId = "";
      let sessionList = [];
      //if (vm.sessionId != "") {
      //alert(vm.sessionId);
      //alert(this.allSessions.length);
      //vm.agendaFilterOption
      let dtt = new Date();
      var dtYear = dtt.getFullYear();
      var dtMonth = dtt.getMonth();
      var dtDay = dtt.getDate();
      let startTime = new Date(dtYear, dtMonth, dtDay).getTime() / 1000;
      let endTime = new Date(dtYear, dtMonth, dtDay);
      endTime.setDate(endTime.getDate() + 1);
      endTime = endTime.getTime() / 1000;
      //alert(startTime);
      //alert(endTime);
      //alert(vm.exPageId);
      //alert(vm.mySessions.length);
      this.allSessions.forEach(function (item) {
        let flag = true;
        //alert(vm.sessionId);
        if (
          (vm.agendaFilterOption == 1 || vm.agendaFilterOption == 2) &&
          vm.selectedAgendaType == 1
        ) {
          flag = false;
          if (vm.mySessions.includes(item.SessionId)) {
            flag = true;
          }
        }
        if (flag) {
          //if (
          //  vm.exPageId == "" ||
          //  (item.StartTime < startTime && item.EndTime > endTime) ||
          //  (item.StartTime >= startTime && item.StartTime <= endTime) ||
          //  (item.EndTime >= startTime && item.EndTime <= endTime)
          //)
          if (
            (item.StartTime < startTime && item.EndTime > endTime) ||
            (item.StartTime >= startTime && item.StartTime <= endTime) ||
            (item.EndTime >= startTime && item.EndTime <= endTime)
          ) {
            item.SelectedSessionClass = "";
            if (vm.sessionId == item.SessionId) {
              item.SelectedSessionClass = "live-session-right";
              vm.currentSessionElementId = "rp_session_" + item.SessionId;
            }

            var currentTime = parseInt(new Date().getTime() / 1000);
            item.IsLive = false;
            if (currentTime < item.StartTime) {
              item.LinkClass = "upcoming-status";
              item.StatusDisplayText = "Upcoming";
              item.StatusClass = "upcoming-session-indicate";
            } else if (
              currentTime > item.StartTime &&
              currentTime < item.EndTime
            ) {
              item.IsLive = true;
              item.StatusDisplayText = "Live";
              item.StatusClass = "live-session-indicate";
              item.LinkClass = "ongoing-status";
            } else if (currentTime > item.EndTime) {
              item.StatusDisplayText = "Session Ended";
              item.StatusClass = "end-session-indicate";
              item.LinkClass = "finish-status";
            }

            sessionList.push(item);
          }
        }
      });
      //}
      return sessionList;
    },
  },
  watch: {
    callStarted(val) {
      if (!val) {
        chat.allChats = [];
        qna.allQnAs = [];
      }
    },
    "chat.unreadChatCount": function (val) {
      vm.$emit("unreadChatCountChanged", val);
    },
    unreadQnACount: function (val) {
      vm.$emit("unreadQnACountChanged", val);
    },
    currentSessionElementId: function () {
      if (vm.currentSessionElementId != "") {
        const el = document.getElementById(vm.currentSessionElementId);
        if (el) {
          el.scrollIntoView(false);
        }
      }
    },
    isFullScreen: function (val) {
      console.log(val);
    },
    //isAttendee() {
    //  return vm.userType != 4;
    //},
    //"broadcastSettings.SpeakerInfoEnabled": function (val) {
    //  vm.updateRightPanelSettings("SpeakerInfoEnabled", val);
    //},
    "broadcastSettings.AttendeeEnabled": function (val) {
      //vm.updateRightPanelSettings("AttendeeEnabled", val);
      vm.$emit("AttendeeEnabled", val);
    },
    //"broadcastSettings.QnAEnabled": function (val) {
    //  vm.updateRightPanelSettings("QnAEnabled", val);
    //},
    //"broadcastSettings.ChatEnabled": function (val) {
    //  vm.updateRightPanelSettings("ChatEnabled", val);
    //},
    //"broadcastSettings.RaiseHandEnabled": function (val) {
    //  vm.updateRightPanelSettings("RaiseHandEnabled", val);
    //},
    volumeLevel: function () {
      ////alert("volumeLevel");
      ////alert(vm.volumeLevel);
      ////return vm.volumeLevel;
      //vm.volumeLevel = parseInt(vm.volumeLevel);
      //if (vm.volumeLevel == 100) {
      //  vm.volumeLevelClass = "volume-full";
      //} else if (vm.volumeLevel < 100 && vm.volumeLevel >= 50) {
      //  vm.volumeLevelClass = "volume-mid";
      //} else if (vm.volumeLevel < 50 && vm.volumeLevel > 0) {
      //  vm.volumeLevelClass = "volume-low";
      //} else {
      //  vm.volumeLevelClass = "volume-off";
      //}
      //vm.$emit("volumeChanged", vm.volumeLevel);
      ////vm.volumeChanged();
    },
    isQnAPanelOpend: function (val) {
      qna.isQnAPanelOpend = val;
    },
    isChatPanelOpend: function (val) {
      chat.isChatPanelOpend = val;
    },
    isSessionTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_session").removeClass("active");
        $("#tab_session").removeClass("active");
        $("#tab_session").addClass("d-none");
        vm.isSessionListPanelOpend = false;
      }
    },
    isMeetingTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_meeting").removeClass("active");
        $("#tab_meeting").removeClass("active");
        $("#tab_meeting").addClass("d-none");
        vm.isMeetingListPanelOpend = false;
      }
    },
    isSpeakerTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_speaker").removeClass("active");
        $("#tab_speaker").removeClass("active");
        $("#tab_speaker").addClass("d-none");
        vm.isSpeakerPanelOpend = false;
      }
    },
    isAttendeeTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_attendee").removeClass("active");
        $("#tab_attendee").removeClass("active");
        $("#tab_attendee").addClass("d-none");
        vm.isAttendeePanelOpend = false;
      }
    },
    isQnATabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_qa").removeClass("active");
        $("#tab_qa").removeClass("active");
        $("#tab_qa").addClass("d-none");
        vm.isQnAPanelOpend = false;
      }
    },
    isChatTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_message").removeClass("active");
        $("#tab_message").removeClass("active");
        $("#tab_message").addClass("d-none");
        vm.isChatPanelOpend = false;
      }
    },
    isRaiseHandTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_raise_hand").removeClass("active");
        $("#tab_raise_hand").removeClass("active");
        $("#tab_raise_hand").addClass("d-none");
        vm.isRaiseHandPanelOpend = false;
      }
    },
    isBreakoutRoomTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_breakout_room").removeClass("active");
        // $("#tab_breakout_room").removeClass("active");
        // $("#tab_breakout_room").addClass("d-none");
        vm.isBreakoutRoomPanelOpend = false;
      }
    },
    // isBreakoutRoomPanelOpend: function () {
    //   vm.breakoutRoomsKey++;
    // },
    isPollTabVisible: function (val) {
      if (!val) {
        $(".right-icon-pannel li#btn_Poll").removeClass("active");
        $("#tab_poll").removeClass("active");
        $("#tab_poll").addClass("d-none");
        vm.isPollPanelOpend = false;
      }
    },
    //settingsIsOpened: function () {
    //  alert(vm.showSettings);
    //  return vm.showSettings;
    //},
    //"chatVars.allChats": function () {
    //  //
    //  alert("chatVars");
    //},
    "chat.allChats": function () {
      //alert("chat.allChats: " + chat.unreadChatCount);
      //vm.chat.allChats = vm.chat.allChats.filter((item) => {
      //  return true;
      //});
      //
      //alert("chat");
      //var container = document.querySelector(".tab-content");
      //if (container) {
      //  alert(container.scrollHeight);
      //  container.scrollTop = container.scrollHeight;
      //}
      if (chat.NewChat) {
        chat.NewChat = false;
        setTimeout(() => {
          vm.scrollChatToBottom();
        }, 1000);
      }
    },
    "qna.allQnAs": function () {
      //
      //alert("chat");
      //var container = document.querySelector(".tab-content");
      //if (container) {
      //  alert(container.scrollHeight);
      //  container.scrollTop = container.scrollHeight;
      //}
      //setTimeout(() => {
      //  vm.scrollQnAToBottom();
      //}, 1000);
    },
    "chat.oldChatLoaded": function () {
      //setTimeout(() => {
      //  vm.scrollChatToBottom();
      //}, 1000);
    },
    //"attendee.currentAttendees": function () {
    //  //vm.sortAttendee();
    //  //alert("attendee");
    //  //var container = document.querySelector(".tab-content");
    //  //if (container) {
    //  //  alert(container.scrollHeight);
    //  //  container.scrollTop = container.scrollHeight;
    //  //}
    //  //setTimeout(() => {
    //  //  vm.scrollChatToBottom();
    //  //}, 100);
    //  //alert("currentAttendees");
    //},
    //"attendee.currentAttendeeCount": function (val) {
    //  //alert(val);
    //  if (val < 0) {
    //    val = 0;
    //  }
    //  //$("#spanAttendeeCount").text(val);
    //  //alert("attendee");
    //  //var container = document.querySelector(".tab-content");
    //  //if (container) {
    //  //  alert(container.scrollHeight);
    //  //  container.scrollTop = container.scrollHeight;
    //  //}
    //  //setTimeout(() => {
    //  //  vm.scrollChatToBottom();
    //  //}, 100);
    //},
    agendaFilterOption: function (val) {
      if (val) {
        //alert(val);
        vm.prepareMySession();
      }
    },
    "broadcastSettings.SpeakerInfoEnabled": function (val) {
      if (vm.userType < 3 || val) {
        $("#divLivePanelContainer").addClass("speaker-enabled");
      } else {
        $("#divLivePanelContainer").removeClass("speaker-enabled");
      }
    },
    userType: function (val) {
      if (val < 3 || vm.broadcastSettings.SpeakerInfoEnabled) {
        $("#divLivePanelContainer").addClass("speaker-enabled");
      } else {
        $("#divLivePanelContainer").removeClass("speaker-enabled");
      }
    },
  },
  created() {
    vm = this;
    navigator.mediaDevices.enumerateDevices().then(vm.gotDevices);
    let myApp = window.localStorage.getItem("my-app");
    myApp = myApp == undefined ? "" : myApp;
    myApp = myApp == null ? "" : myApp;
    var obj = JSON.parse(myApp);
    if (obj) {
      vm.event_collectionName = obj.eventcollectionname;
      if(!vm.event_collectionName){
        vm.event_collectionName = vm.dialogEventCollectionName
      }
      if (obj.user && obj.user.length > 0) {
        vm.uid = obj.user[0].id;
        vm.name = obj.user[0].name;
      }
      vm.prepareSessionList();
      //vm.prepareMySession();
    }
  },
  mounted() {
    $(".disable-action").tooltip();
  },
  beforeUpdate() {
    //alert(vm.playersettings.videoProfile);
  },
  beforeDestroy() {
    //alert("beforeDestroy:RightPanel");
    //window.removeEventListener("beforeunload", this.beforeWindowUnload);
    if (pollPublishListener) {
      pollPublishListener();
    }
    if (pollRessultInterval) {
      clearInterval(pollRessultInterval);
    }
    if (roomClosingInterval) {
      clearInterval(roomClosingInterval);
      roomClosingInterval = null;
    }
    if (breakoutRoomListener) {
      breakoutRoomListener();
    }
    if (volumeOffTimr) {
      clearInterval(volumeOffTimr);
    }
    vm.notifyVolumeOff = false;
  },
  methods: {
    OpenBreakoutPopup() {
      vm.breakoutRoomsKey++;
      vm.isBreakoutRoomPanelOpend = true;
    },
    getHeight() {
      return common.getHeaderHeight(vm.roomId != "");
    },
    onVolumeButtonHover() {
      //alert();
      $("#volumeRange").addClass("full-length");
      $("#volumeRange").removeClass("d-none");
    },
    onVolumeButtonLeave() {
      //alert();
      $("#volumeRange").removeClass("full-length");
      $("#volumeRange").addClass("d-none");
    },
    startMeeting(meetingId) {
      //alert("RP:" + meetingId);
      vm.meetingId = meetingId;
      vm.$emit("startMeeting", meetingId);
    },
    setNextMeetingData(meetingId, meeting) {
      //alert("RP:" + meetingId);
      if (vm.sessionTypeId == 6) {
        vm.$emit("setNextMeetingData", meetingId, meeting);
      }
    },
    startSession(
      sessionId,
      isLive,
      sessionTypeId,
      inPersonURL,
      interactWithAudience
    ) {
      vm.tempInteractWithAudience = false;

      let flag = true;
      let sessions = vm.allSessions.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (sessions.length > 0) {
        let session = sessions[0];
        if (session.SessionTypeDetails.TypeID == 3) {
          if (
            session.StreamingClient &&
            session.StreamingClient.trim().toLowerCase() == "zoom" &&
            session.IsZoomRTMP
          ) {
            flag = false;
          }
        }
      }

      if ((vm.sessionId != sessionId || !flag) && isLive) {
        $("#rp_session_" + sessionId + " .on-demand-dropdown").addClass(
          "d-none"
        );
        if (sessionTypeId == 5) {
          if (inPersonURL) {
            window.open(inPersonURL, "_blank");
          }
        } else {
          if (vm.sessionId == "" || !vm.callStarted) {
            vm.sessionId = sessionId;
            vm.$emit("startSession", sessionId);
          } else {
            if (flag) {
              vm.tempSessionId = sessionId;
              vm.tempInteractWithAudience = interactWithAudience;
              $("#sessionSwitchConfirmPopup").modal(
                { backdrop: "static" },
                "show"
              );
            } else {
              vm.$emit("startSession", sessionId);
            }
          }
        }
      }
    },
    joinSession() {
      $("#sessionSwitchConfirmPopup").modal("hide");
      vm.sessionId = vm.tempSessionId;
      vm.$emit("startSession", vm.tempSessionId, vm.tempInteractWithAudience);
    },
    joinSessionCancel() {
      $("#sessionSwitchConfirmPopup").modal("hide");
    },
    startInteractionWithAudience(sessionId) {
      //$(".tooltip").tooltip("hide");
      //$(".modal").modal("hide");
      $("#rp_session_" + sessionId + " .on-demand-dropdown").addClass("d-none");
      if (sessionId) {
        window.open(location.origin + vm.stageUrl + "/" + sessionId, "_blank");
      }
    },
    openSpeakerPanel(uid) {
      console.log(uid);
      //vm.toogleRightPanel("speaker");
      //if ($("#tab_speaker").hasClass("d-none")) {
      //  //$("#tab_speaker").removeClass("d-none");
      //  vm.isSpeakerPanelOpend = false;
      //  //setTimeout(() => {
      //  //  vm.$emit("openSpeakerPanel", uid);
      //  //}, 1000);
      //}
      if ($("#tab_speaker").hasClass("d-none")) {
        vm.toggleSpeakerTab();
      }
      $("#speaker-area-wrap .single-feature-question").removeClass(
        "selected-speaker-right"
      );
      $(
        "#speaker-area-wrap #rp_speaker_" + uid + ".single-feature-question"
      ).addClass("selected-speaker-right");
      vm.scrollSpeakerToCurrent(uid);
    },
    openAttendeePanel() {
      vm.toggleAttendeeTab();
    },
    setPlayerFullScreen() {
      //vm.isFullScreen = true;
      //alert(vm.isFullScreen);
      //if (!vm.isFullScreen) {
      //  //vm.isFullScreen = false;
      //  vm.resizePlayer();
      //}
    },
    resizePlayer(isManual) {
      //alert(vm.isFullScreen);
      if (!isManual) {
        isManual = false;
      }
      if (vm.isFullScreen) {
        vm.isFullScreen = false;

        //vm.AdjustPlayeHeight();
        //vm.closeFullscreen();
      } else {
        vm.isFullScreen = true;
        //vm.AdjustPlayeHeight();
        //if (isManual) {
        //  vm.openFullscreen();
        //}
      }
      vm.$emit("resizePlayer", isManual);
    },
    openFullscreen() {
      let elem = document.getElementById("vueplayer");
      ///let elem = document.getElementById("LiveStage");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    IsFullScreenCurrently() {
      var full_screen_element =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement ||
        null;

      // If no element is in full-screen
      if (full_screen_element === null) {
        //alert("FULL SCREEN");
        return false;
      } else {
        //alert("SCREEN");
        return true;
      }
    },
    AdjustPlayeHeight() {
      if (!vm.isFullScreen) {
        $("#app").removeClass("player-full-screen");
        if ($("#topmenu")) {
          $("#topmenu").removeClass("d-none");
        }
        if ($("#leftMenuParent")) {
          $("#leftMenuParent").removeClass("d-none");
        }
        if ($("#leftmenu")) {
          $("#leftmenu").hide();
        }
      } else {
        $("#app").addClass("player-full-screen");
        if ($("#topmenu")) {
          $("#topmenu").addClass("d-none");
        }
        if ($("#leftMenuParent")) {
          $("#leftMenuParent").addClass("d-none");
        }
        if ($("#leftmenu")) {
          $("#leftmenu").hide();
        }
      }
    },
    gotDevices(deviceInfos) {
      vm.altSpeakerList = [];
      for (let i = 0; i !== deviceInfos.length; ++i) {
        let deviceInfo = deviceInfos[i];
        //vm.altSpeaker = deviceInfo.deviceId;
        //alert(deviceInfo.deviceId);
        if (deviceInfo.kind === "audiooutput") {
          let device = {
            deviceId: deviceInfo.deviceId,
            groupId: deviceInfo.groupId,
            kind: deviceInfo.kind,
            label: deviceInfo.label,
          };
          if (vm.altSpeaker == null) {
            vm.altSpeaker = device;
          }
          vm.altSpeakerList.push(device);
        } else {
          //console.log("Found non audio output device: ", deviceInfo.label);
        }
      }
    },
    gotDevices1(deviceInfos) {
      let masterOutputSelector = document.createElement("select");

      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        const option = document.createElement("option");
        option.value = deviceInfo.deviceId;
        if (deviceInfo.kind === "audiooutput") {
          console.info("Found audio output device: ", deviceInfo.label);
          option.text =
            deviceInfo.label || `speaker ${masterOutputSelector.length + 1}`;
          masterOutputSelector.appendChild(option);
        } else {
          console.log("Found non audio output device: ", deviceInfo.label);
        }
      }
    },
    changePollCreateOption(option) {
      if (option == 1) {
        vm.pollCreateOption = option;
        $("#dvOptioninfo").hide();
        $("#multiple-choice").show();
        $("#lblQuestion").focus();
      } else {
        vm.pollCreateOption = option;
        //$("#lblOpenQuestion").text('aaa')
        setTimeout(() => {
          $("#lblOpenQuestion").focus();
        }, 300);

        $("#dvOpenOptioninfo").hide();
        $("#multiple-choice").hide();
      }
    },
    clearOption() {
      //$("#lblOptions").val("");
      vm.pollOption = "";
    },
    AddOptions(isCreatingPoll) {
      let addResult = false;
      $("#dvOptioninfo").hide();
      var val = $("#lblOptions").val();
      if (val) {
        val = val.trim();
      }
      if (val !== "") {
        let duplicateOptions = vm.OptionList.filter(function (item) {
          return item == val;
        });
        if (duplicateOptions.length > 0) {
          $("#dvOptioninfo").show();
          $("#dvOptionmsg").text("Duplicate option is not allowed.");
          $("#lblOptions").focus();
          return false;
        }
        // var strHtml =
        //   "<li>" +
        //   '<label class="container-vote-ans"><input type="radio" name="radio"><span class="checkmark-vote-ans"></span><input type="text" class="option-field quesOpt" value="' +
        //   val +
        //   '"></label></li>';
        vm.OptionList.push(val);
        //alert(vm.OptionList.length);
        addResult = true;
        //$("#ulOption").append(strHtml);
        if (vm.OptionList.length < 4) {
          vm.pollOption = "";
          //$("#lblOptions").val("");
          $(".liadd").show();
          $("#lblOptions").focus();
          $("#dvOptioninfo").hide();
          $("#imgAddOption").show();
        } else {
          //$("#dvOptioninfo").show();
          vm.pollOption = "";
          //("#lblOptions").val("");
          //$("#dvOptionmsg").text("Poll should have maximum four options.");
          $(".liadd").hide();
          $("#imgAddOption").hide();
        }
      } else {
        if (!isCreatingPoll) {
          $("#dvOptioninfo").show();
          $("#dvOptionmsg").text(
            "Poll can not be created without Options. Minimum 2 and Maximum 4 options are allowed."
          );
          $("#lblOptions").focus();
        } else {
          addResult = true;
        }
      }
      return addResult;
    },

    DeleteOptions(index) {
      vm.OptionList.splice(index, 1);
      $("#lblOptions").val("");
      $(".liadd").show();
      $("#lblOptions").focus();
      $("#dvOptioninfo").hide();
      $("#imgAddOption").show();
    },
    DeleteBeforeAdd() {
      $("#lblOptions").val("");
      $(".liadd").show();
      $("#lblOptions").focus();
      $("#imgAddOption").show();
    },
    clicklaunch() {
      if (vm.pollCreateOption == 1) {
        if (vm.AddOptions(true)) {
          vm.SaveMultiChoice();
        }
      } else {
        vm.SaveOpenChoice();
      }
    },
    SaveMultiChoice() {
      if ($("#lblQuestion").text() !== "") {
        //if ($(".quesOpt").length > 1) {
        if (vm.OptionList.length > 1) {
          //alert($('.quesOpt').length);
          var pollStructure = [];
          var arroptions = [];

          //$(".quesOpt").each(function () {
          //  if ($(this).val() !== "") {
          //    arroptions.push({
          //      checked: false,
          //      label: $(this).val(),
          //    });
          //  }
          //});
          vm.OptionList.map(function (item) {
            if (item !== "") {
              arroptions.push({
                checked: false,
                label: item,
              });
            }
          });

          if (arroptions.length < 2) {
            $("#dvOptioninfo").show();
            $("#dvOptionmsg").text(
              "Poll can not be created without Options. Minimum 2 and Maximum 4 options are allowed."
            );
            return false;
          }

          if (arroptions.length > 4) {
            //alert("Poll should have maximum four options.");
            $("#dvOptioninfo").show();
            $("#dvOptionmsg").text("Poll should have maximum four options.");
            return false;
          }
          var docid = vm.uuidv4();
          pollStructure.push({
            label: $("#lblQuestion").text(),
            cid: vm.uuidv4(),
            field_type: "checkboxes",
            isActive: false,
            userid: vm.uid,
            LastModifiedDate: new Date(),
            field_options: {
              include_other_option: false,
              description: "",
              options: arroptions,
            },
            required: true,
          });
          vm.saveForm(pollStructure, docid);
        } else {
          $("#dvOptioninfo").show();
          $("#dvOptionmsg").text(
            "Poll can not be created without Options. Minimum 2 and Maximum 4 options are allowed."
          );
          $("#lblOptions").focus();
        }
      } else {
        $("#dvOptioninfo").show();
        $("#dvOptionmsg").text(
          "Please add Question and options to create poll"
        );
        $("#lblQuestion").focus();
        //alert("");
      }
    },
    saveForm: function (formJson, docid) {
      var sessionMapping = [];
      sessionMapping.push({
        EndDate: vm.session.EndTimeS,
        Name: vm.session.Name,
        Selected: true,
        SessionId: vm.session.SessionId,
        StartDate: vm.session.StartTimeS,
      });
      var FormId = vm.session.SessionId;
      // var docid = db
      //   .collection(obj.eventcollectionname)
      //   .doc("FormList")
      //   .collection("Forms")
      //   .doc(FormId).collection(vm.session.SessionId).document().getId();
      var docRef = db
        .collection(vm.event_collectionName)
        .doc("FormList")
        .collection("Forms")
        .doc(FormId)
        .collection("PollForms")
        .doc(docid);
      docRef
        .get()
        .then(function (doc) {
          if (!doc.exists) {
            var docObj = new Object();
            docObj.FormId = FormId;
            docObj.FormType = 1;
            docObj.MapTo = 2;
            docObj.FormTitle = "PollForm";
            docObj.FormJson = formJson;
            docObj.SubmitButtonText = "Submit";
            docObj.AllowMultipleSubmission = false;
            docObj.AllowEditAfterSubmission = false;
            docObj.CreatedDate = new Date();
            docObj.LastModifiedDate = new Date();
            docObj.isPublished = true;
            if (
              docObj.FormType == 1 ||
              (docObj.FormType == 2 && docObj.MapTo == 2)
            ) {
              docObj.Mapping = sessionMapping;
            } else if (docObj.FormType == 2 && docObj.MapTo == 1) {
              docObj.Mapping = [];
            } else if (docObj.FormType == 3) {
              docObj.Mapping = [];
            }

            db.collection(vm.event_collectionName)
              .doc("FormList")
              .collection("Forms")
              .doc(FormId)
              .collection("PollForms")
              .doc(docid)
              .set(docObj)
              .then(function () {
                //$("#tab_poll").addClass("d-none");
                //vm.isPollPanelOpend = true;
                //vm.isCreatePollVisible = false;
                vm.showpoll();

                //alert("Poll created Successfully");
              })
              .catch(function (error) {
                console.error("Error creating Form: ", error);
              });
          } else {
            var frmJson = doc.data().FormJson;
            frmJson.push(...formJson);
            db.collection(vm.event_collectionName)
              .doc("FormList")
              .collection("Forms")
              .doc(FormId)
              .collection("PollForms")
              .doc(docid)
              .update({
                FormJson: frmJson,
              })
              .then(function () {
                vm.showpoll();
                //alert("Poll created Successfully");
              })
              .catch(function (error) {
                console.error("Error updating Form: ", error);
              });
          }
        })
        .catch(function (error) {
          console.log("Error saving Form:", error);
        });
    },
    saveForm1: function (formJson, docid) {
      var sessionMapping = [];
      sessionMapping.push({
        EndDate: vm.session.EndTimeS,
        Name: vm.session.Name,
        Selected: true,
        SessionId: vm.session.SessionId,
        StartDate: vm.session.StartTimeS,
      });
      var docObj = new Object();
      docObj.FormId = vm.session.SessionId;
      docObj.DocId = docid;
      docObj.FormType = 1;
      docObj.MapTo = 2;
      docObj.FormTitle = "PollForm";
      docObj.FormJson = formJson;
      docObj.SubmitButtonText = "Submit";
      docObj.AllowMultipleSubmission = false;
      docObj.AllowEditAfterSubmission = false;
      docObj.CreatedDate = new Date();
      docObj.LastModifiedDate = new Date();
      docObj.isPublished = true;
      if (docObj.FormType == 1 || (docObj.FormType == 2 && docObj.MapTo == 2)) {
        docObj.Mapping = sessionMapping;
      } else if (docObj.FormType == 2 && docObj.MapTo == 1) {
        docObj.Mapping = [];
      } else if (docObj.FormType == 3) {
        docObj.Mapping = [];
      }

      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
          sessionId: vm.session.SessionId,
          docid: docid,
        },
        data: docObj,
      };
      axios
        .post(APIs.CreatePoll, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          console.log(responseData);
          vm.showpoll();
          //if (
          //  responseData &&
          //  responseData.data &&
          //  responseData.data.status == 0 &&
          //  responseData.data.sessions
          //) {
          //  responseData.data.sessions.map(function (item) {
          //    vm.mySessions.push(item.SessionId);
          //  });
          //}
          //vm.mySessionsLoaded = true;
        })
        .catch((error) => {
          console.log(error);
          vm.mySessionsLoaded = true;
        });
    },
    ActivateQuestion: function (QuesID, surveyID) {
      var FormId = vm.session.SessionId;
      var docRef = db
        .collection(vm.event_collectionName)
        .doc("FormList")
        .collection("Forms")
        .doc(FormId)
        .collection("PollForms")
        .doc(surveyID);
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            var frmJson = doc.data().FormJson;
            var index = frmJson.findIndex((p) => p.cid == QuesID);
            if (frmJson[index].isActive == false) {
              frmJson[index].isActive = true;
              frmJson[index].LastModifiedDate = new Date();
            } else {
              frmJson[index].isActive = false;
            }

            db.collection(vm.event_collectionName)
              .doc("FormList")
              .collection("Forms")
              .doc(FormId)
              .collection("PollForms")
              .doc(surveyID)
              .update({
                FormJson: frmJson,
              })
              .then(function () {
                console.log("Form Updated : " + FormId);
              })
              .catch(function (error) {
                console.error("Error updating Form: ", error);
              });
          }
        })
        .catch(function (error) {
          console.log("Error saving Form:", error);
        });
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    SaveOpenChoice() {
      if ($("#lblOpenQuestion").text() !== "") {
        var pollStructure = [];
        var docid = vm.uuidv4();
        pollStructure.push({
          label: $("#lblOpenQuestion").text(),
          cid: vm.uuidv4(),
          field_type: "text",
          LastModifiedDate: new Date(),
          field_options: {
            description: "",
          },
          required: true,
          isActive: false,
          userid: vm.uid,
        });
        $("#dvOpenOptioninfo").hide();
        vm.saveForm(pollStructure, docid);
        //console.log("OpenQuestion");
      } else {
        $("#dvOpenOptioninfo").show();
        $("#dvOpenOptionmsg").text("Please add Question to create poll");
        $("#lblOpenOptions").focus();
      }
    },
    // deletePoll(QuesID,sessionId)
    // {
    //    var docRef = db
    //     .collection(obj.eventcollectionname)
    //     .doc("FormList")
    //     .collection("Forms")
    //     .doc(sessionId)
    //     .collection("PollForms").doc();
    //   docRef.delete().then(() => {
    //       console.log("Document successfully deleted!");
    //   }).catch((error) => {
    //       console.error("Error removing document: ", error);
    //   });
    // },
    getPollQuestion(userType, sessionId) {
      vm.pollQuestionList = [];
      if (pollPublishListener) {
        pollPublishListener();
      }
      console.log("selectsessionID : " + sessionId);

      let firstLoad = true;
      var docRef = db
        .collection(vm.event_collectionName)
        .doc("FormList")
        .collection("Forms")
        .doc(sessionId)
        .collection("PollForms");
      pollPublishListener = docRef.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        //var isflag = false;
        var activeCount = 0;
        //var activeQuestionId = "";

        var activeQuestionId = "";
        var activeQuestionFieldType = "";
        var activeQuestionSurveyID = "";
        changes.forEach(function (change) {
          let data = change.doc.data();
          var fields = data.FormJson;
          //if (fields[0].isActive) {
          //  isflag = fields[0].isActive;
          //}
          if (fields.length > 0) {
            var i;
            for (i = 0; i < fields.length; ++i) {
              if (fields[i].userid) {
                let Qs = vm.pollQuestionList.filter(function (item) {
                  return item.SurveyID == change.doc.id;
                });
                if (Qs.length == 0) {
                  if (fields[i].isActive && fields[i].userid != vm.uid) {
                    activeCount++;
                    activeQuestionId = fields[i].cid;
                    activeQuestionFieldType = fields[i].field_type;
                    activeQuestionSurveyID = change.doc.id;
                  }
                  vm.pollQuestionList.push({
                    QuesID: fields[i].cid,
                    Question: fields[i].label,
                    Options: fields[i].field_options.options,
                    fieldtype: fields[i].field_type,
                    isActive: fields[i].isActive,
                    SurveyID: change.doc.id,
                    UserID: fields[i].userid,
                    LastPublishedAt: fields[i].LastModifiedDate.seconds,
                    IsSubmitted: false,
                    IsSubmitting: false,
                    vote: [],
                    tagData: [],
                    totVote: 0,
                  });
                } else {
                  if (fields[i].isActive && fields[i].userid != vm.uid) {
                    activeCount++;
                    activeQuestionId = fields[i].cid;
                    activeQuestionFieldType = fields[i].field_type;
                    activeQuestionSurveyID = change.doc.id;
                  }
                  Qs[0].isActive = fields[i].isActive;
                  Qs[0].LastPublishedAt = fields[i].LastModifiedDate.seconds;
                }
              }
              console.log(vm.pollQuestionList);
            }
          }
        });
        //let activeList = vm.pollQuestionList.filter(function (item) {
        //  return item.isActive;
        //});
        //if (activeList.length > 0 && isflag) {
        //  if (activeList.length == 1) {
        //    //var ind = vm.pollQuestionList.findIndex((o) => o.isActive === true);
        //    //vm.showVotingOption(
        //    //  vm.pollQuestionList[ind].QuesID,
        //    //  vm.pollQuestionList[ind].fieldtype,
        //    //  vm.pollQuestionList[ind].SurveyID
        //    //);
        //  } else {
        //    //vm.showVotingOption(
        //    //  activeList[0].QuesID,
        //    //  activeList[0].fieldtype,
        //    //  activeList[0].SurveyID
        //    //);
        //  }
        //}

        var actPoll = vm.pollQuestionList.filter(function (u) {
          return u.isActive;
        });
        actPoll = actPoll.sort(function (a, b) {
          return b.LastPublishedAt - a.LastPublishedAt;
        });
        var myPoll = vm.pollQuestionList.filter((u) => {
          return u.UserID.includes(vm.uid) && !u.isActive;
        });
        myPoll = myPoll.sort(function (a, b) {
          return b.LastPublishedAt - a.LastPublishedAt;
        });
        var activeList = actPoll.concat(myPoll);

        if (activeList.length <= 0) {
          vm.hidePollPopup();
        }

        vm.pollQuestionList = activeList.filter(function () {
          return true;
        });
        if (activeCount == 1) {
          vm.updatePollSubmitStatus(
            activeQuestionId,
            activeQuestionFieldType,
            activeQuestionSurveyID,
            firstLoad
          );
        } else {
          vm.updatePollSubmitStatus(
            activeQuestionId,
            activeQuestionFieldType,
            activeQuestionSurveyID,
            firstLoad
          );
        }
        firstLoad = false;
      });
    },
    updatePollSubmitStatus(
      activeQuestionId,
      activeQuestionFieldType,
      activeQuestionSurveyID,
      firstLoad
    ) {
      var requestData = {
        ClientID: vm.clientId,
        EventID: vm.eventId,
        UserID: vm.uid,
        Polls: [],
      };
      vm.pollQuestionList.forEach(function (item) {
        requestData.Polls.push({
          SessionID: vm.session.SessionId,
          PollType: "1",
          IsPoll: "1",
          SurveyID: item.SurveyID,
        });
        vm.GetPollResult(item.QuesID, item.fieldtype);
      });

      var headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.PollXApiKey,
      };
      axios
        .post(APIs.GetUserSubmitList, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          if (responseData.data && responseData.data.Polls) {
            var polls = JSON.parse(JSON.stringify(responseData.data.Polls));
            polls.forEach(function (p) {
              vm.pollQuestionList.forEach(function (q) {
                if (q.SurveyID == p.SurveyID) {
                  q.IsSubmitted = p.IsSubmitted == "1";
                }
              });
            });
            //var activePolls = vm.pollQuestionList.filter(function (q) {
            //  return q.isActive && q.UserID != vm.uid;
            //});
            if (
              activeQuestionId &&
              activeQuestionFieldType &&
              activeQuestionSurveyID
            ) {
              vm.pollQuestionList.forEach(function (q) {
                if (q.QuesID == activeQuestionId && !q.IsSubmitted) {
                  vm.showPollPopup(activeQuestionId);
                }
              });
            } else if (firstLoad) {
              var activeList = vm.pollQuestionList.filter(function (q) {
                return !q.IsSubmitted && q.UserID != vm.uid;
              });
              if (activeList.length == 1) {
                vm.showPollPopup(activeList[0].QuesID);
              }
            }
          }
        })
        .catch(function (exception) {
          //alert("EEEE: " + exception);
          //var activePolls = vm.pollQuestionList.filter(function (q) {
          //  return q.isActive && q.UserID != vm.uid;
          //});
          //if (activePolls.length == 1) {
          //  vm.showVotingOption(
          //    activePolls[0].QuesID,
          //    activePolls[0].fieldtype,
          //    activePolls[0].SurveyID
          //  );
          //}
          console.log(exception);
        });
    },
    showPollPopup(questionId, tab) {
      $("#voteModalCenter").modal({ backdrop: "static" }, "show");
      //$("#rightPanel").addClass("poll-open");
      if (questionId) {
        vm.currentPoll = questionId;
        vm.pollQuestionList.forEach(function (q) {
          if (q.QuesID == questionId) {
            vm.ViewPollResult(q.QuesID, q.fieldtype);
            if (!tab) {
              if (q.IsSubmitted) {
                tab = 2;
              } else {
                tab = 1;
              }
            }
          }
        });
        vm.pollStep = tab;
      }
    },
    FullScreenPollPopup() {
      vm.pollFullScreen = true;
      let elem = document.getElementById("pollPopupBody");
      ///let elem = document.getElementById("LiveStage");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    ExitFullScreenPollPopup() {
      vm.pollFullScreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    hidePollPopup() {
      $("#voteModalCenter").modal("hide");
      //$("#rightPanel").removeClass("poll-open");
      //vm.currentPoll = "";
      if (pollRessultInterval) {
        clearInterval(pollRessultInterval);
      }
    },
    ViewPollResult(val, type) {
      if (pollRessultInterval) {
        clearInterval(pollRessultInterval);
      }
      pollRessultInterval = setInterval(function () {
        vm.GetPollResult(val, type);
      }, 3000);
    },
    GetPollResult(val, type) {
      console.log(new Date());
      var requestData = {
        clientId: vm.clientId,
        eventId: vm.eventId,
        sessionId: vm.session.SessionId,
        pollType: "1",
        questionId: val,
      };
      var headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.PollXApiKey,
      };
      axios
        .post(APIs.GetPollResult, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          let res = responseData.data;
          var result = JSON.parse(JSON.stringify(res));
          vm.pollQuestionList.forEach(function (q) {
            if (q.QuesID == val) {
              q.vote = result.options;
              q.vote.forEach(function (v) {
                v.count = parseFloat(v.count);
              });
              q.vote = q.vote.sort(function (a, b) {
                var A = a.count;
                var B = b.count;
                return B - A;
              });
              if (result.submitCount > 0) {
                q.totVote = parseInt(result.submitCount);
              } else {
                q.totVote = 0;
              }
              console.log("Vote count: " + q.vote);
              if (type != "checkboxes") {
                q.tagData = [];
                var tagTotVote = 0;

                for (var i = 0; i < q.vote.length; i++) {
                  //q.tagData.push({
                  //  text: q.vote[i].optionId,
                  //  weight: parseInt(q.vote[i].count),
                  //});
                  q.tagData.push([
                    q.vote[i].optionId,
                    parseInt(q.vote[i].count),
                  ]);
                  tagTotVote = parseInt(tagTotVote) + parseInt(q.vote[i].count);
                }
                q.totVote = tagTotVote;
              }
            }
          });
        })
        .catch(function (exception) {
          if (pollRessultInterval) {
            clearInterval(pollRessultInterval);
          }
          vm.hidePollPopup();
          console.log(exception);
        });
    },
    //GetPollSubmitStatus(Quescid, type, surveyID) {
    //  var requestData = {
    //    ClientID: vm.clientId,
    //    EventID: vm.eventId,
    //    SessionID: vm.session.SessionId,
    //    UserID: vm.uid,
    //    PollType: "1",
    //    IsPoll: "1",
    //    SurveyID: surveyID,
    //  };
    //  var headers = {
    //    "Content-Type": "application/json",
    //    "x-api-key": APIs.PollXApiKey,
    //  };
    //  axios
    //    .post(APIs.GetSubmitStatus, requestData, {
    //      headers: headers,
    //    })
    //    .then((responseData) => {
    //      let res = responseData.data;
    //      var result = JSON.parse(JSON.stringify(res.result));
    //      if (result.IsPollSurveySubmitStatus == 1) {
    //        var arrresult = result.AnswerSet;
    //        var chkQues = arrresult.find((o) => o.QuestionID === Quescid);
    //        if (chkQues) {
    //          //vm.showOnlyResult(Quescid, type);
    //          vm.isVoteEnabled = false;
    //          vm.ViewPollResult(Quescid, type);
    //        }
    //      }
    //    })
    //    .catch(function (exception) {
    //      console.log(exception);
    //    });
    //},
    backToPollList() {
      vm.pollStep = 0;
      vm.currentPoll = "";
    },
    changePollTab(tab) {
      vm.pollStep = tab;
    },
    SubmitPoll(Ques, type, surveyid) {
      $("#dvOptioninfo").hide();
      var pollAns = "";
      //funcTime.push({ "start submit poll": new Date() });
      if (type === "checkboxes") {
        var listItems = $("#ul" + Ques + " li");
        var ansList = "";
        listItems.each(function (idx, li) {
          var lstOption = $(li);

          if (lstOption[0].children[0].children[0].checked == true) {
            if (ansList == "") {
              pollAns = lstOption[0].children[0].textContent
                .slice(0, -1)
                .trim();
              ansList =
                '{"QuestionID":"' +
                Ques +
                '","Options":[{"Value":"' +
                lstOption[0].children[0].textContent.slice(0, -1).trim() +
                '"}]}';
            } else {
              pollAns +=
                "," + lstOption[0].children[0].textContent.slice(0, -1).trim();
              ansList +=
                ',{"QuestionID":"' +
                Ques +
                '","Options":[{"Value":"' +
                lstOption[0].children[0].textContent.slice(0, -1).trim() +
                '"}]}';
            }
          }
          // and the rest of your code
        });
      } else {
        pollAns = $("#txt" + Ques)
          .val()
          .trim();
        ansList =
          '{"QuestionID":"' +
          Ques +
          '","Options":[{"Value":"' +
          $("#txt" + Ques)
            .val()
            .trim() +
          '"}]}';
      }
      if (pollAns == "") {
        alert("Please answer before submit.");
        return false;
      } else {
        //
      }
      vm.pollQuestionList.forEach(function (q) {
        if (q.SurveyID == surveyid) {
          q.IsSubmitting = true;
        }
      });

      var sessAns = new Object();
      sessAns.id = Ques;
      sessAns.ans = pollAns;

      var answerset = "[" + ansList + "]";
      store.commit("setPollAns", sessAns);

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var requestData = {
        ClientID: vm.clientId,
        EventID: vm.eventId,
        //SessionID: "1796000",
        SessionID: vm.session.SessionId,
        PollType: "1",
        SurveyID: surveyid,
        UserID: vm.uid,
        IsPoll: "1",
        RevisionNo: "0",
        requestID: "default",
        IsAnonymous: "0",
        UserName: "",
        UserFirstName: obj.user[0].fname.trim(),
        UserLastName: obj.user[0].lname.trim(),
        UserEmail: obj.user[0].Email.trim(),
        UserImagePath: obj.user[0].profilepic.trim(),
        UserVisibility: "true",
        ActionTypeCode: "SVT",
        ActionMaxScorePoll: "0.0",
        ActionName: "Votes submitted",
        ActionScore: "10.0",
        AnswerSet: answerset,
        ua: "okhttp/3.11.0",
      };

      var headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.PollXApiKey,
      };

      //funcTime.push({ "call submit poll API": new Date() });
      axios
        .post(APIs.SubmitPollWithResult, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          vm.postLeaderboardAction("SNPL");
          let data = responseData.data;
          vm.pollQuestionList.forEach(function (q) {
            if (q.SurveyID == surveyid) {
              q.IsSubmitted = true;
              q.IsSubmitting = false;
              q.totVote = 0;
              //funcTime.push({ "view poll API success": new Date() });
              var result = JSON.parse(JSON.stringify(data));
              q.vote = result.options;
              q.vote.forEach(function (v) {
                v.count = parseFloat(v.count);
              });
              q.vote = q.vote.sort(function (a, b) {
                var A = a.count;
                var B = b.count;
                return B - A;
              });
              if (result.submitCount > 0) {
                q.totVote = parseInt(result.submitCount);
              } else {
                q.totVote = 0;
              }
              console.log("Vote count: " + q.vote);
              if (type != "checkboxes") {
                q.tagData = [];
                var tagTotVote = 0;

                for (var i = 0; i < q.vote.length; i++) {
                  //q.tagData.push({
                  //  text: q.vote[i].optionId,
                  //  weight: parseInt(q.vote[i].count),
                  //});
                  q.tagData.push([
                    q.vote[i].optionId,
                    parseInt(q.vote[i].count),
                  ]);
                  tagTotVote = parseInt(tagTotVote) + parseInt(q.vote[i].count);
                }
                q.totVote = tagTotVote;
              }
            }
          });
          //funcTime.push({ "view poll API ends": new Date() });
          //console.log(funcTime);
          vm.pollStep = 2;
        })
        .catch(function (exception) {
          //alert(exception);
          console.log(exception);
          vm.pollQuestionList.forEach(function (q) {
            if (q.SurveyID == surveyid) {
              q.IsSubmitting = false;
            }
          });
        });
    },
    scrollSessionToCurrent() {
      var container = this.$el.querySelector("#right-session-list-wrapper");
      let targetId = "rp_session_" + vm.sessionId;
      let scrollTop = -1 * container.clientHeight;
      scrollTop += 20;
      for (let i = 0; i < container.childElementCount; i++) {
        scrollTop += container.children[i].clientHeight + 10;
        if (container.children[i].id == targetId) {
          break;
        }
      }
      container.scrollTop = scrollTop;
      //document.getElementById("rp_session_4979000").scrollIntoViewIfNeeded();
    },
    scrollMeetingToCurrent() {
      var container = this.$el.querySelector("#right-meeting-list-wrapper");
      let targetId = "rp_meeting_" + vm.sessionId;
      let scrollTop = -1 * container.clientHeight;
      scrollTop += 20;
      for (let i = 0; i < container.childElementCount; i++) {
        scrollTop += container.children[i].clientHeight + 10;
        if (container.children[i].id == targetId) {
          break;
        }
      }
      container.scrollTop = scrollTop;
    },
    scrollSpeakerToCurrent() {
      var container = this.$el.querySelector("#speaker-area-wrap");
      let targetId = "rp_speaker_" + vm.sessionId;
      let scrollTop = -1 * container.clientHeight;
      scrollTop += 20;
      for (let i = 0; i < container.childElementCount; i++) {
        scrollTop += container.children[i].clientHeight + 10;
        if (container.children[i].id == targetId) {
          break;
        }
      }
      container.scrollTop = scrollTop;
      //document.getElementById("rp_session_4979000").scrollIntoViewIfNeeded();
    },
    scrollChatToBottom() {
      const els = document.getElementsByClassName("scroll-chat-to-me");
      //alert(els.length);
      if (els.length > 0) {
        const el = els[0];
        if (el) {
          el.scrollIntoView(false);

          //var container = document.querySelector(".tab-content");
          //if (container) {
          //  container.scrollTop = container.scrollTop + 85;
          //}
        }
      }
    },
    scrollQnAToBottom() {
      const els = document.getElementsByClassName("scroll-qna-to-me");
      //alert(els.length);
      if (els.length > 0) {
        const el = els[0];
        if (el) {
          el.scrollIntoView(false);

          //var container = document.querySelector(".tab-content");
          //if (container) {
          //  container.scrollTop = container.scrollTop + 85;
          //}
        }
      }
    },
    onVolumeChanged() {
      //alert("volumeChanged()");
      //alert(e);
      //alert(vm.volumeLevel);
      //alert("aaaaa");
      ////
      //vm.$emit("volumeChanged", vm.volumeLevel);
      if (vm.volumePaused && vm.volumeLevel > 0) {
        vm.volumePaused = false;
      }
      vm.volumeLevelChanged(vm.volumeLevel, true, false);
    },
    volumeLevelChanged(volume, muteUnmute, isMuted) {
      //alert("volumeLevelChanged" + volume);
      //alert(vm.volumeLevel);
      //return vm.volumeLevel;
      // alert(muteUnmute);
      // alert(isMuted);
      if (volume == 100) {
        vm.volumeLevelClass = "volume-full";
      } else if (volume < 100 && volume >= 50) {
        vm.volumeLevelClass = "volume-mid";
      } else if (volume < 50 && volume > 0) {
        vm.volumeLevelClass = "volume-low";
      } else {
        vm.volumeLevelClass = "volume-off";
      }
      if (muteUnmute) {
        vm.$emit("volumeChanged", {
          volume: volume,
          muteUnmute: muteUnmute,
          isMuted: isMuted,
        });
      } else {
        vm.$emit("volumeChanged", volume, muteUnmute, isMuted);
      }
      setTimeout(() => {
        if (vm.volumePaused || vm.volumeLevel < 20) {
          if (volumeOffTimr) {
            clearInterval(volumeOffTimr);
          }
          volumeOffTimr = setInterval(() => {
            vm.notifyVolumeOff = true;
            //vm.showSnackbar(muteMsg, "info", "top");
            setTimeout(() => {
              vm.notifyVolumeOff = false;
            }, 10000);
          }, 30000);
          vm.notifyVolumeOff = true;
          setTimeout(() => {
            vm.notifyVolumeOff = false;
          }, 10000);
          //vm.showSnackbar(muteMsg, "info", "top");
        } else {
          vm.notifyVolumeOff = false;
          if (volumeOffTimr) {
            clearInterval(volumeOffTimr);
          }
        }
      }, 1000);
    },

    toggleVolume(mute) {
      if (mute == undefined) {
        vm.volumePaused = !vm.volumePaused;
        if (!vm.volumePaused && vm.volumeLevel == 0) {
          vm.volumeLevel = 30;
        }
      } else {
        vm.volumePaused = mute;
      }
      if (vm.volumePaused) {
        vm.volumeLevelChanged(0, true, true);
      } else {
        vm.volumeLevelChanged(vm.volumeLevel, true, false);
      }

      //if (vm.volumeLevel > 0) {
      //  //vm.volumeLevel = 0;
      //  vm.$emit("volumeChanged", 0);
      //} else {
      //  //vm.volumeLevel = 100;
      //  vm.$emit("volumeChanged", vm.volumeLevel);
      //}
      ////
    },
    syncMuteUnmute(isMuted) {
      //alert(isMuted);
      vm.volumePaused = isMuted;
      //vm.onVolumeChanged();
      vm.volumeLevelChanged(0, true, isMuted);
    },
    saveCallSettings() {
      if (vm.rememberSettings) {
        // Cookies.set("mic", vm.playersettings.camera);
        // Cookies.set("mic", vm.playersettings.microphone);
        // Cookies.set("mic", vm.playersettings.speaker);
        // Cookies.set("VideoProfile", vm.playersettings.videoProfile);
      }
    },

    updateRightPanelSettings(key, value) {
      //alert(key);
      vm.$emit("updateRightPanelSettings", {
        key: key,
        value: value,
        sessionTypeId: vm.sessionTypeId,
        sessionId: vm.sessionId,
        roundTableId: vm.roundTableId,
        meetingId: vm.meetingId,
      });
    },
    applyBroadcastSettings(broadcastSettings) {
      console.log("applyBroadcastSettings: " + broadcastSettings);
      //vm.broadcastSettings.AttendeeEnabled = broadcastSettings.AttendeeEnabled;
      //vm.broadcastSettings.QnAEnabled = broadcastSettings.QnAEnabled;
      //vm.broadcastSettings.ChatEnabled = broadcastSettings.ChatEnabled;
      //vm.broadcastSettings.RaiseHandEnabled =
      //  broadcastSettings.RaiseHandEnabled;
      //vm.broadcastSettings.SpeakerInfoEnabled =
      //  broadcastSettings.SpeakerInfoEnabled;
      //if (vm.userType == 4 && !vm.broadcastSettings.AttendeeEnabled) {
      //  $("#viewCountWrap").hide();
      //}
    },
    setupRightPanel(
      uid,
      attendeeType,
      channelName,
      sessionTypeId,
      speakerProfiles,
      session,
      roundTable,
      o2oMeeting,
      roundtableSettings,
      agendaFilterOption,
      exPageId,
      meetingId,
      isZoomRTMP,
      roomId
    ) {
      vm.pollFullScreen = false;
      vm.notifyVolumeOff = false;
      vm.isLive = true;
      vm.selectedSpeakerId = "";
      if (channelName.includes("_gr")) {
        vm.isLive = false;
      }
      //alert("exPageId: " + exPageId);
      //alert("meetingId: " + meetingId);
      //alert("isZoomRTMP: " + isZoomRTMP);

      //let flag = false;
      //if (!flag) {
      //  return;
      //}
      //alert("setupRightPanel-sessionTypeId:" + sessionTypeId);
      //
      //alert(roundTable);
      //vm.isSessionTabVisible = true;
      vm.PostQnAAnonymous = false;
      vm.broadcastSettings.SessionListEnabled = true;
      vm.broadcastSettings.MeetingListEnabled = true;
      vm.uid = uid;
      vm.userType = attendeeType;
      vm.channelName = channelName;
      vm.sessionTypeId = sessionTypeId;
      vm.session = session == undefined ? null : session;
      vm.roundTable = roundTable == undefined ? null : roundTable;
      vm.o2oMeeting = o2oMeeting == undefined ? null : o2oMeeting;
      vm.exPageId = exPageId == undefined ? "" : exPageId;
      vm.meetingId = meetingId;
      if (roundTable) {
        vm.roundTableId = roundTable.TableId;
      }
      //if (!(vm.exPageId == "" || vm.exPageId == "sn")) {
      //  vm.isSessionTabVisible = false;
      //}
      vm.isZoomRTMP = false;
      vm.enableInviteSessionAttendee = false;
      vm.allowRaiseHand = true;
      if (session) {
        vm.sessionId = session.SessionId;
        vm.isZoomRTMP = isZoomRTMP;
        vm.setupTabs(
          session.SessionTypeDetails,
          roundtableSettings,
          agendaFilterOption,
          false,
          isZoomRTMP
        );
      } else {
        vm.setupTabs(null, roundtableSettings, agendaFilterOption);
      }

      if (
        vm.sessionTypeId == vm.OnDemandTypeID ||
        vm.sessionTypeId == vm.LiveStreamTypeID ||
        vm.sessionTypeId == vm.LivePanelTypeID ||
        vm.sessionTypeId == vm.InPersonTypeID
      ) {
        if (session) {
          vm.sessionId = session.SessionId;
          vm.allHosts = session.MappedHosts;
          if (!vm.allHosts) {
            vm.allHosts = [];
          }
          vm.allCoHosts = session.MappedCoHosts;
          if (!vm.allCoHosts) {
            vm.allCoHosts = [];
          }
          vm.allSpeakers = session.MappedSpeakers;
          if (!vm.allSpeakers) {
            vm.allSpeakers = [];
          }
          let host = vm.allHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
          if (host && host.length > 0) {
            vm.userType = 1;
          } else {
            let speaker = vm.allSpeakers.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (speaker && speaker.length > 0) {
              vm.userType = 2;
            }
          }
        }
      } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
        vm.isBreakoutRoomTabVisible = false;
        if (session) {
          vm.sessionId = session.SessionId;
        }
        vm.roundTableId = roundTable.TableId;
        vm.spectatorEnabled = roundTable.SpectatorEnabled;
        vm.allHosts = roundTable.Host;
        if (!vm.allHosts) {
          vm.allHosts = [];
        }
        vm.allCoHosts = roundTable.CoHost ? [roundTable.CoHost] : [];
        vm.allSpeakers = roundTable.MappedAttendees;
        let host = vm.allHosts.filter(function (item) {
          return item.AttendeeId == vm.uid;
        });
        if (host && host.length > 0) {
          vm.userType = 1;
        } else {
          let speaker = vm.allSpeakers.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
          if (speaker && speaker.length > 0) {
            vm.userType = 3;
          }
        }
        if (roundTable && roundTable.EnableBreakoutRoom) {
          vm.isBreakoutRoomTabVisible = roundTable.EnableBreakoutRoom;
        }
      } else if (
        vm.sessionTypeId == vm.O2OTypeID ||
        vm.sessionTypeId == vm.E2OTypeID
      ) {
        vm.meetingId = meetingId;
        //alert("vm.meetingId:" + vm.meetingId);
        //alert("vm.userType:" + vm.userType);
        //vm.userType = 3;
      } else if (vm.sessionTypeId == 100) {
        vm.meetingId = roomId;
        //alert("vm.meetingId:" + vm.meetingId);
        //alert("vm.userType:" + vm.userType);
        //vm.userType = 3;
      }
      if (
        vm.sessionTypeId == 3 &&
        session &&
        session.SessionTypeDetails &&
        session.SessionTypeDetails.EnableInviteSessionAttendee
      ) {
        vm.enableInviteSessionAttendee = true;
      }
      if (
        vm.sessionTypeId == 3 &&
        session &&
        session.SessionTypeDetails &&
        session.SessionTypeDetails.EnableRaiseHand
      ) {
        vm.allowRaiseHand = true;
      }
      if (vm.allHosts.length > 0) {
        vm.hostId = vm.allHosts[0].AttendeeId;
      }
      if (vm.allCoHosts.length > 0) {
        vm.coHostId = vm.allCoHosts[0].AttendeeId;
      }
      //console.log("speakerProfiles: " + speakerProfiles);
      ////
      vm.allSpeakers.forEach(function (item) {
        let profiles = speakerProfiles.filter(function (profile) {
          return profile.SpeakerId == item.AttendeeId;
        });
        if (profiles.length > 0) {
          item.Profile = profiles[0].Profile;
        }
      });
      vm.allHosts.forEach(function (item) {
        item.NameInitial = common.getInitials(item.Name);
        let profiles = speakerProfiles.filter(function (profile) {
          return profile.SpeakerId == item.AttendeeId;
        });
        if (profiles.length > 0) {
          item.Profile = profiles[0].Profile;
        }
      });
      //vm.displaySpeakers(vm.allHosts, vm.allSpeakers);
      //alert("initPanelSwitchSetup");
      vm.initPanelSwitchSetup();
      //alert("vm.userType:" + vm.userType);
      chat.initChat(
        vm.sessionTypeId,
        vm.sessionId,
        vm.roundTableId,
        vm.meetingId,
        vm.userType,
        roomId,
        vm.dialogEventCollectionName,
      );
      //to be comment--before commit poll
      //vm.startPoll();
      if (vm.sessionTypeId <= 4) {
        qna.initQnA(
          vm.sessionTypeId,
          vm.sessionId,
          vm.roundTableId,
          "",
          vm.userType,
          vm.QnAModeration,
          vm.QnAAutoPublish,
          roomId,
        vm.dialogEventCollectionName,
        );
      }

      let excludeIds = [];
      vm.allHosts.forEach(function (item) {
        //alert(item.AttendeeId);
        excludeIds.push(item.AttendeeId);
      });
      vm.allSpeakers.forEach(function (item) {
        //alert(item.AttendeeId);
        excludeIds.push(item.AttendeeId);
      });
      //attendee.initRTM(vm.uid, vm.channelName, excludeIds);
    },
    setupTabs(
      sessionTypeDetails,
      roundtableSettings,
      agendaFilterOption,
      applyingFromListener,
      isZoomRTMP
    ) {
      //let allowedTabs = [];
      //alert(isZoomRTMP);
      if (!applyingFromListener) {
        applyingFromListener = false;
      }
      //if (typeof agendaFilterOption != undefined) {
      //  vm.agendaFilterOption = parseInt(agendaFilterOption);
      //}
      if (vm.agendaFilterOption == 0 || vm.agendaFilterOption == 2) {
        vm.selectedAgendaType = 0;
      } else if (vm.agendaFilterOption == 1) {
        vm.selectedAgendaType = 1;
      }
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        if (
          roundtableSettings &&
          roundtableSettings.isSessionTabVisible != undefined
        ) {
          vm.isSessionTabVisible = roundtableSettings.isSessionTabVisible;
        }
        if (
          roundtableSettings &&
          roundtableSettings.isSpeakerTabVisible != undefined
        ) {
          vm.isSpeakerTabVisible = roundtableSettings.isSpeakerTabVisible;
        }

        if (
          roundtableSettings &&
          roundtableSettings.isAttendeeTabVisible != undefined
        ) {
          vm.isAttendeeTabVisible = roundtableSettings.isAttendeeTabVisible;
        }

        if (
          roundtableSettings &&
          roundtableSettings.isQnATabVisible != undefined
        ) {
          vm.isQnATabVisible = roundtableSettings.isQnATabVisible;
        }

        if (
          roundtableSettings &&
          roundtableSettings.isChatTabVisible != undefined
        ) {
          vm.isChatTabVisible = roundtableSettings.isChatTabVisible;
        }
        //Default Enabled
        //if (vm.userType < 4) {
        //  vm.broadcastSettings.ChatEnabled = false;
        //  vm.enableChat();
        //}
        if (
          roundtableSettings &&
          roundtableSettings.isRaiseHandTabVisible != undefined
        ) {
          vm.isRaiseHandTabVisible = roundtableSettings.isRaiseHandTabVisible;
        }
      } else {
        if (sessionTypeDetails == undefined || sessionTypeDetails == null) {
          sessionTypeDetails = {};
        }
        //if (
        //  sessionTypeDetails.EnableGroupChat == undefined ||
        //  sessionTypeDetails.EnableGroupChat == null
        //) {
        //  allowedTabs.push("message");
        //} else
        //alert();
        vm.isSessionTabVisible = true;
        vm.isSpeakerTabVisible = true;
        vm.isAttendeeTabVisible = true;
        vm.isQnATabVisible = false;
        vm.isChatTabVisible = false;
        vm.isRaiseHandTabVisible = false;
        vm.isPollTabVisible = false;
        vm.isBreakoutRoomTabVisible = false;

        //alert(
        //  "sessionTypeDetails.ShowSpeakerList:" +
        //    sessionTypeDetails.ShowSpeakerList
        //);
        if (sessionTypeDetails.ShowSpeakerList == undefined) {
          if (
            vm.sessionTypeId == vm.LivePanelTypeID ||
            vm.sessionTypeId == vm.RoundTableTypeID
          ) {
            vm.isSpeakerTabVisible = true;
          } else {
            vm.isSpeakerTabVisible = false;
          }
        } else {
          vm.isSpeakerTabVisible = sessionTypeDetails.ShowSpeakerList;
        }
        if (isZoomRTMP) {
          //vm.isSpeakerTabVisible = false;
        }
        //alert(
        //  "sessionTypeDetails.ShowAttendeeList:" +
        //    sessionTypeDetails.ShowAttendeeList
        //);
        if (sessionTypeDetails.ShowAgenda != undefined && !isZoomRTMP) {
          vm.isSessionTabVisible = sessionTypeDetails.ShowAgenda;
        }
        if (sessionTypeDetails.ShowAttendeeList != undefined) {
          vm.isAttendeeTabVisible = sessionTypeDetails.ShowAttendeeList;
        } else {
          vm.isAttendeeTabVisible = false;
        }
        if (isZoomRTMP) {
          //vm.isAttendeeTabVisible = false;
        }
        //alert(
        //  "sessionTypeDetails.EnableLiveQnA:" + sessionTypeDetails.EnableLiveQnA
        //);
        if (sessionTypeDetails.EnableLiveQnA == undefined) {
          vm.isQnATabVisible = false;
        } else {
          vm.isQnATabVisible = sessionTypeDetails.EnableLiveQnA;
          if (sessionTypeDetails.AllowPostingQuestionsAnonymously == true) {
            vm.AllowPostingQuestionsAnonymously = true;
          } else {
            vm.AllowPostingQuestionsAnonymously = false;
          }
          if (vm.isQnATabVisible) {
            if (sessionTypeDetails.QnAModeration == undefined) {
              vm.QnAModeration = false;
            } else {
              vm.QnAModeration = sessionTypeDetails.QnAModeration;
            }
            if (sessionTypeDetails.QnAAutoPublish == undefined) {
              vm.QnAAutoPublish = false;
            } else {
              vm.QnAAutoPublish = sessionTypeDetails.QnAAutoPublish;
            }
          }
        }
        //alert(
        //  "sessionTypeDetails.EnableGroupChat:" +
        //    sessionTypeDetails.EnableGroupChat
        //);
        if (sessionTypeDetails.EnableGroupChat == true) {
          vm.isChatTabVisible = sessionTypeDetails.EnableGroupChat;
        }
        if (sessionTypeDetails.AudiencePoll != undefined) {
          vm.isPollTabVisible = sessionTypeDetails.AudiencePoll;
        }
        if (sessionTypeDetails && sessionTypeDetails.EnableRaiseHand) {
          vm.isRaiseHandTabVisible = sessionTypeDetails.EnableRaiseHand;
        }
        if (sessionTypeDetails && sessionTypeDetails.EnableBreakoutRoom) {
          vm.isBreakoutRoomTabVisible = sessionTypeDetails.EnableBreakoutRoom;
        }

        if (
          vm.sessionTypeId == vm.O2OTypeID ||
          vm.sessionTypeId == vm.E2OTypeID
        ) {
          vm.isMeetingTabVisible = true;
          vm.isAttendeeTabVisible = false;
          vm.isChatTabVisible = true;
          vm.userType = 3;

          //Default Enabled
          vm.broadcastSettings.ChatEnabled = false;
          vm.broadcastSettings.MeetingListEnabled = true;
          vm.enableChat();
        }
        if (vm.sessionTypeId == 100) {
          vm.isAttendeeTabVisible = false;
          vm.isChatTabVisible = true;
          vm.userType = 1;

          //Default Enabled
          vm.broadcastSettings.ChatEnabled = true;
          vm.enableChat();
        }
        //alert(vm.broadcastSettings.QnAEnabled);
        //alert(vm.broadcastSettings.ChatEnabled);
        if (isZoomRTMP) {
          //vm.updateRightPanelSettings("QnAEnabled", true);
          //setTimeout(() => {
          //  vm.updateRightPanelSettings("ChatEnabled", true);
          //}, 5000);
        }
        if (vm.sessionTypeId == vm.LivePanelTypeID && !vm.isLive) {
          vm.isAttendeeTabVisible = false;
          vm.isQnATabVisible = false;
        }
        //
        //alert(
        //  "sessionTypeDetails.EnableRaiseHand:" +
        //    sessionTypeDetails.EnableRaiseHand
        //);
        //if (sessionTypeDetails.EnableRaiseHand == undefined) {
        //  vm.isRaiseHandTabVisible = false;
        //} else {
        //  vm.isRaiseHandTabVisible = sessionTypeDetails.EnableRaiseHand;
        //}

        //if (
        //  vm.sessionTypeId == vm.OnDemandTypeID ||
        //  vm.sessionTypeId == vm.LiveStreamTypeID
        //) {
        //  if (
        //    vm.isSpeakerTabVisible &&
        //    !vm.broadcastSettings.SpeakerInfoEnabled
        //  ) {
        //    //alert(vm.userType);
        //    //vm.enableSpeakerInfo();
        //    vm.broadcastSettings.SpeakerInfoEnabled = true;
        //    vm.updateRightPanelSettings(
        //      "SpeakerInfoEnabled",
        //      vm.broadcastSettings.SpeakerInfoEnabled
        //    );
        //  }
        //  if (
        //    vm.isAttendeeTabVisible &&
        //    !vm.broadcastSettings.AttendeeEnabled
        //  ) {
        //    vm.broadcastSettings.AttendeeEnabled = true;
        //    vm.updateRightPanelSettings(
        //      "AttendeeEnabled",
        //      vm.broadcastSettings.AttendeeEnabled
        //    );
        //  }
        //  if (vm.isQnATabVisible && !vm.broadcastSettings.QnAEnabled) {
        //    vm.broadcastSettings.QnAEnabled = true;
        //    vm.updateRightPanelSettings(
        //      "QnAEnabled",
        //      vm.broadcastSettings.QnAEnabled
        //    );
        //  }
        //  if (vm.isChatTabVisible && !vm.broadcastSettings.ChatEnabled) {
        //    vm.broadcastSettings.ChatEnabled = true;
        //    vm.updateRightPanelSettings(
        //      "ChatEnabled",
        //      vm.broadcastSettings.ChatEnabled
        //    );
        //  }
        //  //if(vm.isRaiseHandTabVisible && !vm.broadcastSettings.RaiseHandEnabled){
        //  //	vm.broadcastSettings.RaiseHandEnabled = true;
        //  //	vm.updateRightPanelSettings("RaiseHandEnabled", vm.broadcastSettings.RaiseHandEnabled)
        //  //}
        //}
      }
      if (applyingFromListener) {
        return;
      }
      //allowedTabs.push("speaker");
      //allowedTabs.push("attendee");
      //allowedTabs.push("qa");
      //allowedTabs.push("message");

      //$("#divDDLCamera").hide();
      //$("#divDDLMicrophone").hide();
      //$("#divDDLSpeaker").hide();
      //$("#divDDLVideoProfile").hide();
      //$("#divPlayerSettingsWrapper").removeClass("d-none");
      //if (vm.sessionTypeId == vm.OnDemandTypeID) {
      //  //allowedTabs = ["attendee", "message"];
      //  //hide mic & camera
      //  $("#divDDLSpeaker").show();
      //  $("#divPlayerSettingsWrapper").addClass("d-none");
      //} else if (vm.sessionTypeId == vm.LiveStreamTypeID) {
      //  //hide mic & camera
      //  $("#divDDLSpeaker").show();
      //  //allowedTabs = ["attendee", "message"];
      //} else if (vm.sessionTypeId == vm.LivePanelTypeID) {
      //  //allowedTabs = ["speaker", "attendee", "qa", "message", "raise_hand"];
      //  $("#divDDLCamera").show();
      //  $("#divDDLMicrophone").show();
      //  $("#divDDLSpeaker").show();
      //  $("#divDDLVideoProfile").show();
      //} else if (vm.sessionTypeId == vm.RoundTableTypeID) {
      //  //if (allowedTabs.length == 0) {
      //  //  allowedTabs = ["speaker", "attendee", "message"];
      //  //}
      //  $("#divDDLCamera").show();
      //  $("#divDDLMicrophone").show();
      //  $("#divDDLSpeaker").show();
      //  $("#divDDLVideoProfile").show();
      //} else if (vm.sessionTypeId == vm.O2OTypeID) {
      //  //allowedTabs = ["message"];
      //}
      //alert(allowedTabs);
      $(".right-desc-pannel").addClass("d-none");
      //$(".right-icon-pannel li").hide();
      //////
      //alert("allowedTabs.forEach");
      //allowedTabs.forEach((tab) => {
      //  alert(tab);
      //  alert($("#btn_" + tab));
      //  alert($("#btn_" + tab).html());
      //  alert($("#btn_" + tab).text());
      //  //$("#btn_" + tab).show();
      //  ////
      //  alert($("#btn_speaker").hasClass("d-none"));
      //  //alert($("#btn_" + tab).hasClass("d-none"));
      //  $("#btn_speaker").removeClass("d-none");
      //  $("#btn_speaker").addClass("d-noneaaa");
      //});
    },
    isUserCoHost(id) {
      let result = false;
      vm.allCoHosts.forEach(function (item) {
        if (id == item.AttendeeId) {
          result = true;
        }
      });
      return result;
    },

    showHideTabs(tabSettings) {
      if (tabSettings) {
        if (typeof tabSettings.isSessionTabVisible != undefined) {
          vm.isSessionTabVisible = tabSettings.isSessionTabVisible;
        }
        if (typeof tabSettings.isSpeakerTabVisible != undefined) {
          vm.isSpeakerTabVisible = tabSettings.isSpeakerTabVisible;
        }

        if (typeof tabSettings.isAttendeeTabVisible != undefined) {
          vm.isAttendeeTabVisible = tabSettings.isAttendeeTabVisible;
        }

        if (typeof tabSettings.isQnATabVisible != undefined) {
          vm.isQnATabVisible = tabSettings.isQnATabVisible;
        }

        if (typeof tabSettings.isChatTabVisible != undefined) {
          vm.isChatTabVisible = tabSettings.isChatTabVisible;
        }

        if (typeof tabSettings.isRaiseHandTabVisible != undefined) {
          vm.isRaiseHandTabVisible = tabSettings.isRaiseHandTabVisible;
        }

        if (typeof tabSettings.isBreakoutRoomTabVisible != undefined) {
          vm.isBreakoutRoomTabVisible = tabSettings.isBreakoutRoomTabVisible;
        }

        if (typeof tabSettings.isPollTabVisible != undefined) {
          vm.isPollTabVisible = tabSettings.isPollTabVisible;
          //vm.isPollTabVisible = false;
        }
      }
    },
    //LoadRoundTableSettings() {
    //  var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //  db.collection(obj.eventcollectionname)
    //    .doc("Settings")
    //    .collection("Roundtable")
    //    .doc("RoundtableSettings")
    //    .onSnapshot(function (doc) {
    //      if (doc.exists) {
    //        let data = doc.data();
    //        if (typeof data.ShowSpeakerList != undefined) {
    //          vm.isSpeakerTabVisible = data.ShowSpeakerList;
    //        }
    //        if (typeof data.ShowAttendeeList != undefined) {
    //          vm.isAttendeeTabVisible = data.ShowAttendeeList;
    //        }
    //        if (typeof data.EnableGroupChat != undefined) {
    //          vm.isChatTabVisible = data.EnableGroupChat;
    //        }
    //        if (typeof data.EnableRaiseHand != undefined) {
    //          vm.isRaiseHandTabVisible = data.EnableRaiseHand;
    //        }
    //      }
    //    });
    //},
    initPanelSwitchSetup() {
      //sessionTypeId: 0,
      //sessionId: "",
      //roundTableId: "",
      let colId = "";
      let docId = "";
      if (vm.sessionTypeId == 4) {
        colId = "RoundTable";
        docId = vm.roundTableId;
      } else if ([1, 2, 3, 5].includes(vm.sessionTypeId)) {
        colId = "Session";
        docId = vm.sessionId;
      } else if (vm.sessionTypeId == 6) {
        colId = "OneToOneMeeting";
        docId = vm.meetingId;
      } else if (vm.sessionTypeId == 7) {
        colId = "ExhibitorMeeting";
        docId = vm.meetingId;
      } else {
        return;
      }
      if (colId == "" || docId == "") {
        return;
      }
      //if (vm.sessionTypeId == 3 || vm.sessionTypeId == 4) {
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection(colId)
        .doc(docId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            let data = doc.data();
            //vm.broadcastSettings.SessionListEnabled =
            //  data.SessionListEnabled != undefined
            //    ? data.SessionListEnabled
            //    : true;

            vm.broadcastSettings.SessionListEnabled = true;
            vm.broadcastSettings.MeetingListEnabled = true;
            vm.broadcastSettings.SpeakerInfoEnabled =
              data.SpeakerInfoEnabled != undefined
                ? data.SpeakerInfoEnabled
                : true;
            vm.broadcastSettings.AttendeeEnabled =
              data.AttendeeEnabled != undefined ? data.AttendeeEnabled : true;
            vm.broadcastSettings.QnAEnabled =
              data.QnAEnabled != undefined ? data.QnAEnabled : true;
            vm.broadcastSettings.ChatEnabled =
              data.ChatEnabled != undefined ? data.ChatEnabled : true;
            vm.broadcastSettings.RaiseHandEnabled =
              data.RaiseHandEnabled != undefined ? data.RaiseHandEnabled : true;
            vm.broadcastSettings.RaiseHandEnabled =
              data.RaiseHandEnabled != undefined ? data.RaiseHandEnabled : true;

            //vm.broadcastSettings.SpeakerInfoEnabled =
            //  data.SpeakerInfoEnabled != undefined
            //    ? data.SpeakerInfoEnabled
            //    : vm.sessionTypeId == 4
            //    ? true
            //    : false;
            //vm.broadcastSettings.AttendeeEnabled =
            //  data.AttendeeEnabled != undefined
            //    ? data.AttendeeEnabled
            //    : vm.sessionTypeId == 4
            //    ? true
            //    : false;
            //vm.broadcastSettings.QnAEnabled =
            //  data.QnAEnabled != undefined
            //    ? data.QnAEnabled
            //    : vm.sessionTypeId == 4
            //    ? true
            //    : false;
            //vm.broadcastSettings.ChatEnabled =
            //  data.ChatEnabled != undefined
            //    ? data.ChatEnabled
            //    : vm.sessionTypeId == 4
            //    ? true
            //    : false;
            //vm.broadcastSettings.RaiseHandEnabled =
            //  data.RaiseHandEnabled != undefined
            //    ? data.RaiseHandEnabled
            //    : vm.sessionTypeId == 4
            //    ? true
            //    : false;
          }

          if (
            !vm.broadcastSettings.SessionListEnabled &&
            vm.userType == 4 &&
            vm.isSessionListPanelOpend
          ) {
            vm.isSessionListPanelOpend = false;
            vm.toogleRightPanel("session");
          }
          if (
            !vm.broadcastSettings.MeetingListEnabled &&
            vm.userType == 4 &&
            vm.isMeetingListPanelOpend
          ) {
            vm.isMeetingListPanelOpend = false;
            vm.toogleRightPanel("meeting");
          }
          if (
            !vm.broadcastSettings.SpeakerInfoEnabled &&
            vm.userType == 4 &&
            vm.isSpeakerPanelOpend
          ) {
            vm.isSpeakerPanelOpend = false;
            vm.toogleRightPanel("speaker");
          }
          if (
            !vm.broadcastSettings.AttendeeEnabled &&
            vm.userType == 4 &&
            vm.isAttendeePanelOpend
          ) {
            vm.isAttendeePanelOpend = false;
            vm.toogleRightPanel("attendee");
          }
          if (
            !vm.broadcastSettings.QnAEnabled &&
            vm.userType == 4 &&
            vm.isQnAPanelOpend
          ) {
            vm.isQnAPanelOpend = false;
            vm.toogleRightPanel("qa");
          }
          if (
            !vm.broadcastSettings.ChatEnabled &&
            vm.userType == 4 &&
            vm.isChatPanelOpend
          ) {
            vm.isChatPanelOpend = false;
            vm.toogleRightPanel("message");
          }
          if (
            !vm.broadcastSettings.RaiseHandEnabled &&
            vm.userType == 4 &&
            vm.isRaiseHandPanelOpend
          ) {
            vm.isRaiseHandPanelOpend = false;
            vm.toogleRightPanel("raise_hand");
          }
          if (
            !vm.broadcastSettings.BreakoutRoomEnabled &&
            vm.userType == 4 &&
            vm.isBreakoutRoomPanelOpend
          ) {
            vm.isBreakoutRoomPanelOpend = false;
            //vm.toogleRightPanel("breakout_room");
          }
          if (
            !vm.broadcastSettings.PollEnabled &&
            vm.userType == 4 &&
            vm.isPollPanelOpend
          ) {
            vm.isPollPanelOpend = false;
            vm.toogleRightPanel("poll");
          }

          //if (vm.userType == 4 && !vm.broadcastSettings.AttendeeEnabled) {
          //  $("#viewCountWrap").hide();
          //} else {
          //  $("#viewCountWrap").show();
          //}
        });
      //}
    },
    collapse() {
      //alert("collapse");
      $(".right-desc-pannel").addClass("d-none");
      $(".right-icon-pannel li").removeClass("active");
      $("#divPlayerSettings").hide();
      vm.isRaiseHandPanelOpend = false;
      vm.isQnAPanelOpend = false;
      vm.isChatPanelOpend = false;

      vm.toggleBrandLogo(true);
      vm.toggleCountdown(true);
    },
    toggleSpeakerProfile(uid) {
      $("#speaker_" + uid).toggleClass("full-description");
      if ($("#speaker_" + uid).hasClass("full-description")) {
        $("#more_" + uid).html("Less");
      } else {
        $("#more_" + uid).html("More");
      }
    },
    openRightPanel(ID) {
      if (vm.isChatTabVisible) {
        if (ID == "message") {
          vm.toggleChatTab();
          setTimeout(() => {
            if (
              !$("#tab_" + ID).hasClass("d-none") &&
              !$("#btn_" + ID).hasClass("active")
            ) {
              $("#btn_" + ID).addClass("active");
            }
          }, 1000);
        }
      }
    },
    toogleRightPanel(ID) {
      //alert(ID);
      var btnID = "btn_" + ID;
      var tabID = "tab_" + ID;

      $(".right-desc-pannel").addClass("d-none");
      //alert(btnID);
      //alert(tabID);
      if (ID != undefined && ID != null && ID != "") {
        if ($("#" + btnID).hasClass("active")) {
          $(".right-icon-pannel li").removeClass("active");
          $("#" + btnID).removeClass("active");
          $("#" + tabID).addClass("d-none");
          vm.toggleBrandLogo(true);
          vm.toggleCountdown(true);
        } else {
          $(".right-icon-pannel li").removeClass("active");
          $("#" + btnID).addClass("active");
          $("#" + tabID).removeClass("d-none");
          vm.toggleBrandLogo(false);
          vm.toggleCountdown(false);
        }
      }
    },
    scrollHanle(evt) {
      console.log(evt);
    },
    leaveRTMChannel() {
      //attendee.LeaveRTMChannel();
      vm.sessionId = "";
    },
    joinRTMChannel() {
      //attendee.JoinRTMChannel();
      //alert('joinRTMChannel')
    },
    startPoll() {
      console.log("start poll " + vm.sessionTypeId);
      if (vm.sessionTypeId == 3 && !vm.isPollStarted) {
        this.cancelCreatepoll();
        vm.getPollQuestion(vm.userType, vm.sessionId);
        vm.isPollStarted = true;
      }
    },
    stopPoll() {
      vm.isPollStarted = false;
    },
    enableSessionList: function () {
      //$(".tooltip").tooltip("hide");
      //vm.updateRightPanelSettings(
      //  "SessionListEnabled",
      //  !vm.broadcastSettings.SessionListEnabled
      //);
    },
    enableSpeakerInfo: function () {
      $(".tooltip").tooltip("hide");
      vm.updateRightPanelSettings(
        "SpeakerInfoEnabled",
        !vm.broadcastSettings.SpeakerInfoEnabled
      );
    },
    enableAttendee: function () {
      $(".tooltip").tooltip("hide");
      vm.updateRightPanelSettings(
        "AttendeeEnabled",
        !vm.broadcastSettings.AttendeeEnabled
      );
    },
    enableQnA: function () {
      $(".tooltip").tooltip("hide");
      vm.updateRightPanelSettings(
        "QnAEnabled",
        !vm.broadcastSettings.QnAEnabled
      );
    },
    enableChat: function () {
      $(".tooltip").tooltip("hide");
      vm.updateRightPanelSettings(
        "ChatEnabled",
        !vm.broadcastSettings.ChatEnabled
      );
    },
    enableRaiseHand: function () {
      $(".tooltip").tooltip("hide");
      vm.updateRightPanelSettings(
        "RaiseHandEnabled",
        !vm.broadcastSettings.RaiseHandEnabled
      );
    },
    inviteAttendeeToStage(entryType, attendeeId, option, isAcceptStatus) {
      //alert(attendeeId);
      //alert(vm.event_collectionName);
      if (vm.sessionId && attendeeId) {
        for (var i = 0; i < vm.currentAttendeeList.length; i++) {
          if (vm.currentAttendeeList[i].AttendeeId == attendeeId) {
            if (entryType == 1) {
              vm.currentAttendeeList[i].Inviting = true;
            } else if (entryType == 2) {
              vm.currentAttendeeList[i].RHRemoving = true;
            }
            break;
          }
        }
        vm.currentAttendeeList = vm.currentAttendeeList.filter(function () {
          return true;
        });
        if (entryType == 1) {
          vm.$emit("inviteAttendeeToStage", attendeeId, option);
        } else if (entryType == 2) {
          vm.$emit("applyRaiseHandAction", attendeeId, option, isAcceptStatus);
        }
      }
    },
    // cancelInviteAttendeeToStage(attendeeId, option){
    //   if (vm.sessionId && attendeeId) {
    //     for(var i = 0; i < vm.currentAttendeeList.length; i++){
    //       if(vm.currentAttendeeList[i].AttendeeId == attendeeId){
    //         vm.currentAttendeeList[i].Canceling = true;
    //         break;
    //       }
    //     }
    //   }
    // },
    toggleSessionsTab: function (e) {
      if (vm.userType < 3 || vm.broadcastSettings.SessionListEnabled) {
        //alert("");
        vm.toogleRightPanel("session");
        if ($("#tab_session").hasClass("d-none")) {
          vm.isSessionListPanelOpend = false;
        } else {
          vm.isSessionListPanelOpend = true;
          vm.isRaiseHandPanelOpend = false;
          vm.isQnAPanelOpend = false;
          vm.isChatPanelOpend = false;
          vm.isBreakoutRoomPanelOpend = false;
          vm.scrollSessionToCurrent();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleMeetingsTab: function (e) {
      if (vm.userType < 3 || vm.broadcastSettings.MeetingListEnabled) {
        //alert("");
        vm.toogleRightPanel("meeting");
        if ($("#tab_meeting").hasClass("d-none")) {
          vm.isMeetingListPanelOpend = false;
        } else {
          vm.isMeetingListPanelOpend = true;
          vm.isRaiseHandPanelOpend = false;
          vm.isQnAPanelOpend = false;
          vm.isChatPanelOpend = false;
          vm.scrollMeetingToCurrent();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    enablePoll: function () {
      vm.updateRightPanelSettings(
        "PollEnabled",
        !vm.broadcastSettings.PollEnabled
      );
    },
    toggleSpeakerTab: function (e) {
      if (vm.userType < 3 || vm.broadcastSettings.SpeakerInfoEnabled) {
        vm.toogleRightPanel("speaker");
        if ($("#tab_speaker").hasClass("d-none")) {
          vm.isSpeakerPanelOpend = false;
        } else {
          vm.isSpeakerPanelOpend = true;
          vm.isRaiseHandPanelOpend = false;
          vm.isQnAPanelOpend = false;
          vm.isChatPanelOpend = false;
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleAttendeeTab: function (e) {
      if (vm.userType < 3 || vm.broadcastSettings.AttendeeEnabled) {
        vm.toogleRightPanel("attendee");
        if ($("#tab_attendee").hasClass("d-none")) {
          vm.isAttendeePanelOpend = false;
        } else {
          vm.isAttendeePanelOpend = true;
          vm.isRaiseHandPanelOpend = false;
          vm.isQnAPanelOpend = false;
          vm.isChatPanelOpend = false;
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleQnATab: function (e) {
      if (vm.userType < 3 || vm.broadcastSettings.QnAEnabled) {
        vm.toogleRightPanel("qa");
        if ($("#tab_qa").hasClass("d-none")) {
          vm.isQnAPanelOpend = false;
        } else {
          vm.isQnAPanelOpend = true;
          vm.isRaiseHandPanelOpend = false;
          vm.isChatPanelOpend = false;
          qna.allQnAs.map(function (item) {
            item.read = true;
          });
          vm.unreadQnACount = 0;
          //vm.scrollQnAToBottom();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleChatTab: function (e) {
      if (
        vm.userType < 3 ||
        vm.broadcastSettings.ChatEnabled ||
        vm.stageUrl == "/stageview"
      ) {
        chat.allChats.map(function (item) {
          item.read = true;
        });
        chat.allChats = chat.allChats.filter(function () {
          return true;
        });
        chat.unreadChatCount = 0;
        vm.toogleRightPanel("message");
        if ($("#tab_message").hasClass("d-none")) {
          vm.isChatPanelOpend = false;
        } else {
          vm.isChatPanelOpend = true;
          vm.isRaiseHandPanelOpend = false;
          vm.isQnAPanelOpend = false;
          vm.scrollChatToBottom();
          $("#txtChat").focus();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleRaiseHandTab: function (e) {
      if (vm.broadcastSettings.RaiseHandEnabled) {
        //alert("toggleRaiseHandTab")
        if (vm.userType == 1 || vm.isCurrentUserCoHost) {
          vm.toogleRightPanel("raise_hand");
          if ($("#tab_raise_hand").hasClass("d-none")) {
            vm.isRaiseHandPanelOpend = false;
          } else {
            vm.isRaiseHandPanelOpend = true;
            vm.isQnAPanelOpend = false;
            vm.isChatPanelOpend = false;
            //vm.unreadRaiseHandCount = 0;
            //vm.scrollRaiseHandToBottom();
          }
        } else if (vm.userType == 4) {
          //if (vm.sessionHostSpeakerCount + vm.sessionInvitedAndRHInStageCount < vm.maxSpeakerLimit) {
          vm.isRHOn = !vm.isRHOn;
          vm.$emit("applyRaiseHandAction", vm.uid, vm.isRHOn);

          $(".right-desc-pannel").addClass("d-none");
          $(".right-icon-pannel li").removeClass("active");
          if (vm.isRHOn) {
            $("#btn_raise_hand").addClass("active");
          }
          //}
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    setMyRHStatus(status) {
      vm.isRHOn = status;
      if (vm.isRHOn) {
        $("#btn_raise_hand").addClass("active");
      } else {
        $("#btn_raise_hand").removeClass("active");
      }
    },
    handleRH() {
      //alert("aaaaa")
      vm.isRHOn = !vm.isRHOn;
      vm.$emit("applyRaiseHandAction", vm.uid, vm.isRHOn);
    },
    toggleBrandLogo(option) {
      let el = $("#brandLogoBottom");
      if (el) {
        if (option) {
          el.show();
        } else {
          el.hide();
        }
      }
    },
    toggleCountdown(option) {
      if (vm.sessionTypeId == 6) {
        let el = $("#timerLabel");
        if (el) {
          if (option) {
            el.show();
          } else {
            el.hide();
          }
        }
      }
    },
    togglePollTab: function (e) {
      if (vm.userType == 4) {
        if (vm.activePollList.length > 0) {
          if (vm.activePollList.length == 1) {
            vm.showPollPopup(vm.activePollList[0].QuesID);
            //vm.showVotingOption(
            //  vm.activePollList[0].QuesID,
            //  vm.activePollList[0].fieldtype,
            //  vm.activePollList[0].SurveyID
            //);
          } else {
            vm.showPollPopup(vm.currentPoll);
          }
        }
      }
      if (vm.userType == 1 || vm.userType == 2) {
        vm.toogleRightPanel("poll");
        if ($("#tab_poll").hasClass("d-none")) {
          vm.isPollPanelOpend = false;
          vm.isCreatePollVisible = true;
        } else {
          vm.isPollPanelOpend = true;
          //vm.getPollQuestion();
          vm.isCreatePollVisible = false;
          //$("#btn_poll").addClass("active");
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    rightPanelOnClick(e) {
      e.stopPropagation();
    },

    getInitials(name) {
      return common.getInitials(name);
    },

    UpdateGuestPanel(currentGuestList) {
      //alert("UpdateGuestPanel:" + currentGuestList.length);
      vm.currentGuestList = currentGuestList;
      vm.currentGuestList = vm.currentGuestList.filter(function (item) {
        item.NameInitial = common.getInitials(item.Name);
        return true;
      });
    },
    UpdateAttendeePanel(currentAttendeeList) {
      //alert("UpdateAttendeePanel:" + currentAttendeeList.length);
      // vm.currentAttendeeList = currentAttendeeList.filter(function () {
      //   return true;
      // });
      vm.currentAttendeeList = currentAttendeeList;
      vm.currentAttendeeList = vm.currentAttendeeList.filter(function (item) {
        item.NameInitial = common.getInitials(item.Name);
        return true;
      });
    },
    UpdateSpeakerPanel(speakerIdList) {
      // alert("speakerIdList: "+speakerIdList.length);
      // alert("allSpeakers: "+vm.allSpeakers.length);
      vm.allSpeakers.forEach(function (item) {
        let ids = speakerIdList.filter(function (val) {
          return val == item.AttendeeId;
        });
        if (ids.length > 0) {
          item.IsActive = true;
        } else {
          item.IsActive = false;
        }
      });
      vm.allSpeakers = vm.allSpeakers.filter(function () {
        return true;
      });
      //alert("allHosts: "+vm.allHosts.length);
      vm.allHosts.forEach(function (item) {
        let ids = speakerIdList.filter(function (val) {
          return val == item.AttendeeId;
        });
        if (ids.length > 0) {
          item.IsActive = true;
        } else {
          item.IsActive = false;
        }
      });
      vm.allHosts = vm.allHosts.filter(function () {
        return true;
      });
    },
    prepareSessionList() {
      vm.speakerDetailsForPopup = [];

      var listRef = db
        .collection(vm.event_collectionName)
        .doc("SessionList")
        .collection("Sessions")
        .where("IsPublished", "==", true)
        .orderBy("StartDate", "asc")
        .orderBy("EndDate", "asc");
      var dtt;
      vm.allSessions = [];
      listRef
        .get()
        .then((querySnapshot) => {
          var currentTime = parseInt(new Date().getTime() / 1000);
          //alert(querySnapshot.docs.length);
          querySnapshot.forEach((doc) => {
            let data = doc.data();
            var objSession = new Object();
            objSession.SessionId =
              data.SessionId != undefined ? data.SessionId : "0";
            objSession.Name = data.Name != undefined ? data.Name : "";
            //if (objSession.SessionId == "7374000") {
            //  alert("objSession.Name:" + objSession.Name);
            //}
            objSession.DescriptionShort =
              data.DescriptionShort != undefined ? data.DescriptionShort : "";

            objSession.StartTime = data.StartDate.seconds;
            objSession.EndTime = data.EndDate.seconds;
            if (data.StartDate != undefined) {
              dtt = new Date(data.StartDate.seconds * 1000);
              objSession.DateTabLabel = dtt.toString().substring(0, 10);
            } else {
              objSession.DateTabLabel = "";
            }

            objSession.StartTimeLabel = vm.getFormattedTime(
              data.StartDate.seconds
            );
            objSession.EndTimeLabel = vm.getFormattedTime(data.EndDate.seconds);

            objSession.TrackName = "";
            objSession.Track = data.Track;
            if (!objSession.Track) {
              objSession.Track = { TrackID: "", TrackName: "" };
            }
            if (objSession.Track != undefined) {
              if (objSession.Track.TrackName != undefined) {
                objSession.TrackName = objSession.Track.TrackName;
              }
            }

            objSession.SessionTypeDetails = data.SessionTypeDetails;
            objSession.IsZoomRTMP = doc.data().IsZoomRTMP
              ? doc.data().IsZoomRTMP
              : false;
            objSession.IsRTMP = doc.data().IsRTMP
              ? doc.data().IsRTMP
              : false;
            objSession.ZoomMeetingStarted = doc.data().MeetingStarted
              ? doc.data().MeetingStarted
              : false;
            objSession.RTMPStarted = doc.data().RTMPStarted
              ? doc.data().RTMPStarted
              : false;
            if (data.StreamingClient) {
              objSession.StreamingClient = data.StreamingClient;
            } else {
              objSession.StreamingClient = "Web";
            }
            objSession.MappedHosts =
              data.MappedHosts == undefined ? [] : data.MappedHosts;
            if (objSession.StreamingClient.toLowerCase().trim() == "web") {
              if (objSession.MappedHosts.length > 1) {
                objSession.MappedHosts = [objSession.MappedHosts[0]];
              }
            }
            objSession.MappedCoHosts = data.MappedCoHost
              ? [data.MappedCoHost]
              : [];
            objSession.MappedSpeakers =
              data.MappedSpeakers == undefined ? [] : data.MappedSpeakers;

            objSession.IsHost = false;
            objSession.IsSpeaker = false;

            let results = objSession.MappedHosts.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (results.length > 0) {
              objSession.IsHost = true;
            }
            results = objSession.MappedCoHosts.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (results.length > 0) {
              objSession.IsHost = true;
            }
            results = objSession.MappedSpeakers.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (results.length > 0) {
              objSession.IsSpeaker = true;
            }

            objSession.IsLive = false;
            if (currentTime < objSession.StartTime) {
              objSession.LinkClass = "upcoming-status";
              objSession.StatusDisplayText = "Upcoming";
              objSession.StatusClass = "upcoming-session-indicate";
            } else if (
              currentTime > objSession.StartTime &&
              currentTime < objSession.EndTime
            ) {
              if (
                !objSession.IsZoomRTMP ||
                objSession.IsHost ||
                objSession.IsSpeaker
              ) {
                objSession.IsLive = true;
                objSession.StatusDisplayText = "Live";
                objSession.StatusClass = "live-session-indicate";
                objSession.LinkClass = "ongoing-status";
              } else {
                objSession.IsLive = true;
                objSession.StatusDisplayText = "Live";
                objSession.StatusClass = "live-session-indicate";
                if (objSession.IsZoomRTMP && objSession.RTMPStarted) {
                  objSession.LinkClass = "ongoing-status";
                } else {
                  objSession.LinkClass = "upcoming-status";
                }
              }
            } else if (currentTime > objSession.EndTime) {
              objSession.StatusDisplayText = "Session Ended";
              objSession.StatusClass = "end-session-indicate";
              objSession.LinkClass = "finish-status";
            }
            vm.allSessions.push(objSession);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    prepareMySession() {
      vm.mySessions = [];
      if (vm.agendaFilterOption == 0) {
        vm.mySessionsLoaded = true;
      } else {
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
          },
          data: {
            AttendeeId: vm.uid,
          },
        };
        axios
          .post(APIs.MyAgenda, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            if (
              responseData &&
              responseData.data &&
              responseData.data.status == 0 &&
              responseData.data.sessions
            ) {
              responseData.data.sessions.map(function (item) {
                vm.mySessions.push(item.SessionId);
              });
            }
            vm.mySessionsLoaded = true;
          })
          .catch((error) => {
            console.log(error);
            vm.mySessionsLoaded = true;
          });
      }
    },
    updateSessionStatus() {
      let cTime = parseInt(new Date().getTime() / 1000);
      vm.allSessions.forEach(function (item) {
        if (cTime < item.StartTime) {
          item.LinkClass = "upcoming-status";
          item.StatusDisplayText = vm.$t("livestage.upcoming");
          item.StatusClass = "upcoming-session";
        } else if (cTime > item.StartTime && cTime < item.EndTime) {
          if (item.IsZoomRTMP && !item.ZoomRTMPListener) {
            vm.ZoomRTMPStatusListener(item);
          }
          if (!item.IsZoomRTMP || item.IsHost || item.IsSpeaker) {
            item.IsLive = true;
            item.StatusDisplayText = vm.$t("livestage.live");
            item.StatusClass = "active-session";
            item.LinkClass = "ongoing-status";
          } else {
            item.StatusDisplayText = "Live";
            item.StatusClass = "live-session-indicate";
            if (item.IsZoomRTMP && item.RTMPStarted) {
              item.IsLive = true;
              item.LinkClass = "ongoing-status";
            } else {
              item.IsLive = false;
              item.LinkClass = "upcoming-status";
            }
          }
        } else if (cTime > item.EndTime) {
          if (item.ZoomRTMPListener) {
            item.ZoomRTMPListener();
            item.ZoomRTMPListener = null;
          }
          item.IsLive = false;
          item.StatusDisplayText = vm.$t("livestage.sessionended");
          item.StatusClass = "finish-session";
          item.LinkClass = "finish-status";
        }
      });
      vm.allSessions = vm.allSessions.filter(function () {
        return true;
      });
    },
    ZoomRTMPStatusListener(objSession) {
      if (!objSession.ZoomRTMPListener) {
        let firstLoad = true;
        objSession.ZoomRTMPListener = db
          .collection(vm.event_collectionName)
          .doc("SessionList")
          .collection("Sessions")
          .doc(objSession.SessionId)
          .onSnapshot((doc) => {
            if (!firstLoad) {
              var data = doc.data();
              objSession.RTMPStarted = data.RTMPStarted
                ? data.RTMPStarted
                : false;
              objSession.ZoomMeetingStarted = data.MeetingStarted
                ? data.MeetingStarted
                : false;
            }
            firstLoad = false;
          });
      }
    },
    updateRTMPStatus(sessionId, zoomMeetingStarted, RTMPStarted) {
      //alert(sessionId);
      vm.allSessions.map(function (item) {
        if (item.SessionId == sessionId) {
          //alert(RTMPStarted);
          //alert(zoomMeetingStarted);
          item.RTMPStarted = RTMPStarted;
          item.ZoomMeetingStarted = zoomMeetingStarted;
        }
      });
    },
    toggleMoreSessionActions(sessionId, e) {
      if (sessionId) {
        if (
          $("#rp_session_" + sessionId + " .on-demand-dropdown").hasClass(
            "d-none"
          )
        ) {
          $(".on-demand-dropdown").addClass("d-none");
          $("#rp_session_" + sessionId + " .on-demand-dropdown").removeClass(
            "d-none"
          );
        } else {
          $("#rp_session_" + sessionId + " .on-demand-dropdown").addClass(
            "d-none"
          );
        }
      } else {
        $(".on-demand-dropdown").addClass("d-none");
      }
      if (e) {
        e.stopPropagation();
      }
    },
    StartRTMPStreaming(sessionId, e) {
      $("#rp_session_" + sessionId + " .on-demand-dropdown").addClass("d-none");
      vm.allSessions.forEach(function (session) {
        if (session.SessionId == sessionId) {
          if (session.SessionTypeDetails.TypeID == 3) {
            let headers = {
              "content-type": "application/json",
            };
            let bodyData = {
              meetingid: session.Zoom_Detail.id,
              stream_url: session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url,
              stream_key:
                session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey,
              page_url: session.ZoomRTMPMUX_detail.data.playbackUrl,
            };
            //vm.showLoader();
            axios
              .post(APIs.EnableZoomRTMPStreaming, bodyData, {
                headers: headers,
              })
              .then((response) => {
                //vm.hideLoader();
                console.log(response.data);
                if (response.data.code == 1) {
                  db.collection(vm.eventcollection)
                    .doc("SessionList")
                    .collection("Sessions")
                    .doc(sessionId)
                    .update({
                      ZoomRTMPEnable_Status: response.data,
                      RTMPStarted: true,
                    })
                    .then(function () {
                      //resolve(response.data);
                      $(
                        "#rp_session_" + sessionId + " .on-demand-dropdown"
                      ).addClass("d-none");
                      vm.showSnackbar(
                        "RTMP Streaming started successfully.",
                        "info",
                        "top"
                      );
                    })
                    .catch(function (error) {
                      //$(
                      //  "#rp_session_" + sessionId + " .on-demand-dropdown"
                      //).addClass("d-none");
                      console.error(
                        "Error updating ZoomRTMPEnable_Status: ",
                        error
                      );
                      vm.showSnackbar(
                        "Error on Start RTMP Streaming.",
                        "error",
                        "top"
                      );
                    });
                } else {
                  console.log(response);
                  vm.showSnackbar(
                    "Error on Start RTMP Streaming.",
                    "error",
                    "top"
                  );
                }
              })
              .catch((error) => {
                //vm.hideLoader();
                console.log(error);
                vm.showSnackbar(
                  "Error on Start RTMP Streaming.",
                  "error",
                  "top"
                );
              });
          }
        }
      });
      if (e) {
        e.stopPropagation();
      }
    },
    StopRTMPStreaming(sessionId, e) {
      $("#rp_session_" + sessionId + " .on-demand-dropdown").addClass("d-none");
      vm.allSessions.forEach(function (session) {
        if (session.SessionId == sessionId) {
          if (session.SessionTypeDetails.TypeID == 3) {
            let headers = {
              "content-type": "application/json",
            };
            let bodyData = {
              meetingid: session.Zoom_Detail.id,
            };
            //vm.showLoader();
            axios
              .post(APIs.DisableZoomRTMPStreaming, bodyData, {
                headers: headers,
              })
              .then((response) => {
                //vm.hideLoader();
                console.log(response.data);
                if (response.data.code == 1) {
                  db.collection(self.eventcollection)
                    .doc("SessionList")
                    .collection("Sessions")
                    .doc(sessionId)
                    .update({
                      ZoomRTMPEnable_Status: response.data,
                      RTMPStarted: false,
                    })
                    .then(function () {
                      //resolve(response.data);
                      $(
                        "#rp_session_" + sessionId + " .on-demand-dropdown"
                      ).addClass("d-none");
                      vm.showSnackbar(
                        "RTMP Streaming stopped successfully.",
                        "info",
                        "top"
                      );
                    })
                    .catch(function (error) {
                      //$(
                      //  "#rp_session_" + sessionId + " .on-demand-dropdown"
                      //).addClass("d-none");
                      console.error(
                        "Error updating ZoomRTMPEnable_Status: ",
                        error
                      );
                      vm.showSnackbar(
                        "Error on Stop RTMP Streaming.",
                        "error",
                        "top"
                      );
                    });
                } else {
                  console.log(response);
                  vm.showSnackbar(
                    "Error on Stop RTMP Streaming.",
                    "error",
                    "top"
                  );
                }
              })
              .catch((error) => {
                //vm.hideLoader();
                console.log(error);
                vm.showSnackbar(
                  "Error on Stop RTMP Streaming.",
                  "error",
                  "top"
                );
              });
          }
        }
      });
      if (e) {
        e.stopPropagation();
      }
    },
    changeAgendaType(agendaType) {
      vm.selectedAgendaType = agendaType;
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      return formattedtime;
    },
    Returndatetimeformat: function (seconds) {
      var dtt = "";
      dtt = new Date(seconds * 1000);
      var hours = dtt.getHours();
      var minutes =
        dtt.getMinutes().toString() == "0" ? "00" : dtt.getMinutes();
      var newformat = hours >= 12 ? "PM" : "AM";
      hours = hours >= 12 ? hours - 12 : hours;
      //var newformat = hours >= 12 ? "PM" : "AM";
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + newformat;
      return formattedtime;
    },
    //CHAT SECTION START
    createChat() {
      //alert();
      let msg = $("#txtChat").val();
      msg = msg.trim();
      if (msg.length > 0) {
        let sendTo = 0;
        if ($("#selectSendTo")) {
          sendTo = $("#selectSendTo").val();
          //alert(sendTo);
        }
        chat.addChat(msg, sendTo);
        $("#txtChat").val("");
        vm.postLeaderboardAction("SNCH");
      }
    },
    sendMessageReaction(chatId, reactionId) {
      console.log(chatId + reactionId);
      //e.target.closest(".msg-reaction-list").style.display = "none";
      $("#msg-reaction-list-" + chatId).hide();
      setTimeout(() => {
        $("#msg-reaction-list-" + chatId).removeAttr("style");
        //e.target.closest(".msg-reaction-list").style.display = "";
      }, 100);

      if (chatId && reactionId) {
        var reactions = vm.chat.allReactions.filter((item) => {
          return item.id == reactionId;
        });
        if (reactions.length > 0) {
          var timeout = 1;
          if (reactions[0].rev_id) {
            var chats = vm.chat.allChats.filter((item) => {
              return item.ChatId == chatId;
            });
            if (
              chats.length > 0 &&
              chats[0][reactions[0].rev_id] &&
              chats[0][reactions[0].rev_id].includes(vm.uid)
            ) {
              timeout = 1000;
              chat.sendMessageReaction(chatId, reactions[0].rev_id);
            }
          }
          setTimeout(() => {
            chat.sendMessageReaction(chatId, reactionId);
          }, timeout);
        }
      }
    },
    chatEmojiSelected(emoji) {
      $("#txtChat").val($("#txtChat").val() + emoji.data);
      $("#txtChat").focus();
    },
    toggleChatEmojiPanel() {
      vm.showChatEmojiPannel = !vm.showChatEmojiPannel;
    },
    //CHAT SECTION END

    //QnA SECTION START
    goToQnA1() {
      $(".qna-input-area").css("display", "none");
      $("#qna-area-wrap").css("display", "none");
      $(".ask-question-wrap").removeClass("d-none");
      $("#tab_qa .qna-section").addClass("h-100");
    },
    goToQnAList1() {
      $(".qna-input-area").css("display", "block");
      $("#qna-area-wrap").css("display", "block");
      $(".ask-question-wrap").addClass("d-none");
      $("#tab_qa .qna-section").removeClass("h-100");
    },
    goToQnA() {
      $("#qna-area-wrap").addClass("d-none");
      $("#ask-question-wrap").removeClass("d-none");
      $("#go-ask-question").addClass("d-none");
      $("#qna-input-area").removeClass("d-none");

      //$(".qna-input-area").css("display", "none");
      //$(".ask-question-wrap").removeClass("d-none");
      $("#tab_qa .qna-section").addClass("h-100");
      $("#txtQnA").focus();
    },
    goToQnAList() {
      $("#qna-area-wrap").removeClass("d-none");
      $("#ask-question-wrap").addClass("d-none");
      $("#go-ask-question").removeClass("d-none");
      $("#qna-input-area").addClass("d-none");

      //$(".qna-input-area").css("display", "block");
      //$("#qna-area-wrap").css("display", "block");
      //$(".ask-question-wrap").addClass("d-none");
      $("#tab_qa .qna-section").removeClass("h-100");
    },
    createQnA() {
      let msg = $("#txtQnA").val();
      let postAnonymous = $("#chkPostAnonymous").is(":checked");
      msg = msg.trim();
      if (msg.length > 0) {
        qna.addQnA(msg, postAnonymous, vm.isQnATabVisible, vm.isQnAPanelOpend);
        $("#txtQnA").val("");
        vm.goToQnAList();
        vm.postLeaderboardAction("SQAQ");
      }
    },
    toggleLikeQnA(qnaId, myQnA, isLiked) {
      if (qnaId != "" && !myQnA) {
        qna.toggleLikeQnA(qnaId, isLiked);
        //if(IsLiked){
        //	qna.unlikeQnA(qnaId);
        //}
        //else{
        //	qna.likeQnA(qnaId);
        //}
        if (!isLiked) {
          vm.postLeaderboardAction("SQLQ");
        }
      }
    },
    togglePublishQnA(qnaId, isPublished) {
      if (qnaId != "" && vm.userType == 1) {
        qna.togglePublishQnA(qnaId, isPublished);
        //if ((isPublished, isPublished)) {
        //  qna.unpublishQnA(qnaId);
        //} else {
        //  qna.piblishQnA(qnaId);
        //}
      }
    },
    //dislikeQnA(qnaId, myQnA) {
    //  if (qnaId != "" && !myQnA) {
    //    qna.dislikeQnA(qnaId);
    //  }
    //},
    changeQnASortingTab(tabClicked) {
      if (vm.qnaActiveTabIndex == 1 && tabClicked == 0) {
        vm.qnaActiveTabIndex = 0;
      } else if (vm.qnaActiveTabIndex == 0 && tabClicked == 1) {
        vm.qnaActiveTabIndex = 1;
      }
    },
    //QnA SECTION END
    //28.10.2020 start
    createIpoll() {
      $(".poll-first-step").css("display", "none");
      $("#live_PollTop").css("display", "none");
      $("#btn_create_pool").css("display", "none");
      $(".poll-second-step").css("display", "block");
      $(".poll-lunch").css("display", "flex");
      $("#create_PollTop").css("display", "block");
      $(".multiple-ans").css("display", "block");
      $(".liadd").show();
      $("#dvOptioninfo").hide();
      $("#dvOpenOptioninfo").hide();
      $("#lblQuestion").focus();
      $("#imgAddOption").show();
      vm.OptionList = [];
    },
    showpoll() {
      $(".poll-first-step").css("display", "block");
      $("#live_PollTop").css("display", "block");
      $("#btn_create_pool").css("display", "block");
      $(".poll-second-step").css("display", "none");
      $(".poll-lunch").css("display", "none");
      $("#create_PollTop").css("display", "none");
      $("#voteBtn").text("Submit");
      vm.OptionList = [];
      // if(option == 1)
      // {
      //   $('#multiple-ans').show();
      // }else
      // {
      //   $('#multiple-ans').hide();
      // }
      // vm.pollCreateOption = option;
      this.cancelCreatepoll();
    },
    cancelCreatepoll() {
      $("#lblQuestion").text("");
      $("#lblOpenQuestion").text("");
      //$("#ulOption").empty();
      var lenli = $("#ulOption > li").length;
      if (lenli > 1) {
        $("#ulOption > li")
          .slice(2, parseInt(lenli - 1))
          .remove();
      }
      vm.pollOption = "";
      vm.OptionList = [];
      $("#lblOptions").val("");
      $("#dvOptioninfo").hide();
      $("#dvOpenOptioninfo").hide();
      vm.changePollCreateOption(1);
    },
    //28.10.2020 end

    selectAnswer(e) {
      $(".attendee-live-poll-q li").removeClass("select-and-box");
      $(".attendee-live-poll-q li input").removeClass("isvotechecked");
      if ($(e.currentTarget).parent().parent().hasClass("select-and-box")) {
        $(e.currentTarget).parent().parent().removeClass("select-and-box");
      } else {
        $(e.currentTarget).parent().parent().addClass("select-and-box");
      }

      $("#attendee-submit_Vote").removeAttr("disabled");
      //vm.SubmitPoll(QuesID, fieldtype, SurveyID);
    },

    selectTab(val, e) {
      $(e.currentTarget).addClass("active");
      $("#" + val).removeClass("active");
    },

    getBreakoutRooms(sessionId, roundTableId) {
      vm.isLoading = true;
      if (breakoutRoomListener) {
        breakoutRoomListener();
        breakoutRoomListener = null;
      }
      vm.breakoutRooms = [];
      var dbRef = db.collection(vm.event_collectionName);
      if (vm.sessionTypeId == vm.LivePanelTypeID) {
        dbRef = dbRef
          .doc("SessionList")
          .collection("Sessions")
          .doc(sessionId)
          .collection("BreakoutRooms");
      } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
        dbRef = dbRef
          .doc("RoundTableList")
          .collection("RoundTables")
          .doc(roundTableId)
          .collection("BreakoutRooms");
      }
      breakoutRoomListener = dbRef.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        changes.forEach(function (change) {
          let data = change.doc.data();
          data.Members = [];
          let room = vm.breakoutRooms.filter(function (item) {
            if (item.RoomId == change.doc.id) {
              return true;
            }
          });
          if (room.length == 0) {
            data.PreAssigned = data.PreAssigned ? true : false;
            data.IsUpdating = false;
            vm.breakoutRooms.push(data);
            vm.listenBreakoutRoomParticipants(
              sessionId,
              roundTableId,
              data.RoomId
            );
          } else {
            room[0].Name = data.Name;
            room[0].Instruction = data.Instruction;
            room[0].Capacity = data.Capacity;
            room[0].Duration = data.Duration;
            room[0].Occupied = data.Occupied;
            room[0].PreAssigned = data.PreAssigned;
            room[0].IsPublished = data.IsPublished;
            room[0].IsUpdating = false;
            
            if (!room[0].IsPublished) {
              vm.leaveBreakoutRoom(room[0].RoomId);
            }
          }
        });
        if (vm.isLoading) {
          vm.breakoutRoomsKey++;
        } else {
          vm.breakoutRooms = vm.breakoutRooms.filter(function () {
            return true;
          });
        }
        vm.isLoading = false;
      });
    },

    listenBreakoutRoomParticipants(sessionId, roundTableId, roomId) {
      let rooms = vm.breakoutRooms.filter(function (item) {
        if (item.RoomId == roomId) {
          return true;
        }
      });
      if (rooms.length > 0) {
        var room = rooms[0];
        if (room.listener) {
          room.listener();
          room.listener = null;
        }
        var dbRef = db.collection(vm.event_collectionName);
        if (vm.sessionTypeId == vm.LivePanelTypeID) {
          dbRef = dbRef
            .doc("SessionList")
            .collection("Sessions")
            .doc(sessionId)
            .collection("BreakoutRooms");
        } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          dbRef = dbRef
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(roundTableId)
            .collection("BreakoutRooms");
        }
        room.listener = dbRef
          .doc(roomId)
          .collection("Participances")
          .onSnapshot((snapshot) => {
            let rooms = vm.breakoutRooms.filter(function (item) {
              if (item.RoomId == roomId) {
                return true;
              }
            });
            if (rooms.length > 0) {
              let changes = snapshot.docChanges();
              changes.forEach(function (change) {
                let data = change.doc.data();
                let members = rooms[0].Members.filter(function (item) {
                  if (item.AttendeeId == change.doc.id) {
                    return true;
                  }
                });
                if (members.length == 0) {
                  if (data.IsActive) {
                    data.NameInitial = vm.getInitials(data.Name);
                    rooms[0].Members.push(data);
                  }
                } else {
                  members[0].IsActive = data.IsActive;
                }
                // if (data.IsActive) {
                //   data.NameInitial = vm.getInitials(data.Name);
                //   rooms[0].Members.push(data);
                // }
              });
              rooms[0].Members = rooms[0].Members.filter(function (item) {
                return item.IsActive;
              });
              rooms[0].Members = rooms[0].Members.sort(function (a, b) {
                let v1 = a.Name.toLowerCase().trim();
                let v2 = b.Name.toLowerCase().trim();
                return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
              });
            }
          });
      }
    },

    createBreakoutRoom(room) {
      if (room) {
        if (room.Name) {
          room.Name = room.Name.trim();
        }
        if (room.Instruction) {
          room.Instruction = room.Instruction.trim();
        }
        if (!room.Name) {
          vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
            "Room Title can not be blank."
          );
        } else if (room.Capacity < 2) {
          vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
            "Capacity can not be less than 2."
          );
        } else if (room.Duration < 2) {
          vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
            "Duration can not be less than 2."
          );
        } else {
          let result = vm.breakoutRooms.some(function (element) {
            if (
              (!room.RoomId && element.Name == room.Name) ||
              (room.RoomId &&
                element.RoomId != room.RoomId &&
                element.Name == room.Name)
            ) {
              return true;
            }
          });
          if (result) {
            vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
              "The room name already exists, please choose another name."
            );
          } else {
            let flag = false;
            if (room.RoomId) {
              flag = true;
              room.LastModifiedDate = new Date().getTime();
              room.LastModifiedBy = vm.uid;
              // let result = vm.breakoutRooms.filter(function (element) {
              //   if (element.RoomId != room.RoomId) {
              //     return true;
              //   }
              // });
              // if (result.length > 0) {
              //   room.IsPublished = result[0].IsPublished;
              // }
              // db.collection(vm.event_collectionName)
              //   .doc("SessionList")
              //   .collection("Sessions")
              //   .doc(vm.sessionId)
              //   .collection("BreakoutRooms")
              //   .doc(room.RoomId)
              //   .update(room)
              //   .then(function () {
              //     vm.$refs.breakoutRoomRef.onCreateBreakoutRoomSuccess(
              //       room.RoomId
              //     );
              //   })
              //   .catch(function (error) {
              //     console.error("Error updating room: ", error);
              //     vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
              //       "Error on updating room."
              //     );
              //   });
            } else {
              room.IsPublished = false;
              room.RoomId = new Date().getTime().toString();
              room.CreatedDate = new Date().getTime();
              room.CreatedBy = vm.uid;
              room.Occupied = 0;
              // db.collection(vm.event_collectionName)
              //   .doc("SessionList")
              //   .collection("Sessions")
              //   .doc(vm.sessionId)
              //   .collection("BreakoutRooms")
              //   .doc(room.RoomId)
              //   .set(room)
              //   .then(function () {
              //     vm.$refs.breakoutRoomRef.onCreateBreakoutRoomSuccess();
              //   })
              //   .catch(function (error) {
              //     alert("Error : " + room.RoomId);
              //     vm.breakoutRooms = vm.breakoutRooms.filter(function (item) {
              //       if (item.RoomId != room.RoomId) {
              //         return true;
              //       }
              //     });
              //     console.error("Error creating room: ", error);
              //     vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
              //       "Error on creating room."
              //     );
              //   });
            }
            let headers = {
              "content-type": "application/json",
              Authorization: "Bearer " + vm.getSessionToken(),
            };
            let requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: vm.clientId,
                eventId: vm.eventId,
              },
              data: room,
            };
            axios
              .post(APIs.createBreakoutRoom, requestData, {
                headers: headers,
              })
              .then((responseData) => {
                console.log(responseData);
                if (
                  responseData &&
                  responseData.data &&
                  responseData.data.status == 200
                ) {
                  if (flag) {
                    vm.$refs.breakoutRoomRef.onCreateBreakoutRoomSuccess(
                      room.RoomId
                    );
                  } else {
                    vm.$refs.breakoutRoomRef.onCreateBreakoutRoomSuccess();
                  }
                } else {
                  if (flag) {
                    vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
                      "Error on updating room."
                    );
                  } else {
                    vm.breakoutRooms = vm.breakoutRooms.filter(function (item) {
                      if (item.RoomId != room.RoomId) {
                        return true;
                      }
                    });
                    vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
                      "Error on creating room."
                    );
                  }
                }
                // if (
                //   responseData &&
                //   responseData.data &&
                //   responseData.data.status == 0 &&
                //   responseData.data.sessions
                // ) {
                //   responseData.data.sessions.map(function (item) {
                //     vm.mySessions.push(item.SessionId);
                //   });
                // }
                // vm.mySessionsLoaded = true;
              })
              .catch((error) => {
                if (flag) {
                  console.error("Error updating room: ", error);
                  vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
                    "Error on updating room."
                  );
                } else {
                  console.error("Error creating room: ", error);

                  vm.breakoutRooms = vm.breakoutRooms.filter(function (item) {
                    if (item.RoomId != room.RoomId) {
                      return true;
                    }
                  });
                  vm.$refs.breakoutRoomRef.onCreateBreakoutRoomError(
                    "Error on creating room."
                  );
                }
              });
          }
        }
      }
    },

    updateRoomStatus(room) {
      if (room && room.RoomId) {
        debugger;
        // var roomId = room.RoomId;
        // let room = vm.breakoutRooms.filter(function (item) {
        //   if (item.RoomId == roomId) {
        //     return true;
        //   }
        // });
        // if (room.length > 0) {
        //   alert("");
        //   room[0].IsPublished = !room.IsPublished;
        // }
        // db.collection(vm.event_collectionName)
        //   .doc("SessionList")
        //   .collection("Sessions")
        //   .doc(vm.sessionId)
        //   .collection("BreakoutRooms")
        //   .doc(room.RoomId)
        //   .update({ IsPublished: room.IsPublished })
        //   .then(function () {
        //     vm.$refs.breakoutRoomRef.onUpdateRoomStatusSuccess(
        //       room.Name,
        //       room.IsPublished
        //     );
        //     //debugger;
        //     // let room = vm.breakoutRooms.filter(function (item) {
        //     //   if (item.RoomId == room.RoomId) {
        //     //     return true;
        //     //   }
        //     // });
        //     // if (room.length > 0) {
        //     //   alert("")
        //     //   room[0].IsPublished = !room.IsPublished;
        //     // }
        //   })
        //   .catch(function (error) {
        //     // let room = vm.breakoutRooms.filter(function (item) {
        //     //   if (item.RoomId == room.RoomId) {
        //     //     return true;
        //     //   }
        //     // });
        //     // if (room.length > 0) {
        //     //   room[0].IsPublished = !room.IsPublished;
        //     // }
        //     console.error("Error updating room: ", error);
        //     vm.$refs.breakoutRoomRef.onUpdateRoomStatusError(
        //       room.RoomId,
        //       "Error on updating room."
        //     );
        //   });
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
          },
          data: {
            RoomId: room.RoomId,
            //SessionId: room.SessionId,
            IsPublished: room.IsPublished,
            LastModifiedDate: new Date().getTime(),
            LastModifiedBy: vm.uid,
          },
        };
        if (vm.sessionTypeId == vm.LivePanelTypeID) {
          requestData.data.SessionId = room.SessionId;
        } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          requestData.data.TableId = room.TableId;
        }
        axios
          .post(APIs.updateBreakoutRoomStatus, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            console.log(responseData);
            if (
              responseData &&
              responseData.data &&
              responseData.data.status == 200
            ) {
              vm.$refs.breakoutRoomRef.onUpdateRoomStatusSuccess(
                room.RoomId,
                room.Name,
                room.IsPublished
              );
            } else {
              vm.$refs.breakoutRoomRef.onUpdateRoomStatusError(
                room.RoomId,
                "Error on updating room status."
              );
            }
            // if (
            //   responseData &&
            //   responseData.data &&
            //   responseData.data.status == 0 &&
            //   responseData.data.sessions
            // ) {
            //   responseData.data.sessions.map(function (item) {
            //     vm.mySessions.push(item.SessionId);
            //   });
            // }
            // vm.mySessionsLoaded = true;
          })
          .catch((error) => {
            console.error("Error updating room status: ", error);
            vm.$refs.breakoutRoomRef.onUpdateRoomStatusError(
              room.RoomId,
              "Error on updating room status."
            );
          });
      }
    },
    joinBreakoutRoom(breakoutRoomId, breakoutRoomName) {
      //alert(roomId);
      vm.isBreakoutRoomPanelOpend = false;
      this.$emit("joinBreakoutRoom", breakoutRoomId, breakoutRoomName);
    },
    leaveBreakoutRoom(breakoutRoomId) {
      if (vm.breakoutRoomId == breakoutRoomId) {
        // var room = vm.breakoutRooms.filter(function (item) {
        //   if (item.RoomId == vm.breakoutRoomId) {
        //     return true;
        //   }
        // });
        // if (room.length > 0) {
        vm.roomClosing = true;
        // this.showSnackbar(
        //   "The Breakout Room will close in 60 seconds. You will be returned to the main session automatically",
        //   "info",
        //   "top"
        // );
        vm.roomNotificationText = vm.roomClosingTemplate.replace(
          "{{timeLeft}}",
          vm.roomClosingTime.toString()
        );
        var timeSpent = 0;
        roomClosingInterval = setInterval(function () {
          timeSpent++;
          vm.roomNotificationText = vm.roomClosingTemplate.replace(
            "{{timeLeft}}",
            (vm.roomClosingTime - timeSpent).toString()
          );
          if (timeSpent >= vm.roomClosingTime) {
            clearInterval(roomClosingInterval);
            roomClosingInterval = null;
            vm.roomClosing = false;
          }
        }, 1000);

        setTimeout(() => {
          if (vm.breakoutRoomId == breakoutRoomId) {
            vm.roomClosing = false;
            this.$emit("leaveBreakoutRoom");
            this.showSnackbar(
              "You are returning to the main session.",
              "info",
              "top"
            );
          }
        }, vm.roomClosingTime * 1000);
        // }
      }
    },
    leaveBreakoutRoomNow() {
      vm.roomClosing = false;
      this.$emit("leaveBreakoutRoom");
      this.showSnackbar(
        "You are returning to the main session.",
        "info",
        "top"
      );
    },
  },
};
</script>

<style scoped>
.on-demand-session-option {
  position: relative;
}
.on-demand-session-option p {
  margin: 0 0 0 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  padding: 0 4px;
}
.on-demand-session-option p span {
  height: 6px;
  width: 6px;
  background: #fff;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
  margin: 2px;
}
.on-demand-dropdown {
  position: absolute;
  right: 4px;
  bottom: 100%;
  min-width: 169px;
  background: #fff;
  min-height: 41px;
  padding: 0 15px;
  border-radius: 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  z-index: 999999;
  margin-bottom: 12px;
}
.on-demand-dropdown ul {
  margin: 0;
  padding: 0;
}
.on-demand-dropdown ul li {
  list-style: none;
  font-size: 0.875rem;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
  font-weight: 400;
  cursor: pointer;
}
.on-demand-dropdown ul li:last-child {
  border-bottom: none;
}
</style>